import requests from "./requests.en";
import reviewChecks from "./reviewChecks.en";
import agentic from "./agentic.en";
import decisionControls from "./decisionControls.en";
import stepLetters from "./stepLetters.en";
import processes from "./processes.en";

export default {
  requests,
  reviewChecks,
  agentic,
  decisionControls,
  stepLetters,
  processes,
  // Case records after the AA-01 fact-check (group G5): fees after the gateway's first answer, meeting records and the parties' review of the
  // minutes, the Article 4 jurisdiction findings, the exemption's period of validity and early end, and the commitments register's open terms.
  caseRecords: {
    fees: {
      title: "Fees",
      hint: "Each fee with what the payment gateway said when it was last asked. A fee reversed or charged back is no longer received; a refund reads as refunded once its transfer is confirmed.",
      none: "No fee is recorded on this file.",
      receipt: "Receipt {{receipt}}",
      gatewayChecked: "Gateway last asked on {{date}}: {{status}}",
      reversed: "Reversed on {{date}}",
      refundRequested: "Refund instructed on {{date}}",
      refunded: "Refunded on {{date}} · reference {{reference}}",
      recheck: "Re-check with the gateway",
      recheckDone: "The gateway was asked again",
      changes: { None: "No change", Reversed: "The payment was reversed", RefundConfirmed: "The refund is confirmed" },
      recordReversal: "Record a reversal",
      reversalTitle: "Record a reversal or chargeback",
      reversalHint: "When the finance unit reports that a paid fee was taken back – a chargeback, a returned transfer. The fee step opens again until the fee is paid.",
      reason: "Reason",
      confirmRefund: "Confirm the refund",
      refundTitle: "Confirm the refund",
      refundHint: "From the finance record: the transfer or refund reference and the day the money went back to the payer.",
      reference: "Transfer or refund reference",
      refundedOn: "Refunded on",
      saved: "Recorded",
    },
    meetings: {
      purpose: "Purpose",
      purposeHint: "What the Department needs from the meeting (Regulations Article 14).",
      noPurpose: "No purpose recorded",
      iAttend: "I attend this meeting",
      iAttendHint: "Only an officer who attended may approve the minutes.",
      attendance: "Record my attendance",
      attendanceDone: "Your attendance is recorded",
      approvedBy: "Approved by {{name}}",
      problems: {
        NoMinutes: "No minutes yet",
        NotApproved: "Minutes not yet approved",
        ApproverUnknown: "Approved without the approver recorded",
        ApproverDidNotAttend: "Approved by an officer not recorded as attending",
      },
      partyReview: {
        title: "The party's review of the minutes",
        hint: "The parties heard may read and sign the minutes (Regulations Article 23(5)–(6)). Record whether they signed, signed with reservations or refused to sign.",
        record: "Record the party's review",
        status: "Review",
        signatory: "Signed, or refused, by",
        note: "Reservations, or the reason given for refusing",
        reviewedOn: "On",
        saved: "The party's review is recorded",
        statuses: { Pending: "Awaiting the party's review", Signed: "Signed by the party", SignedWithReservations: "Signed with reservations", RefusedToSign: "The party refused to sign" },
      },
    },
    jurisdiction: {
      title: "Jurisdiction – Decree-Law Article 4",
      hint: "The exclusions of Article 4: a sector regulator's own competition rules (4(1)) and undertakings owned by the Federal Government or by an emirate's government acting in that emirate, as a resolution determines (4(2)–(3)). The review passes the complaint as within jurisdiction only once each is answered.",
      regulators: "Sector regulators for the complaint's sector",
      noRegulator: "No sector regulator's remit covers the declared sector.",
      noIsic: "The complaint carries no ISIC code.",
      stateOwned: "Shown as government-related in the Data Bank",
      regulator: "Regulator considered",
      ownRules: "Another law gives the regulator its own competition rules for this good or service",
      referred: "The regulator asked the Ministry in writing to take the matter on, and the Ministry agreed",
      ownership: "Ownership of the respondent",
      ownerships: { None: "Not government-owned", Federal: "Owned by the Federal Government", Emirate: "Owned by an emirate's government" },
      designated: "Determined by a Cabinet or local-government resolution",
      withinEmirate: "Carries out the activity concerned in that emirate",
      resolution: "Resolution",
      note: "Note",
      answer: { unknown: "Not yet answered", yes: "Yes", no: "No" },
      save: "Record the findings",
      saved: "The findings are recorded",
    },
    exemption: {
      validity: "Period of validity",
      validityMissing: "The period of validity is not recorded: an amendment cannot be filed until it is.",
      validFrom: "In force from",
      validUntil: "Expires on",
      source: "Taken from",
      recordValidity: "Record the period from the decision",
      validityHint: "The period the signed decision states (Regulations Article 9(1)) – never the agreement's own term.",
      endedEarly: "Ended early on {{date}}",
      recordEarlyEnd: "Record a cancellation or early end",
      earlyEndHint: "An exemption is cancelled where the circumstances no longer exist, its conditions are not fulfilled or the information supplied was misleading (Decree-Law Article 10); it also ends with the agreement.",
      kind: "How it ended",
      kinds: { Revoked: "Cancelled by the Ministry", Terminated: "The agreement was terminated" },
      ground: "Ground (Decree-Law Article 10)",
      grounds: { CircumstancesChanged: "The circumstances no longer exist", ConditionsNotFulfilled: "The conditions are not fulfilled", MisleadingInformation: "The information supplied was misleading" },
      endedOn: "Ended on",
      note: "The cancelling decision, or the parties' notice",
      saved: "Recorded",
      notInForce: "Not in force",
    },
    commitments: {
      toConfirm: "To confirm",
      terms: { Obligor: "Obligor", Kind: "Kind", DueOn: "Due date", VerificationMethod: "Verification", Wording: "Signed wording" },
      confirm: "Confirm the terms",
      confirmHint: "Terms the signed decision does not state, or that the register read from its wording: confirm them, or record the day the condition's trigger happened.",
      obligor: "Obligor",
      kind: "Kind",
      verification: "Verification method",
      triggerOn: "The day of the {{trigger}}",
      dueOn: "Due date",
      owner: "Owner",
      confirmWording: "Register the condition in its signed wording",
      signed: "As signed",
      runsFrom: "Due {{period}} after the {{trigger}}",
      triggers: { Decision: "decision", Completion: "completion", Implementation: "implementation", Notification: "notification" },
      months_one: "{{count}} month",
      months_other: "{{count}} months",
      days_one: "{{count}} day",
      days_other: "{{count}} days",
      saved: "The terms are confirmed",
    },
    commitmentAlerts: {
      overdue: "Overdue since {{date}}",
      breached: "Breached",
      implementationDate: "Implementation date {{date}}",
      with: "With {{level}}",
      levels: { Owner: "the owner", Director: "the Director", AssistantUndersecretary: "the Assistant Under-Secretary" },
      evidence: "Evidence on record when the alert was raised",
      lastVerified: "Last verified {{date}}",
      noVerification: "No verification is recorded",
      measured: "Last measured {{value}} on {{date}} against a target of {{target}}",
      noMeasurement: "No measurement against the target is recorded",
      documents: "On file",
      noDocuments: "No monitoring report or document is filed",
      history: "Escalation",
      automatic: "by the register",
      escalate: "Escalate to {{level}}",
      escalateTitle: "Escalate commitment {{n}} to {{level}}",
      escalateHint: "The escalation is recorded on the file with your name, the time and your reasons; a task and a notice go to {{level}}.",
      reason: "Reasons",
      escalated: "Escalated to {{level}}",
    },
    /** After the decision (scenario 6.44): the undertaking's compliance reports and their review, a status step with reasons, the waiver and the enforcement file. */
    commitmentLifecycle: {
      reports: "Compliance reports from the undertaking",
      evidence: "Evidence",
      review: "Review the report",
      reviewTitle: "Review the compliance report on commitment {{n}}",
      outcome: "Outcome",
      outcomes: { Accepted: "Compliance shown", Insufficient: "More is needed" },
      reviewNote: "What the review found",
      recordReview: "Record the review",
      reviewed: "Review recorded",
      awaitingReview: "Awaiting review",
      stepTitle: "Record commitment {{n}} as {{status}}",
      stepHint: "A breach and a reopening are recorded with your reasons, your name and the time in the file's history.",
      waive: "Waive",
      waiveTitle: "Waive commitment {{n}}",
      waiveHint: "The waiver is recorded with your reasons, the legal basis, your name and the time; the undertaking sees it on its file, and the commitment leaves the alerts.",
      legalBasis: "Legal basis",
      legalBasisHint: "The provision or the decision that allows the waiver.",
      legalBasisAr: "Legal basis in Arabic (optional)",
      waived: "Commitment waived",
      waivedBy: "Waived by {{by}} on {{date}}:",
      openEnforcement: "Open an enforcement file",
      enforcementTitle: "Open an enforcement file on the breach of commitment {{n}}",
      enforcementHint: "An ex officio file for implementing the concentration in breach of the decision (Article 26), opened by your recorded decision. It carries the evidence on record – the alert, the last verification and measurement, the compliance reports and the documents – and is linked to this file.",
      enforcementOpened: "Enforcement file {{number}} opened",
      enforcementFile: "Enforcement file {{number}}",
    },
  },
  /** Uploading a filing document in the back office (6.12, 6.13): the reason a file is refused, and the "Translation of" choice. */
  filingUploads: {
    notUploaded: "File not uploaded",
    legacyWord: "{{name}} is a Word 97–2003 document (.doc). The platform cannot read this older format, so nothing in it could be read or checked. Save it as a Word document (.docx) or as a PDF and upload it again.",
    legacyOffice: "{{name}} is an older Excel or PowerPoint file (97–2003) that the platform cannot read. Save it in the current format (.xlsx or .pptx) or as a PDF and upload it again.",
    refused: "{{name}} was not uploaded: this type of file is not accepted here. Upload a PDF, a Word document (.docx), an Excel workbook (.xlsx), a text or CSV file, or an image (PNG or JPEG).",
    tooLarge: "{{name}} was not uploaded: it is larger than the size accepted here.",
    translationOf: "Translation of",
    notATranslation: "Not a translation – an original document",
    translationHint: "If this file translates a document already on the file, choose the original: the two are compared once both are read, the differences are marked, and a party document's discrepancy is referred to you.",
    linked: "Filed as a translation",
    unlinked: "Filed as an original document",
  },
  /** The structure of a concentration: its type recorded with reasons (6.10) and a joint venture's parents (6.9); theories from the figures (5.2). */
  concentrationStructure: {
    typeTitle: "Type of concentration",
    typeHint: "Record the type of each market and of the file with your reasons. The platform pre-fills it from the figures – horizontal only where both parties are active – and flags the applicant's labels the figures contradict. The review report's §3 states your classification.",
    types: { Horizontal: "Horizontal", Vertical: "Vertical", Conglomerate: "Conglomerate", None: "No overlap", none: "Not determined" },
    applicantLabel: "Applicant: {{type}}",
    bothActive: "Both parties active",
    notBothActive: "Parties not both active",
    conflict: "Contradicted by the figures",
    type: "Type",
    fileType: "Type of the concentration",
    reasons: "Your reasons",
    fileReasons: "Your reasons for the type of the concentration",
    reasonsHint: "A sentence at least: a type picked from a list is not a classification.",
    choose: "Choose…",
    save: "Record the classification",
    saved: "Classification recorded",
    notSaved: "Classification not recorded",
    recorded: "{{type}} · {{name}} · {{date}}",
    incomplete: "Recorded, incomplete",
    notRecorded: "Not yet recorded",
    departs: "Your classification departs from the figures in {{markets}}: your reasons must answer them.",
    jvTitle: "Joint venture and its parent companies",
    fullFunction: "Full-function",
    notFullFunction: "Not full-function",
    jointControl: "Joint control",
    controlUnclear: "Control not established",
    notFiled: "Structure not filed",
    spillOver_one: "{{count}} market where two or more parents remain active",
    spillOver_other: "{{count}} markets where two or more parents remain active",
    noSpillOver: "No market where two parents remain active",
    parent: "Parent",
    stake: "Stake",
    controlRights: "Control rights",
    activities: "Activities",
    noOtherActivity: "None declared",
    rights: { BoardMajority: "Board majority", VetoStrategic: "Veto over strategic decisions", CastingVote: "Casting vote", ManagementContract: "Management contract", OptionToAcquireControl: "Option to acquire control", MinorityProtectionOnly: "Minority protection only" },
    relations: { Same: "joint venture's market", Upstream: "upstream", Downstream: "downstream", Neighbouring: "neighbouring" },
    marketsAtRisk: "Coordination between the parents to assess",
    together: "together {{share}}",
    missing: "Not on the form: {{items}}.",
    jvCriterion: "The review criterion \"Coordination between the parents assessed\" binds this file: the review report's coordinated-effects passage must assess each market listed.",
    noTheoryOnFigures: "The current figures support no theory of harm.",
  },
  r3Metrics: {
    notRecorded: "Not recorded",
    none: "None",
    inputs: "Rests on",
    methodVersion: "Calculation method {{version}}",
    aboutFigure: "About {{name}}",
    measures: {
      hhi: "Herfindahl-Hirschman Index (HHI)",
      deltaHhi: "Change in HHI",
      crN: "Concentration ratio",
      combinedShare: "Combined share",
      unallocatedShare: "Unallocated share",
      riskScore: "Structural risk score",
      guppi: "Upward pricing pressure (GUPPI)",
      cmcr: "Compensating marginal-cost reduction (CMCR)",
      criticalLoss: "Critical loss",
      assumedMargin: "Assumed gross margin",
      turnoverGroup: "Worldwide group turnover",
      turnoverState: "Turnover in the State",
      turnoverMarket: "Turnover in the relevant market",
      shareStatus: "Share status",
      completeness: "File completeness",
      efficiencyCredit: "Credited efficiencies",
      dealScreeningScore: "Deal screening score",
      marketScreeningScore: "Market screening score",
      marketSignalScore: "Data Bank signal score",
      draftQuality: "AI check (second reading of a draft)",
      figureCheck: "Figure status and check",
      criterionConfidence: "Confidence of the platform's reading",
      draftConfidence: "Confidence of an agent's draft",
      fileRiskScore: "Risk score of a file outside merger control",
      triagePriority: "Triage priority (complaints and infringement reports)",
      article9Score: "Article 9 compliance score (exemptions and amendments)",
      filingReadiness: "Filing readiness score",
      penaltyIndication: "Fine range and indicative settlement (enforcement)",
      assistantConfidence: "Confidence of the legal assistant's answer",
      dataBankConfidence: "Confidence of a Data Bank figure",
      mergerSimulation: "Merger simulation (price effect)",
      localCatchment: "Local catchment",
      marketStudyAnalyses: "Analyses of a market study",
      operationalStatistics: "Operational statistics",
    },
    figureStatus: { Declared: "Declared by the applicant", Entered: "Entered by an officer", Calculated: "Calculated", Extracted: "Read from a document", NotRecorded: "Not recorded" },
    figureDeclaredBy: { applicant: "Declared by the applicant", complainant: "Declared by the complainant", parties: "Declared by the parties" },
    figureCheck: {
      notIndependent: "Not checked against an independent source",
      unchecked: "Unchecked",
      inputsUnchecked: "Calculated from unchecked figures – check them first: {{inputs}}",
      page: "page {{page}}",
      check: "Check against source",
      checkedBy: "Checked by {{name}} on {{date}}",
      recorded: "source recorded {{date}}",
      title: "Check this figure against its source",
      hint: "A calculated or extracted figure is not quoted in an approved report, decision or letter until an officer checks it. Say which source you checked it against and what it gives. A check is not a verification: only a source independent of the applicant verifies a figure.",
      note: "How you checked it",
      confirm: "Record the check",
      saved: "Check recorded",
    },
    asFiled: "As filed",
    hhiPre: "HHI before",
    hhiPost: "HHI after",
    crPre: "CR{{n}} before",
    turnoverGroup: "Group turnover (worldwide)",
    turnoverState: "Turnover in the State",
    turnoverMarket: "Turnover in this market",
    partiesShareHighest: "Parties' share (highest market)",
    partiesShare: "Parties' share",
    competitorsIdentified: "Competitors identified",
    noOverlap: "No overlap",
    noOverlapAnywhere: "The parties are not both active in any market",
    mostAffected: "Most affected market",
    concentrationTitle: "Concentration",
    deltaHhi: "Change in HHI",
    crPost: "CR{{n}} after",
    hhiAfter: "HHI after",
    hhiShort: "HHI",
    unallocated: "Unallocated share",
    identifiedFirms_one: "{{count}} identified firm",
    identifiedFirms_other: "{{count}} identified firms",
    unallocatedLeftOut: "{{share}} unallocated, left out of the index",
    lowerBound: "Lower bound: {{share}} of the market is unallocated. Were it one firm, HHI after would be {{max}}.",
    sharesDoNotAddUp: "Shares add up to {{total}}, not 100%. Used as declared.",
    sharesAndSources: "Declared shares and independent sources",
    declaredCombined: "Declared combined share",
    declaredPartiesShare: "Declared parties' share",
    independentCombined: "Independent sources",
    declaredShare: "Declared",
    independentShare: "Independent source",
    difference: "Difference (points)",
    applicantFiling: "Applicant's filing only",
    notOneUndertaking: "Not one undertaking",
    shareStatus: { Confirmed: "Confirmed", Discrepancy: "Discrepancy", Declared: "Declared by the applicant – unchecked", Unallocated: "Unallocated", SourceOnly: "Independent source only" },
    independentSources: "Independent sources",
    noIndependentSource: "No source independent of the applicant covers this market.",
    records_one: "{{count}} record",
    records_other: "{{count}} records",
    riskScore: "Structural risk score",
    scoreRestsOn: "Rests on the most affected market: {{market}}",
    verticalLink: "Vertical link declared",
    dominanceAbove: "Dominance is deemed above {{share}}%.",
    quantitativeTests: "Quantitative tests",
    horizontalNotApplicable: "Not applicable: the parties are not both active in this market.",
    guppiOn: "GUPPI on {{party}} products",
    cmcrOn: "CMCR on {{party}} products",
    criticalLoss: "Critical loss",
    notDecided: "not decided",
    marginLabel: "Gross margin",
    assumedMargin: "Assumed – not supplied by the parties",
    margin: "Margin {{margin}}",
    priceRise: "Price rise",
    scenariosNotApplicable: "Not applicable: the parties are not both active in this market, so there is no overlap to divest.",
    scenarioBaseline: "Baseline: notified pre-merger HHI {{hhi}}",
    changeFromNotified: "Change from baseline",
    calculateDivestiture: "Calculate this divestiture",
    covered: "Identified firms cover {{share}}",
    declaredByApplicant: "Declared by the applicant",
    efficienciesTitle_one: "Efficiencies test · {{count}} claim",
    efficienciesTitle_other: "Efficiencies test · {{count}} claims",
    verdicts: { Yes: "Yes", Partial: "Partial", No: "No", NotVerified: "Not verified" },
    countsZero: "Counts zero",
    recordVerified: "Record as verified",
    withdrawVerification: "Withdraw verification",
    verifiedAgainst: "Verified against (document, page)",
    preDealSource: "Pre-deal estimate in (board paper or internal estimate, date, page)",
    preDealPercent: "Pre-deal saving, % of marginal cost",
    preDealAed: "Pre-deal saving, AED a year",
    preDealHint: "The saving as the parties estimated it in the ordinary course before the deal. A figure prepared for the filing alone is not verified, and the credit never exceeds the pre-deal figure.",
    preDealRecorded: "Compared with the pre-deal estimate in {{source}}",
    assessSpecific: "Assess merger-specificity",
    specificityReasons: "Which less restrictive route was weighed, and why it would or would not deliver the saving",
    confirmSpecific: "Merger-specific",
    rejectSpecific: "Not merger-specific",
    withdrawSpecific: "Withdraw finding",
    proposedByAgent: "Proposed by {{agent}} · {{date}} · not yet approved",
    determinedByOfficer: "Determined by {{name}} · {{date}}",
    openFindings_one: "{{count}} open finding",
    openFindings_other: "{{count}} open findings",
    harmStructural: "Structural screen: post-transaction HHI {{post}} ({{band}}) with a change of {{delta}} is above the marks of the published method; a detailed analysis of the effects on competition is warranted.",
    harmUnilateral: "Unilateral effects: the combined share of {{share}}% is above the {{mark}}% at which dominance is deemed to exist.",
    supersededDraft: "Earlier agent draft (before calculation method 1.0)",
    supersededDraftNote: "Its figures are superseded by the figures above, calculated under the published method.",
    reportBeforeMethod: "Drafted before calculation method 1.0",
    reportBeforeMethodNote: "Its figures may differ from the current analysis. A new draft is needed before the file goes further.",
  },
  login: {
    title: "Sign in",
    subtitle: "Staff access is restricted to the Ministry's federal network.",
    sessionNote: "Every session needs your password and an authenticator code. Sessions end after 30 minutes without activity and after 10 hours at most.",
    rightNow: "Right now",
    agents: {
      triage: { name: "Triage Agent", activity: "is triaging a new concentration notification" },
      market: { name: "Market Definition & Concentration Agent", activity: "is measuring concentration in the ready-mix cement market" },
      citations: { name: "Citation Verifier", activity: "is checking every citation against Federal Decree-Law No. 36 of 2023" },
      sla: { name: "SLA Sentinel", activity: "is watching the statutory clock on every open case" },
      correspondence: { name: "Correspondence Agent", activity: "is drafting a bilingual deficiency letter for signature" },
      intake: { name: "Complaint Intake Assistant", activity: "is screening an anonymous whistleblowing report" },
      brief: { name: "Decision Brief Writer", activity: "is preparing a decision brief for the Minister" },
    },
  },
  risk: { level: { High: "High", Medium: "Medium", Low: "Low" }, score: "Risk score {{score}} out of 100", notAssessed: "Not yet assessed", namedScore: "{{name}}: {{score}} out of 100" },
  commandCenter: {
    notScored: "Not scored yet",
    showAll: "Show all {{count}}",
    showFewer: "Show fewer",
    otherSteps: "Other steps ({{count}})",
    andMore: "And {{count}} more",
    openRegister: "Open the register",
    myWork: "My work",
    myFiles: "My files",
    noFiles: "No open files are assigned to you.",
    awaitingDecision: "Awaiting my decision",
    nothingAwaiting: "Nothing awaits your decision.",
    approaching: "Approaching deadlines",
    nothingApproaching: "No deadline falls in the next five days.",
    workload: "Workload",
    workloadOpen: "Open files",
    unassignedAlert: "High-priority files with no officer assigned: {{count}}",
    assign: "Assign",
    pipeline: "Requests pipeline",
    agentColumns: { agent: "Agent", runs: "Runs", accepted: "Accepted" },
    ministerDecisions: "Minister decisions",
    proposalDecisions: "Human decisions on AI proposals",
    pendingProposals: "AI proposals waiting",
    watchlistColumns: { case: "Case", stage: "Stage", deadline: "Deadline", risk: "Risk" },
    title: "Home",
    subtitle: "Live view of the Competition Department's caseload, statutory clocks and AI assistance.",
    kpis: "Key performance indicators",
    funnel: "Case funnel",
    slaHeatmap: "Statutory deadline heatmap",
    aiAssist: "AI assistance",
    watchlist: "Merger files",
    proposalsApproved: "Proposals approved",
    proposalsEdited: "Edited before approval",
    proposalsRejected: "Rejected",
    hoursSaved: "Estimated officer hours saved",
    target: "Target",
    refreshed: "Refreshed",
    openCases: "Open cases",
    onTarget: "On target",
    offTarget: "Off target",
    kpi: {
      ecFormalReviewDays: "EC initial review (days)",
      ecDecisionDays: "EC submission → decision (days)",
      complaintResolutionDays: "Complaint resolution (days)",
      slaCompliance: "Statutory deadlines met",
      aiAcceptance: "AI drafts accepted",
      hoursSaved: "Officer hours saved",
      unnotifiedCandidates: "Unnotified concentration candidates",
    },
    dealWatchNew: "{{count}} new since yesterday",
    dealWatchOpen: "Open Deal Watch",
    newsOpen: "Open News",
    newsToday: "{{count}} published today",
    funnelHint: "Economic concentrations that reached each stage of the statutory procedure.",
    intake: "Submissions per week",
    intakeHint: "Submissions per week by service.",
    aiAssistHint: "Human decisions on AI proposals, Minister decisions and runs per agent.",
    runs: "runs",
    slaHeatmapHint: "Statutory clocks by kind and health across all visible cases.",
    health: { OnTrack: "On track", AtRisk: "At risk", Breached: "Breached", Paused: "Paused", CompletedOnTime: "On time", CompletedLate: "Late" },
    watchlistHint: "Open cases ranked by concentration risk and nearest statutory deadline.",
    recentActivity: "Recent activity",
    liveAgents: "Agent activity",
    liveAgentsHint: "Live stream of agent reasoning steps, retrievals, tool calls and guardrails.",
    liveAgentsIdle: "No agent is running right now. Steps appear here in real time when an agent works on a case.",
    recentRuns: "Recent runs",
    decisions: "Decisions",
    methodology: "Methodology: KPIs are computed from the workflow journal and statutory clocks of the cases visible to you; hours saved are estimated at {{hours}} officer hours per accepted AI draft. Targets follow the RFP service levels, as the published calculation method states them.",
    nearestFirst: "Nearest deadline first",
    watchlistOrder: "Open files · nearest deadline first",
    byStage: "Merger files by stage",
    byStageMeta: "Files at each stage today",
    workloadAtRisk: "Near the deadline",
    workloadPast: "Past the deadline",
  },
  inbox: {
    focused: "Showing the proposal you followed a link to.",
    showAll: "Show the whole inbox",
    focusMissing: "This proposal isn't available to you, or no longer exists.",
    avgEditDistance: "avg edit distance {{value}}%",
    activityHint: "Select a proposal's agent activity to watch how the draft was produced: retrievals, tool calls, guardrails.",
    title: "AI Inbox",
    subtitle: "Every AI proposal waits here for a human decision. Nothing is sent or changed until you approve it.",
    empty: "No proposals waiting. The agents will notify you when new drafts are ready.",
    filterAgent: "Agent",
    filterType: "Case type",
    filterUrgency: "Urgency",
    reviewNote: "Review note (optional)",
    diffTitle: "Your edits vs. AI draft",
  },
  cases: {
    title: "Cases",
    registers: "Registers",
    ecRegister: "Economic concentration register",
    complaintsRegister: "Competition complaints register",
    exemptionsRegister: "Exemption applications",
    appeals: "Grievances",
    whistleblowing: "Whistleblowing & market signals",
    legalEnquiries: "Legal enquiries",
    columns: {
      number: "Case",
      title: "Title",
      state: "Stage",
      assignee: "Officer",
      clock: "Deadline",
      risk: "Risk",
      proposals: "AI",
      updated: "Updated",
    stage: "Stage",
    period: "Statutory period",
    lastChange: "Last change",
  },
    noPeriod: "No running period",
    order: "Nearest deadline first, then newest",
    pausedBy: "Paused by {{name}}",
    unattended: "No officer · period running",
  },
  sections: {
    ec: { requests: "Requests", screening: "Intake screening", screeningPurpose: "Filings the control test flagged as possibly not notifiable: confirm and return them, or admit them to the initial review." },
    investigations: { register: "Complaints register" },
  },
  parallelRun: {
    title: "Parallel run",
    hint: "Condition 1.10: before adoption the platform runs alongside the Department's ordinary process. The officers' own conclusion on each point is recorded beside the platform's result, and the head of section decides every divergence. The file is a test file, so nothing the platform does on it reaches the parties.",
    liveFile: "Not a test file",
    liveFileHint: "This file is live: what the platform does on it reaches the parties. A file joins the parallel run only once the Director has marked it as a test file.",
    platform: "What the platform finds now",
    platformResult: "The platform",
    officers: "The officers' own result",
    points: "Points compared",
    noPoints: "No point has been compared yet.",
    record: "Record the officers' result on a point",
    point: "Point",
    customPoint: "Another point the officers name",
    customLabel: "The point",
    customPlatform: "What the platform shows on it",
    source: "Where the officers' result is recorded",
    sourceHint: "The memo, register entry or note of the Department's ordinary process.",
    recordAction: "Record and compare",
    recordedAgree: "Recorded: the officers' result and the platform's agree.",
    recordedDivergent: "Recorded: the results differ, and the divergence goes to the head of section.",
    agree: "Agree",
    measure: "Time taken",
    divergent: "Divergence – for the head of section",
    decide: "Decide the divergence",
    redecide: "Decide again",
    decided: "Decision recorded.",
    decidedBy: "Decided by {{name}}",
    ruling: "Whose result is right",
    rulings: { Platform: "The platform's", Officers: "The officers'", Both: "Both are acceptable", Neither: "Neither" },
    severity: "Seriousness of the platform's error",
    severityHint: "Critical, major or minor as condition 1.7 defines them; a critical divergence keeps the section from adoption.",
    severities: { Critical: "Critical", Major: "Major", Minor: "Minor" },
    reasons: "Reasons",
    rereadAction: "Read the platform's result again",
    reread: "The platform's result was read again.",
    none: "No result yet",
    notifiable: { Yes: "Notifiable", No: "Not notifiable", Pending: "Pending: figures missing" },
    register: {
      title: "Parallel run before adoption",
      hint: "Condition 1.10: at least eight weeks and fifteen real files (or every file received in that time), with no effect on the parties. Adoption follows only if the platform's accuracy is at least equal to the officers', no critical divergence remains, and the time or depth of analysis has improved.",
      empty: "No file is in the parallel run yet. It starts with the first point recorded on a test file.",
      weeks: "Weeks",
      files: "Files",
      platformAccuracy: "Platform's accuracy",
      officersAccuracy: "Officers' accuracy",
      platformDays: "Platform's median time",
      officersDays: "Officers' median time",
      unmet: "What adoption still lacks",
      met: "The run meets the conditions it can measure",
      metHint: "Adoption remains the Department's decision, with the head of section's assessment of the depth of analysis.",
      file: "File",
      points: "Points",
      divergences: "Divergences",
      undecided: "Awaiting decision",
      critical: "Critical remaining",
      since: "In the run since",
    },
  },
  statistics: {
    dataChecks: {
      title: "{{count}} files whose own data would distort these figures", title_one: "{{count}} file whose own data would distort these figures",
      hint: "Check each file before relying on the figures it reaches. A time that cannot be right is left out of its average until the file is corrected.",
      leftOut: "left out until corrected",
      figures: { decisionOutcomes: "Decisions by outcome" },
    },
    sourcesHint: "Figures the platform records are computed from the case files; figures it does not record (budget, staff, dawn raids, court appeals, private claims, international cooperation, events) are entered by the Department. An entered figure replaces the computed one and both are kept. Percentages are derived from the figures shown.",
    from: "From",
    to: "To",
    questionnairePeriod: "Questionnaire period",
    export: "Export OECD tables",
    year: "Year",
    texts: {
      sectors: "Sectors", otherMeans: "Other means (which ones)", withdrawalReasons: "Reasons for withdrawal (7.4)", turnoverReasons: "Reasons to join and leave",
      cooperationAuthorities: "Authorities and cases", refusalReasons: "Why benefits were refused (8.3)", rejectionReasons: "Main reasons for rejection",
      exOfficioSources: "Main own-initiative sources", claimTypes: "Types of claims and outcomes",
    },
    value: "Figure",
    note: "Note or source",
    clear: "Use the computed figure",
    saved: "Figure saved",
    computedIs: "Computed from the platform: {{value}}",
    computedWas: "computed: {{value}}",
    editHint: "Select a figure to enter or correct it",
    recordedFrom: "The platform holds files from {{year}}; earlier years come from the entered figures only",
    noDecisions: "No decisions in these years",
    tabs: { operations: "Operations", antitrust: "Antitrust enforcement", mergers: "Mergers", powers: "Enforcement powers", sanctions: "Sanctions", advocacy: "Advocacy", judicial: "Judicial review", institution: "Institution" },
    legend: { Computed: "Computed from the files", Entered: "Entered by the Department", Derived: "Derived from the figures shown", Missing: "Not recorded" },
    units: { days: "days", "%": "%", h: "h" },
    kpiBasis: {
      ecFormalReviewDays: "Average calendar days from submission to formal acceptance ({{period.ec.initialReview}} working days, extendable once).",
      ecDecisionDays: "Average calendar days from submission to the Minister's decision ({{period.ec.review}}-day statutory review period).",
      complaintResolutionDays: "Average calendar days from complaint submission to closure (target: 3 months).",
      slaCompliance: "Share of completed statutory clocks closed on or before their due date.",
      aiAcceptance: "Share of reviewed AI proposals approved as drafted or after editing.",
      hoursSaved: "Estimated at 2.5 officer hours per accepted AI draft.",
    },
    columns: {
      totalBudget: "Total budget (AED)", competitionBudget: "Competition budget (AED)", totalStaff: "Total staff", competitionStaff: "Competition staff",
      lawyers: "Lawyers", economists: "Economists", other: "Other", mergersUnit: "Economic Concentration", antitrustUnit: "Investigations", advocacyUnit: "Advocacy & studies", otherUnits: "Other units",
      joined: "Joined", left: "Left", turnoverRate: "Turnover",
      mergerCooperation: "Merger cases", antitrustCooperation: "Antitrust cases", meetings: "Meetings attended", oecdSubmissions: "OECD roundtable submissions",
      horizontalDays: "Horizontal", bidRiggingDays: "Bid rigging", verticalDays: "Vertical", abuseDays: "Abuse of dominance",
      total: "Total", complaint: "After a complaint", leniency: "After leniency", whistleblowing: "After whistleblowing", exOfficio: "Own initiative", exOfficioShare: "Own initiative share",
      fine: "Imposing a fine", noInfringement: "Closed without infringement",
      simplified: "Simplified notifications", simplifiedShare: "Share of notifications",
      notifications: "Notifications", phase1: "Cleared after the simplified review", phase1Remedies: "Simplified review, with remedies", phase2: "Cleared after the substantive review", phase2Remedies: "Substantive review, with remedies", prohibitions: "Prohibitions", withdrawn: "Withdrawn",
      reviewAverageDays: "To review end – average", reviewMaxDays: "To review end – maximum", decisionAverageDays: "Review end to decision – average", decisionMaxDays: "Review end to decision – maximum",
      averageDays: "Total – average", maxDays: "Total – maximum",
      applications: "Cases with applications", multipleApplicants: "Several applicants", benefitsGranted: "Benefits to all applicants", benefitsRefused: "Benefits refused",
      received: "Received", rejected: "Rejected", rejectionRate: "Rejection rate", rejectionsAppealed: "Rejections appealed", appealsSucceeded: "Appeals succeeded",
      cartel: "Cartels", abuse: "Abuse of dominance",
      referrals: "Referred to prosecution", charged: "Criminal charges", criminalSanctions: "Criminal sanctions",
      horizontalSettlements: "Horizontal – settlements", horizontalCommitments: "Horizontal – commitments", horizontalOther: "Horizontal – other",
      verticalSettlements: "Vertical – settlements", verticalCommitments: "Vertical – commitments", verticalOther: "Vertical – other",
      abuseSettlements: "Abuse – settlements", abuseCommitments: "Abuse – commitments", abuseOther: "Abuse – other",
      imprisonment: "Cases with imprisonment", imprisonmentAppealed: "Appealed", imprisonmentOverturned: "Overturned on appeal",
      studies: "Market studies", opinions: "Formal opinions", events: "Events organised",
      studyRecommendations: "Study recommendations", studyAdopted: "Adopted", studyAdoptionRate: "Studies – adoption", opinionRecommendations: "Opinion recommendations", opinionAdopted: "Adopted", opinionAdoptionRate: "Opinions – adoption",
      studyAverageDays: "Average duration",
      decisions: "Decisions issued", interimMeasures: "Interim measures", grievances: "Grievances", grievancesAccepted: "Grievances accepted", courtAppeals: "Court appeals", courtAppealRate: "Appeal rate",
      courtUpheld: "Upheld", courtPartial: "Partly annulled", courtAnnulled: "Annulled",
      grievanceAverageDays: "Grievance", firstInstanceDays: "First instance", appealCourtDays: "Court of appeal", cassationDays: "Cassation",
      claims: "Claims brought", followOnClaims: "Follow-on", standaloneClaims: "Standalone", claimsUpheld: "Upheld", claimsDismissed: "Dismissed",
    },
    tables: {
      q2_3_1: { title: "Budget and staff", hint: "Total budget in AED, the part dedicated to competition, total staff and staff working on competition." },
      q2_3_7: { title: "Competition staff by background and division", hint: "Staff working on competition by academic background, and by section of the Department." },
      q2_3_10: { title: "Staff turnover", hint: "Competition staff who joined and left in the year; turnover is those who left as a share of competition staff (2.3.1)." },
      q12_9: { title: "Cooperation with foreign authorities", hint: "Cases in which the Department co-operated with at least one foreign competition authority, by type (also answers 7.10 for mergers)." },
      q12_11: { title: "International fora", hint: "Meetings of the OECD, UNCTAD and ICN attended, and submissions to OECD roundtables." },
      q3_7: { title: "Average investigation duration", hint: "Average calendar days from the opening of the investigation to the final decision, by year of decision and conduct (3.7, 5.5 and 6.6)." },
      q3_8: { title: "Horizontal agreements – investigations opened", hint: "Files entering the investigation stage in the year, by how they were opened." },
      q3_9: { title: "Horizontal agreements – final decisions", hint: "Final decisions in the year: imposing a fine (including settlements) or closing without an infringement (including commitments)." },
      q4_7: { title: "Bid rigging – investigations opened", hint: "Files entering the investigation stage in the year, by how they were opened." },
      q4_8: { title: "Bid rigging – final decisions", hint: "Final decisions in the year." },
      q5_7: { title: "Vertical agreements – investigations opened", hint: "Files entering the investigation stage in the year, by how they were opened." },
      q5_8: { title: "Vertical agreements – final decisions", hint: "Final decisions in the year." },
      q6_8: { title: "Abuse of dominance – investigations opened", hint: "Files entering the investigation stage in the year, by how they were opened." },
      q6_9: { title: "Abuse of dominance – final decisions", hint: "Final decisions in the year." },
      q7_1_6: { title: "Simplified notification procedure", hint: "Notifications concluded under the simplified procedure (not escalated to a full review), by year of notification, and their share of all notifications (7.2)." },
      q7_2: { title: "Merger decisions", hint: "Notifications received and decisions issued in the year, by the review each file went through. Reasons for withdrawal answer 7.4." },
      q7_3: { title: "Merger review duration", hint: "Calendar days from the initial notification to the completion of the review (the file going to the decision-maker), from there to the decision, and in total." },
      q8_2: { title: "Leniency applications and benefits", hint: "Cases with leniency applications, cases with more than one applicant, whether benefits were granted to all applicants, and why they were refused (8.3)." },
      q8_10: { title: "Complaints received and rejected", hint: "Complaints received and rejected, the rejection rate, the main reasons, and rejections taken to grievance with their result." },
      q8_11: { title: "Sources of investigations", hint: "All investigations opened in the year, whatever the conduct, by source; the share opened on the Department's own initiative, and its main sources." },
      q8_14: { title: "Dawn raids", hint: "Cases with unannounced inspections, by conduct." },
      q8_19: { title: "Criminal enforcement", hint: "Files referred to the Public Prosecution (Article 33), cases in which criminal charges were brought and cases in which criminal sanctions were imposed." },
      q10_8: { title: "Settlements, commitments and other negotiated procedures", hint: "Cases closed by settlement, commitments or another negotiated procedure, by conduct and instrument." },
      q10_9: { title: "Imprisonment", hint: "Cases in which imprisonment was imposed, those appealed, and those overturned on appeal." },
      q13_2: { title: "Market studies", hint: "Market studies the Ministry released in the year – market-study files approved for publication – and their sectors." },
      q13_3: { title: "Formal advocacy opinions", hint: "Opinions to government adopted in the year and their sectors." },
      q13_5: { title: "Adoption of recommendations", hint: "Recommendations made in market studies and in advocacy opinions, and the share adopted by regulators or legislators." },
      q13_7: { title: "Market study duration", hint: "Average calendar days from commissioning to publication of the market studies finalised in the year." },
      q13_9: { title: "Advocacy events", hint: "Workshops, trainings and campaigns organised by the Department (not events where staff were only speakers)." },
      q14_8: { title: "Appeals", hint: "Decisions issued and interim measures, grievances against them (Article 34), appeals before the courts as a share of decisions, and their outcome." },
      q14_8d: { title: "Length of appeals", hint: "Average calendar days of a grievance, and of each level of court appeal." },
      q11_6: { title: "Private enforcement", hint: "Private competition claims brought before the courts, follow-on or standalone, and their outcome." },
    },
    lists: {
      q3_10: "Horizontal agreements – infringement decisions",
      q4_9: "Bid rigging – infringement decisions",
      q5_9: "Vertical agreements – infringement decisions",
      q6_10: "Abuse of dominance – infringement decisions",
      q7_6: "Concentrations prohibited or cleared with remedies",
      q10_8: "Cases settled or closed on commitments",
      q10_10: "Procedural infringements (including merger control)",
      q13_2: "Market studies finalised",
      q13_3: "Formal advocacy opinions issued",
    },
    noItems: "Nothing in these years",
    decisionColumns: { number: "Decision No.", year: "Year", conduct: "Type of conduct", companies: "Companies involved", sanction: "Sanction", fine: "Fine (AED)", outcome: "Outcome", parties: "Merging parties", remedies: "Remedies", instrument: "Instrument" },
    itemColumns: { year: "Year", title: "Title", sector: "Sector", duration: "Duration", addressee: "Addressed to" },
    sanctions: { Fine: "Fine", Warning: "Warning", Referral: "Referral to the Public Prosecution", Orders: "Orders", Finding: "Finding of infringement", Settlement: "Settlement", Commitments: "Commitments", Remedies: "Cleared with remedies", Prohibition: "Prohibited" },
    methodology: {
      antitrust: "Conduct groups: horizontal agreements are cartels, restrictive agreements and market sharing; vertical agreements are resale price maintenance and exclusive dealing; abuse of dominance includes predatory pricing, economic dependency, refusal to deal and tying. An investigation counts as opened when the file enters its investigation stage. A private warning finds an infringement without a fine, so it counts in the total only.",
      phasesAwaiting: "Reading the simplified review as the questionnaire's Phase I and the substantive review as its Phase II awaits the Department's approval in the legal rules register.",
      phasesApproved: "The Department has approved reading the simplified review as the questionnaire's Phase I and the substantive review as its Phase II.",
      mergers: "Clearances are counted by the review each file went through: the simplified or the substantive review. The export fills the questionnaire's Phase I and Phase II columns from them. Notifications exclude filings screened out as not notifiable. Review time runs from the initial notification.",
    },
  },
  caseAssistant: {
    button: "Ask the assistant",
    title: "Assistant · {{caseNumber}}",
    description: "Answers cite this case file and the department's knowledge; anything that would change the case waits for your approval. The same conversation continues in the AI Workspace.",
    newConversation: "Start a new conversation",
    openInWorkspace: "Open in AI Workspace",
    starting: "Opening your conversation about this case…",
    failed: "Couldn't open the conversation",
  },
  // S 2.4, S 6.3, S 6.4: where each filed value comes from, the amounts as filed in their currency, and the sales test that could not run.
  filedValues: {
    title: "Where each filed value comes from",
    hint: "Each value with its source: a document on the file (page and passage), the conversation, or the person who entered it. A value copied from another field, without a source, or whose passage does not state it is flagged; an amount in another currency shows its rate, source and date.",
    none: "No value on the form yet.",
    value: "Value",
    source: "Source",
    kinds: { Document: "Document on the file", Applicant: "Entered by the applicant", Conversation: "Stated in the conversation", Officer: "Entered by an officer" },
    noSource: "No source recorded",
    page: "p. {{page}}",
    passageNotFound: "passage not found in the document",
    passageDoesNotState: "the passage does not state this value",
    market: "Market: {{market}}",
    originalAmount: "Filed as {{original}}",
    published: "published rate",
    turnoverMissing: "Turnover in the relevant market missing",
    turnoverMissingHint: "No size for {{markets}}",
    noMarket: "No relevant market declared",
  },
  workspace: {
    breadcrumb: "Location",
    testFile: "Test file – as of {{date}}",
    testMode: {
      action: "Mark as a test file",
      hint: "Replay a past case or run a prepared scenario",
      title: "Mark this file as a test",
      body: "A test file is never published, counted in the statistics or cited as a precedent, sends no e-mail or SMS, and is hidden from the portal except for the account that filed it. The mark cannot be removed and is refused once a decision has been issued.",
      asOf: "Replay as of",
      asOfHint: "The AI will read only the legal texts and precedents issued on or before this date.",
      reason: "Purpose of the test and what its outcome will be compared with",
      submit: "Mark as a test",
      done: "The file is marked as a test.",
    },
    administrativeRecord: {
      action: "Export the administrative record",
      hint: "A ZIP for a grievance or appeal: documents, letters, drafts, figures, approvals, decisions and the audit trail",
      preparing: "Assembling the administrative record…",
      done: "The administrative record of {{caseNumber}} is exported.",
      doneHint: "The ZIP opens at its index page. A digital fingerprint of its list of contents, which gives each file's own fingerprint, is recorded in the audit trail, so any later change shows.",
      failed: "The administrative record could not be exported",
    },
    testFileHint: "Run to test the platform. Its decision is never published, counted or cited as a precedent, and its AI reads only the texts and precedents issued by this date.",
    fineAed: "Settlement amount or court fine (AED)",
    settlementReached: "Settled under Article 33(2) (the amount is the settlement)",
    closedWithCommitments: "Closed on commitments offered by the undertakings",
    stepTaken: "Step recorded",
    decisionNotYet: "No decision yet",
    decisionNotYetHint: "The decision is drafted and issued once the file reaches the decision stage.",
    stageOf: "Stage {{n}} of {{total}}",
    awaitingRole: "Awaiting {{role}}",
    procedureGuide: "Procedure guide",
    details: "Details",
    moreActions: "More actions",
    undo: {
      action: "Undo last step",
      nothing: "No step can be undone",
      confirmTitle: "Undo the last step?",
      confirmBody: "The case returns from “{{from}}” to “{{to}}”. Deadlines and tasks closed by the step are reopened, and the reversal is recorded in the history.",
      note: "Reason for undoing",
      done: "The last step was undone",
      failed: "The step could not be undone",
      fromToast: "Undone immediately after concluding the stage",
      reasons: {
        NoStep: "No step to undo",
        WorkflowChanged: "The procedure has changed since this step",
        Submission: "A submission cannot be undone",
        Automatic: "Steps taken automatically cannot be undone",
        NotActor: "Only the officer who took the step or the Director can undo it",
        Window: "Steps can be undone within 24 hours",
        DecisionIssued: "A decision has been issued since this step",
        LetterSent: "A letter has been sent to the parties since this step",
      },
    },
    refer: {
      action: "Refer to another section",
      hint: "Opens a separate linked file in that section",
      title: "Refer to another section",
      body: "The other section works the matter in its own linked file with its own stages. This file keeps its own path.",
      target: "Section and file type",
      reason: "Reason for the referral",
      submit: "Open the linked file",
      done: "Linked file {{caseNumber}} opened",
      sections: { EconomicConcentration: "Economic Concentration", Investigations: "Investigations & Complaints", Advocacy: "Advocacy", Requests: "Other requests", Leadership: "Leadership" },
    },
    linked: {
      title: "Linked files",
      hint: "Files referred to or from this one",
      relation: { Parent: "Referred from", Referral: "Referred to", Related: "Related" },
    },
    guard: "Guard",
    guardSatisfied: "satisfied",
    guardNotSatisfied: "not satisfied",
    guardUnmet: "Condition not met: {{condition}}",
    fieldEn: "{{field}} in English",
    fieldAr: "{{field}} in Arabic",
    noticeDraft: "The Ministry of Economy and Tourism has received a notification of the economic concentration “{{title}}”. Any interested party may submit comments or an objection within the publication period.",
    roles: "Roles",
    anyStaff: "Any staff member",
    overview: "Overview",
    workflow: "Workflow",
    parties: "Parties & entities",
    documents: "Documents",
    analysis: "Analysis",
    investigationReport: "Report",
    correspondence: "Correspondence",
    tasks: "Tasks & meetings",
    reports: "Reports",
    decision: "Decision",
    audit: "Audit trail",
    agents: "Agent activity",
    aiSummary: "AI case summary",
    riskGauge: "Concentration risk",
    explainability: "Explainability",
    nextSteps: "Next steps",
    runAgent: "Run agent",
    transition: "Advance workflow",
    publication: "Publication & objections",
    procedure: "Procedure",
    remedies: "Remedies",
    investigation: "Investigation board",
    report: "Report",
    enforcement: "Enforcement",
    enquiry: "Enquiry",
    exemption: "Exemption review",
    amendment: "Amendment review",
    appeal: "Grievance",
    noSummary: "The Triage Agent has not summarised this case yet. Run it from the agent menu or wait for the workflow hook.",
    formallyAccepted: "Formally accepted",
    clocks: "Statutory clocks",
    extend: "Extend",
    extendHint: "Up to {{max}} more days are allowed under",
    extensionDays: "Extension (days)",
    justification: "Justification",
    clockExtended: "Deadline extended",
    paused: "Suspended",
    pausedSince: "Suspended since {{date}} – resumes when the applicant completes the file",
    humanTasks: "Human tasks",
    taskCompleted: "Task completed",
    journal: "Instance journal",
    noDocuments: "No documents on this case yet.",
    docSize: "{{kb}} KB",
    docPages_one: "{{count}} page",
    docPages_other: "{{count}} pages",
    docVersion: "Version {{version}}",
    docPageOf: "Page {{page}} · passage {{n}}",
    docInternal: "Internal",
    docLanguage: { ar: "Arabic", en: "English", other: "Another language" },
    // How a document's text was read (substantive review 6.12): pages, scans, pages not read, values to be checked.
    documentReading: {
      checks: "Document checks",
      noChecks: "Nothing to raise about this document.",
      pages: "{{count}} pages in the file",
      scanned: "{{count}} transcribed from a scan",
      unread: "{{count}} not read",
      partly: "{{count}} read in part",
      notStored: "{{count}} not kept as text",
      scanTag: "Scan",
      unreadTag: "Pages not read",
      toCheck: "To be checked",
      onPage: "page {{page}}",
      scannedPage: "scanned page",
      notFound: "not found in the text as read",
      lowConfidence: "low confidence",
      toCheckNote: "Values marked to be checked were read from a scanned page or with low confidence: check them against the document.",
      aiReading: "AI reading",
      aiReadingLegacy: "Read automatically by the platform's AI before the reading recorded its model; reprocess the document to record it and check it.",
      instructionVersion: "instructions v{{version}}",
      transcriptionVersion: "scan transcription v{{version}}",
      notChecked: "The summary and the fields are the AI's reading of the document: no officer has checked them against it yet.",
      checkedBy: "Checked against the document by {{name}} on {{date}}.",
      check: "Record that I checked it",
      checkRecorded: "Your check of the reading is recorded on the file.",
    },
    // A document and its translation (substantive review 6.13): both texts side by side, the differences marked, the officer's decision.
    documentTranslation: {
      tab: "Translation",
      none: "This document has no translation on the file.",
      linkLabel: "This document is the translation of",
      choose: "Choose the original…",
      link: "Link as translation",
      unlink: "No longer a translation",
      linked: "Translation linked; the two are compared now.",
      original: "Original",
      translation: "Translation",
      arabic: "Arabic",
      english: "English",
      inferred: "Recognised as one checklist item filed in two languages.",
      arabicPrevails: "Legislation or a Ministry document: the Arabic text prevails over the translation.",
      referred: "A party document whose translation differs: referred to the officer, who decides which text stands, with reasons.",
      decided: "Decided by {{name}} on {{date}}: {{decision}}.",
      reasons: "Reasons",
      decisionLabel: "Which text stands",
      decision: { arabic: "The Arabic text stands", english: "The English text stands", corrected: "Neither: a corrected translation is to be filed" },
      reasonsHint: "Recorded in the file's journal with the decision.",
      decide: "Record the decision",
      saved: "Decision recorded in the journal.",
      differences_one: "{{count}} difference",
      differences_other: "{{count}} differences",
      noDifferences: "The figures, dates, articles, names and defined terms match.",
      kind: { figure: "Figure", date: "Date", article: "Article", name: "Name", term: "Defined term" },
      page: "Page {{page}}",
      pages: "Arabic page {{ar}} · English page {{en}}",
      article: "Article {{article}}",
      whole: "Whole text",
      empty: "Nothing in this language here.",
    },
    reprocess: "Read the document again",
    reprocessQueued: "Document intelligence re-run queued",
    extraction: "Extracted fields",
    fullText: "Text",
    redactedView: "Show PII-redacted text (what the model saw)",
    processingDoc: "Document intelligence is still processing this file.",
    injectionFlags: "Prompt-injection screening flagged",
    thresholdTest: "Threshold test (Cabinet Decision No. 3 of 2025)",
    thresholdBasis: "Deterministic calculators – turnover, market-share, HHI, CR4 – computed from the notification data.",
    relevantMarkets: "Relevant markets & concentration metrics",
    band: "Concentration band",
    scorecard: "Structural triage score (prioritisation signal)",
    scorecardHint: "A screening signal that allocates scrutiny, not evidence of harm: every point is attributed to a structural factor with a rationale. The recommendation is the expert's judgment against the evidentiary standard in the report.",
    noAnalysis: "The Market Definition & Concentration Agent has not run yet.",
    noRisk: "No triage score yet",
    dominancePost: "Post-transaction dominance",
    theoriesOfHarm: "Theories of harm",
    countervailing: "Countervailing factors",
    letters: "Letters & notifications",
    lettersHint: "Drafted from bilingual templates. A letter with legal effect is sent only once an authorised officer has confirmed it; one prepared without that confirmation waits here.",
    held: {
      badge: "Awaiting your confirmation",
      title: "This letter has not been sent",
      hint: "It has legal effect and was prepared without an officer's confirmation. Read it in full, then confirm it to send it now, or cancel it.",
      confirm: "Confirm and send",
      cancel: "Cancel letter",
      reason: "Why it is cancelled (optional)",
      confirmed: "Letter confirmed and sent",
      cancelled: "Letter cancelled; it was not sent",
      failed: "The letter could not be confirmed",
      openFailed: "Your reading of this letter was not recorded, so it cannot be confirmed yet",
    },
    // Scenario 6.36: a letter the confidentiality screen held, with what it found, until the passages are removed or the basis for disclosure is recorded.
    screened: {
      badge: "Held by the confidentiality screen",
      title: "This letter may disclose confidential material",
      hint: "The confidentiality screen found the passages below in the letter or its attachments. Take them out and save the letter – it is screened again – or have an authorised officer record the basis on which they may be disclosed. It can then be confirmed.",
      kinds: { Passage: "Passage from a confidential document", Figure: "Figure from a confidential document", Marked: "Marked confidential", Email: "E-mail address", Phone: "Telephone number", Document: "Confidential document attached", Identity: "Identifies the complainant" },
      where: { letter: "in the letter", arabic: "in the Arabic text", attachment: "in the attachment {{name}}" },
      edit: "Edit the letter",
      bodyEn: "English text",
      bodyAr: "Arabic text",
      save: "Save and screen again",
      saved: "Letter saved and screened again",
      stillFound_one: "The screen still finds one passage",
      stillFound_other: "The screen still finds {{count}} passages",
      clear: "The confidentiality screen now finds nothing in this letter.",
      basis: "Basis for disclosure",
      basisPlaceholder: "The owner's written consent and its date, or why the passage is not confidential",
      recordBasis: "Record the basis",
      basisRecorded: "Basis for disclosure recorded",
      recordedBy: "Basis recorded by {{name}}",
      basisOnlyAuthorised: "The basis for disclosure is recorded by the Head of Complaints, the Director or a more senior officer.",
    },
    rfis: "Requests for information",
    rfisHint: "Deficiency and clarification requests with statutory reply clocks and reminder cadence.",
    reminders: "Reminders",
    awaitingResponse: "Awaiting applicant response",
    satisfied: "Satisfied",
    notSatisfied: "Not satisfied",
    publicRegister: "Public register notice",
    publicRegisterHint: "Publication on the received-applications schedule opens the window for views and objections that Arts 15–16 of the Implementing Regulations set; the publication shows the day it closes. No decision issues until that window closes.",
    publish: "Publish notice",
    publishHint: "Only non-confidential information is published. Confidential parties and market data are excluded.",
    published: "Notice published",
    windowCloses: "Window closes {{date}}",
    windowClosesLabel: "Window closes",
    windowOpen: "Open",
    publicLink: "Public register",
    copyPublicLink: "Copy link",
    previewPublicLink: "Preview",
    publicLinkCopied: "Public register link copied",
    publishedAt: "Published",
    notPublished: "Not yet published. Publish once the case is registered and the Director approves.",
    submissions: "Submissions",
    interestedParties: "Interested-party views",
    outsideWindow: "Outside window",
    weighHint: "Letters are weighed, not counted: record for each the evidence it brings and whose interest it serves. The reasons go into the report's third-party section.",
    weighPrinciple: "A competitor objecting to lower prices protects itself, not competition. Weight follows the evidence – documents, data, verifiable facts – never the number of letters.",
    weighSubmission: "Weigh",
    reweighSubmission: "Re-weigh",
    recordWeight: "Record weight",
    submissionWeighed: "Submission weighed",
    evidentialWeight: "Evidential weight",
    interestServed: "Interest served",
    whyAcceptedOrDiscounted: "Why accepted or discounted",
    weighReasoningHint: "State the evidence the letter brings (or lacks) and why the concern is accepted or discounted. This sentence is carried verbatim into the report.",
    weighedBy: "weighed by {{name}} · {{date}}",
    weights: { Unassessed: "Unassessed", None: "None", Low: "Low", Medium: "Medium", High: "High" },
    decisionPublication: {
      title: "Public version of the decision",
      hint: "Drafted from the record – outcome, procedure, reasons, conditions, the Committee's opinion – with exact turnovers, shares, prices and third parties withheld. Check the redactions, edit the text and publish it to the decisions register.",
      publishedBadge: "Published", draftBadge: "Draft",
      review: "Review and publish", revise: "Revise", publish: "Publish to the register", republish: "Publish the revision", resetToDraft: "Regenerate from the record",
      saved: "Draft saved.", published: "The decision is published in the register.",
      staleTitle: "The record has changed since this draft was prepared", stale: "The decision, its conditions or the Committee's opinion changed after the draft. Regenerate it before publishing.",
      outcome: "Outcome", decidedOn: "Decided", reviewDays: "Review (days)", simplified: "simplified procedure", redactionCount: "Passages withheld",
      redactions: "{{count}} redactions applied by the platform", redactions_one: "{{count}} redaction applied by the platform",
      redactionKinds: { Turnover: "Turnover", Share: "Market share", Amount: "Amount", Percentage: "Percentage", Contact: "Contact", ThirdParty: "Third party", Party: "Party", Name: "Name" },
      caseHint: "Drafted from the decision – outcome, reasons, orders and the procedure followed – with sales, the fine range and other amounts withheld. The fine imposed is published; the complainant and the source of an investigation are never named.",
      fine: "Fine imposed", provision: "Provision applied",
      notNamed: "Undertakings not named", notNamedHint: "A warning letter, a request for the criminal action and the closure of an investigation the Department opened itself are published without naming the undertakings.",
      publisherOnly: "The Head of Complaints or the Director publishes the decision; you can prepare and save the text.",
      reasons: "Reasons", reasonsHint: "The public reasoning: market definition, the evidence relied on, the parties' observations and how they were answered, and why the conditions are proportionate. Keep business secrets out.",
      conditions: "Conditions", conditionsHint: "One condition per line, as the public should read them.",
      redactionNotes: "Redaction note", redactionNotesHint: "Say what was withheld and on what basis; this note is published with the decision.",
      preparedBy: "Prepared by {{name}} · {{date}}", publishedBy: "Published by {{name}} · {{date}}",
    },
    exPost: {
      tab: "Ex-post",
      title: "Ex-post evaluation of the decision",
      hint: "What the report predicted for each market – structure, prices, entry – and what the commitments were to achieve, read against the Data Bank after the decision. Complete it with a verdict, findings and the lessons the analysis policy should take.",
      none: "No ex-post evaluation is scheduled", noneHint: "The evaluation is scheduled when the decided case closes.",
      status: { Scheduled: "Scheduled", Read: "Read", Completed: "Completed" },
      verdicts: { AsPredicted: "As predicted", BetterThanPredicted: "Better than predicted", WorseThanPredicted: "Worse than predicted", Inconclusive: "Inconclusive", NoData: "No data" },
      entryReadings: { Likely: "Likely", Unlikely: "Unlikely", NotAssessed: "Not assessed" },
      read: "Read the Data Bank", reread: "Re-read the Data Bank", readDone: "The Data Bank was read against the report's predictions.",
      complete: "Record the evaluation", completed: "The evaluation is recorded and its lessons are on the analysis policy page.", record: "Record",
      decision: "Decision", dueAt: "Due", inDays: "in {{count}} days", inDays_one: "in {{count}} day", overdueDays: "{{count}} days overdue", overdueDays_one: "{{count}} day overdue", lastRead: "Last read", efficiencies: "Efficiencies claimed", cognisable: "cognisable",
      suggested: "Suggested verdict", notRead: "The Data Bank has not been read for this decision yet. Read it to compare what the market did with what the report predicted.",
      hhiPredicted: "HHI predicted", hhiObserved: "HHI observed", sharePredicted: "Merged share predicted", shareObserved: "Merged share observed", pricePredicted: "Price effect simulated", priceObserved: "Price change observed", entry: "Entry", verdict: "Verdict",
      commitments: "Commitments", suggestedLessons: "Suggested lessons for the analysis policy",
      findings: "Findings", findingsHint: "What the market did against what the report predicted, market by market, and whether the commitments held.",
      policyLessons: "Lessons for the analysis policy", policyLessonsHint: "What the margin, recapture, entry or remedy assumptions should take from this case – or that nothing needs changing, and why.",
      completedBy: "Completed by {{name}} · {{date}}",
    },
    interests: { Unassessed: "Interest not read", ProtectsCompetition: "Protects competition", ProtectsCompetitor: "Protects a competitor", Neutral: "Neutral" },
    objections: "Objections",
    objectionsHint: "Objections require the fee and an admissibility decision within {{period.ec.objectionAdmissibility}} working days; the objector is told the outcome; an accepted objection goes to every party in a non-confidential version, for a reply within {{period.ec.objectionReply}} working days (Article 16).",
    admissibilityDue: "Admissibility due",
    partiesReplyDue: "Parties' reply due",
    repliedInTime: "Replied in time",
    repliedLate: "Replied late",
    admissibility: "Admissibility",
    partiesReply: "Parties' reply",
    outcome: "Outcome",
    decideAdmissibility: "Decide admissibility",
    resolveObjection: "Resolve objection",
    objectionDecided: "Objection updated; parties notified where applicable",
    reasoning: "Reasoning",
    admissible: "Admissible",
    inadmissible: "Inadmissible",
    uphold: "Uphold",
    dismiss: "Dismiss",
    // AA-01 G2: objection notices – the non-confidential version, the objector's letter, the parties' silence.
    nonConfidentialGrounds: "Non-confidential grounds for the parties",
    nonConfidentialGroundsAr: "Non-confidential grounds (Arabic, optional)",
    nonConfidentialHint: "Sent to every party to the concentration if the objection is accepted. The draft has figures, amounts and contact details taken out; remove anything else given in confidence. The objection as filed is never sent.",
    objectorReasonsHint: "The objector is told the outcome and, on a rejection, these reasons (Article 16(3)).",
    reasoningAr: "Reasons (Arabic, optional)",
    objectorTold: "Objector told {{date}}",
    partiesSent_one: "Sent to one party",
    partiesSent_other: "Sent to {{count}} parties",
    recordSilence: "Record no reply",
    silenceFrom: "No reply – silence from {{date}}",
    silenceRecorded: "Silence recorded: the review resumes on the file as it stands (Article 16(4)(c)).",
    noticeDraftLoaded: "Drafted from the notification: the parties, the transaction and every declared market, with no figures.",
    reportsHint: "Report with recommendation, decision brief and other agent reports approved for this case.",
    noReports: "No report yet.",
    conditions: "Conditions",
    conditionsHint: "One condition per line.",
    decidedBy: "Decided by",
    issuedAt: "Issued",
    signature: "e-Signature",
    appealDeadline: "Appeal deadline",
    notifiedAt: "Parties notified",
    noticesTitle: "Notice to each party",
    noticesHint: "Every party entitled to notice gets its own notice; each party's deadline runs from its own notification, and moves to the day of receipt once that is proven.",
    deliveryStatus: { Delivered: "E-mailed", Failed: "E-mail refused – portal only", PortalOnly: "Portal only" },
    receivedOn: "Received {{date}}",
    receiptNotProven: "Receipt not proven",
    deadlineOn: "Deadline {{date}}",
    fromSending: "counted from sending",
    recordReceipt: "Record receipt",
    receiptDate: "Date received",
    receiptNote: "How it was delivered",
    receiptRecorded: "Receipt recorded; the party's deadline now runs from it",
    grievanceEffect: "What the acceptance does to the decision",
    effectWithdrawn: "Withdraws the decision",
    effectAmended: "Amends the decision",
    amendedTerms: "Amended terms (English)",
    amendedTermsAr: "Amended terms (Arabic)",
    amendedTermsHint: "Quoted in the notices to the grievant and to the other parties to the original decision.",
    notifyParties: "Notify parties",
    partiesNotified: "Decision notifications sent",
    issueDecision: "Issue decision",
    issueDecisionHint: "Signing records the decision in the register and starts the appeal clock.",
    issueDecisionHintEc: "Issued within the {{period.ec.review}}-day review period; the parties are notified within {{period.ec.notifyDecision}} days.",
    deciderOnly: "A decision is issued only by its signatory: the Minister for ministerial decisions; the Undersecretary for the administrative decision that the conditions of Article 12 are not met.",
    notInDecisionState: "The case is in state {{state}}. Advance the workflow to the decision stage first.",
    prefillFromBrief: "Pre-fill from decision brief",
    signAndIssue: "Sign & issue",
    decisionIssued: "Decision signed and recorded",
    auditTrail: "Audit trail",
    auditHint: "Every event is SHA-256 chained to the previous one and streamed to the SIEM. Re-verify at any time.",
    verifyChain: "Check again",
    chainValid: "Complete and unaltered",
    chainValidHint: "{{count}} entries checked.",
    chainGap: "Some events belong to interleaved chains from other cases.",
    chainInvalid: "{{count}} entries were changed after they were recorded",
    chainInvalidHint: "Report this to the platform administrator.",
    actor: "Actor",
    action: "Action",
    entity: "Entity",
    auditDetailsInConsole: "Platform administrators read each entry in Platform administration.",
    extendedBy: "including an extension of {{days}}",
    warningSent: "warning sent", recipients: { applicant: "Applicant", department: "Competition Department", complainant: "Complainant", whistleblower: "Whistleblower" },
    auditSeverity: "Severity",
    agentRuns: "Agent runs",
    piiRedacted: "PII tokens redacted",
    piiHint: "Names, IDs and contacts are pseudonymised before any model call.",
    noRuns: "No agent has run on this case yet.",
    runTools_one: "{{count}} tool call",
    runTools_other: "{{count}} tool calls",
    runSources_one: "{{count}} source consulted",
    runSources_other: "{{count}} sources consulted",
    runFailed: "The run did not complete",
    reviewStage: "Review stage",
    processPosition: "Where the case stands in its procedure",
    phaseOf: "phase {{n}} of {{total}}",
    phases: {
      title: "Phases of the procedure",
      intake: "Intake",
      review: "Review",
      publication: "Publication",
      assessment: "Assessment",
      decision: "Decision",
      closure: "Closure",
    },
    phaseStanding: { done: "Completed", current: "In progress", ahead: "Ahead", skipped: "Not on this path" },
    stageStanding: { visited: "Passed", current: "Current stage", ahead: "Ahead", bypassed: "Not on this path" },
    stagesDone: "{{done}} of {{total}} stages passed",
    extendable: "extendable by {{days}}",
    automaticTransition: "Moves automatically",
    guardUnknown: "not evaluated for your role",
    primaryClock: "primary",
    processMap: "Process map",
    processGuide: "Process guide",
    processGuideHint: "The written description of this procedure – stages, actors, clocks, gates and diagrams (PDF, opens in a new tab).",
    stepRequires: "What this step requires",
    responsibleRoles: "Responsible roles",
    forms: "Forms",
    openWorkflow: "Open workflow",
    stepProposals: "AI proposals for this step",
    noStepProposals: "No AI proposal for this step yet — run an agent or advance the workflow.",
    recommendedAction: "Recommended action",
    noTransition: "No transition is available for your role at this step.",
    thisStep: "This step",
    completeness: "Completeness of the file",
    mandatoryPresent: "mandatory items present",
    requiredDocumentsOnFile: "{{present}} of {{total}} required documents on file",
    atSubmission: "at submission",
    readinessAtSubmission: "Readiness score at submission",
    fileComplete: "File complete",
    itemsToResolve: "{{count}} items to resolve", itemsToResolve_one: "{{count}} item to resolve",
    readinessOnly: "Deterministic checklist — the Initial Review Agent has not examined this file yet.",
    runFormalReview: "Run initial review",
    formalReviewQueued: "Initial Review Agent queued; the checklist refreshes when it finishes.",
    reviewProposal: "Review proposal",
    consistencyFindings: "Consistency findings",
    optional: "Optional",
    requestText: "Request",
    openDocument: "Open document",
    deficiencyDrafted: "A deficiency notice with these items has been drafted and awaits your approval.",
    completenessStatus: { Present: "Present", Deficient: "Deficient", Missing: "Missing", ToFollow: "To follow", NotRequired: "Not required" },
    overriddenCount: "{{count}} ruled on by an officer",
    overrideBadge: "Officer's ruling",
    resolveItem: "Resolve",
    resolveItemHint: "Attach, link or rule on this item",
    resolve: {
      title: "Resolve checklist item",
      platformSays: "The platform says",
      notOnChecklist: "This item is not on the checklist of the case.",
      upload: "Upload",
      link: "Link a document",
      mark: "Rule on it",
      uploadHint: "Upload the document straight into this slot. It is filed as {{category}}, and the checklist recomputes when the file is stored.",
      uploadAction: "Upload into this slot",
      uploaded: "Document uploaded and filed under the item",
      linkHint: "File a document that is already on the case under this item. The document keeps its history; the move is written to the timeline.",
      alreadyHere: "Already filed under this item",
      currentlyUnder: "Currently under: {{slot}}",
      notLinked: "Not linked to any checklist item",
      linkAction: "File under this item",
      linked: "Document filed under the item",
      ruling: "Ruling",
      present: "Treat as present",
      presentHint: "The requirement is met — on the file, or in a form the platform did not recognise.",
      notRequired: "Not required for this case",
      notRequiredHint: "The item does not apply here. Mandatory items need a reason the record can stand on.",
      reason: "Reason",
      reasonHint: "At least {{min}} characters. Written to the case timeline and the audit chain under your name.",
      reasonPlaceholder: "What you checked, and why the platform's finding does not hold…",
      auditNote: "An officer's ruling outranks the platform's finding and any agent's assessment. It stays visible on the item and can be revoked at any time; revoking restores the platform's view.",
      markAction: "Record ruling",
      marked: "Ruling recorded — the checklist has been recomputed",
      revoke: "Revoke ruling",
      revokeReason: "Why the ruling is withdrawn (optional)",
      confirmRevoke: "Confirm revocation",
      revoked: "Ruling revoked — the platform's finding stands again",
    },
    qualification: "Is this an economic concentration?",
    qualificationHint: "Deterministic control test under Article 1 of Federal Decree-Law No. 36 of 2023, combined with the notification thresholds. Rules decide; agents only supply evidence.",
    verdict: { Constitutes: "Constitutes a concentration", DoesNotConstitute: "Does not constitute a concentration", Borderline: "Borderline – screening required", Unassessed: "Not assessed" },
    notificationRequired: "Notification required",
    notificationNotRequired: "Notification not required",
    flaggedForScreening: "Flagged for screening",
    controlTest: "Control test",
    noControlTest: "The applicant has not provided the control-test inputs yet.",
    missingInputs: "Information still needed from the applicant",
    changeOfControl: "Change of control",
    turnoverThreshold: "Sales in the relevant market above {{threshold}}",
    turnoverThresholdHint: "Combined sales of the parties in each declared market (share × market size). Group annual accounts are the fee base only.",
    marketSizeMissing: "Market size not on file",
    shareThreshold: "Parties' share above {{threshold}}%",
    met: "Met",
    notMet: "Not met",
    notificationPending: {
      short: "Pending",
      hint: "A test of Article 3 is not run without its figure: the status stays pending until every declared market has its size and the parties' shares on file. A missing figure is never read as below the threshold.",
    },
    applicantNotice: "Notice shown to the applicant",
    acknowledgedBy: "Acknowledged by {{name}} on {{date}}",
    acknowledgedHint: "The applicant confirmed they understood that notification does not appear required and that the fee is non-refundable, and chose to file anyway.",
    applicantContests: "The applicant contests the automated qualification ({{date}}) and asked for a human review",
    declaredInputs: "Declared inputs",
    dataCompleteness: { Full: "Complete inputs", Partial: "Partial inputs", Minimal: "Minimal inputs" },
    acquiredStake: "Stake acquired",
    preStake: "Stake held before",
    postStake: "Stake after transaction",
    largestOther: "Largest other shareholder",
    controlType: "Declared control",
    controlTypes: { Unknown: "Not declared", None: "No control", Sole: "Sole control", Joint: "Joint control" },
    rights: "Rights conferred",
    controlRights: { BoardMajority: "Majority of the board", VetoStrategic: "Veto over strategic decisions", CastingVote: "Casting vote", ManagementContract: "Management contract", OptionToAcquireControl: "Option to acquire control", MinorityProtectionOnly: "Minority-protection rights only" },
    fullFunctionJv: "Full-function joint venture",
    assetsAreBusiness: "Assets form a business",
    intraGroup: "Intra-group restructuring",
    controlStructureNote: "Applicant's description of the control structure",
    aiDraftBy: "AI draft · {{agent}}",
    extractionNote: "Read automatically from the document. Check against the text before relying on it.",
    noneFound: "None found",
    notRecorded: "Not recorded",
    chainValidHint_one: "{{count}} entry checked.",
    chainValidHint_other: "{{count}} entries checked.",
    chainInvalid_one: "{{count}} entry was changed after it was recorded",
    chainInvalid_other: "{{count}} entries were changed after they were recorded",
  },
  stage: {
    steps: "Stages of this file",
    stepOf: "Stage {{n}} of {{total}}",
    owner: "Responsible",
    notReached: "Not reached yet",
    notOnPath: "Not on this file's path",
    panels: { file: "Case file", history: "History" },
    recordOf: "Record of the {{phase}} stage",
    recordHint: "What was concluded in this stage, by whom and when.",
    recordEmpty: "No signed stage review was recorded here.",
    recordExits: "How the stage was left",
    actor: { Human: "An officer", Agent: "An assistant of the platform", System: "The platform's record" },
    left: {
      title: "What is left",
      count_one: "One item",
      count_other: "{{count}} items",
      done_one: "One item done",
      done_other: "{{count}} items done",
      none: "Nothing is left for you in this stage.",
      noneCanConclude: "Everything is done. The stage can be concluded.",
      blocking: "Needed",
      criteria_one: "One criterion to decide",
      criteria_other: "{{count}} criteria to decide",
      showAll: "Show all {{count}}",
      showFewer: "Show fewer",
      taskFailed: "The task could not be completed",
      kinds: { Criterion: "Criterion to decide", Issue: "Issue to resolve", Document: "Filing to complete", Task: "Task", Draft: "Draft to review", Condition: "Condition of the procedure" },
      actions: { Criterion: "Decide", Issue: "Open", Document: "Resolve", Task: "Mark done", Draft: "Review" },
    },
    primary: {
      go: "Next: {{title}}",
      here: "Next step: {{title}}",
      issue: "Resolve the issue: {{title}}",
      conclude: "Conclude the stage",
      waiting: "Waiting for the next step of the procedure",
      waitingFor: "Waiting for: {{condition}}",
      awaiting: "Awaiting: {{role}}",
      anotherRole: "another officer",
      closed: "This file is closed",
      held: {
        declare: "Next step: declare any interest in this file",
        pending: "Awaiting the Director's decision on the declared interest",
        recused: "Recused from this file – no action can be taken on it",
      },
    },
  },
  review: {
    sourceKinds: { Document: "Document", Proposal: "AI draft", Tool: "Platform check", Clock: "Statutory period", Task: "Task", Citation: "Legal reference", Letter: "Letter", Meeting: "Meeting", Rfi: "Request for information", Submission: "Submission" },
    tab: "Review",
    fileTab: "Case file",
    historyTab: "History",
    stageReviews: "Stage reviews",
    visit: "visit {{n}}",
    criteria: "Review criteria",
    required: "Required",
    recommended: "Recommended",
    optional: "Optional",
    undecided: "Not decided yet",
    decidedOf: "{{done}} of {{total}} decided",
    overrodeAi: "{{count}} AI overrides", overrodeAi_one: "{{count}} AI override",
    surfaces: { file: "Open the case file", analysis: "Open the analysis", decision: "Open the decision", history: "Open the process" },
    aiAssessment: "What the platform found",
    basis: { Deterministic: "Rules engine", Agent: "Agent draft", Mixed: "Rules + agent", label: "Filing authority", Member: "Member of the undertaking", Mandate: "Representative under mandate" },
    references_one: "Reference",
    references_other: "References ({{count}})",
    discuss: {
      title: "Discuss with the agent",
      subtitle: "Ask anything about this suggestion",
      why: "Why this verdict?",
      raise: "What would raise your confidence?",
      weakest: "Which evidence is weakest?",
      address: "What must my finding address?",
      placeholder: "Ask about this suggestion…",
      send: "Send",
      stop: "Stop",
      agent: "Review agent",
      thinking: "Reading the file",
      copy: "Copy",
      copied: "Copied",
      restart: "New conversation",
      failed: "The agent could not answer",
      none: "No questions were asked about this suggestion.",
    },
    confidence: "Confidence",
    confidenceHint: "The platform's confidence in this verdict: {{pct}}%",
    readingBasis: "This reading is {{meaning}}: {{pct}}%",
    manualOnly: "No automated assessment for this criterion.",
    proposalAwaiting: "Draft awaiting your decision",
    acceptAi: "Accept assessment",
    acceptedAi: "AI assessment accepted",
    acceptAiHint: "Record the platform's verdict as your finding, as it stands",
    aiAgreesHint: "This is the platform's verdict",
    yourFinding: "Your finding",
    verdicts: { Satisfied: "Satisfied", Deficient: "Deficient", NeedsInformation: "Needs information", NotApplicable: "Not applicable", Unknown: "No view", Pending: "Not yet decided" },
    hotkeyVerdicts: "decide",
    hotkeyNote: "note",
    hotkeyRecord: "record",
    disagreeTitle: "The platform found \"{{ai}}\" — say why you differ.",
    note: "Reviewer's note",
    response: "Your response",
    noResponse: "No response was written — the platform's assessment stood as recorded.",
    startFromPlatform: "Start from the platform's text",
    startFromPlatformHint: "Copies what the platform found into your response, to keep, correct or rewrite",
    notePlaceholder: "Your finding in your own words…",
    notePlaceholderDisagree: "Why you differ from the platform…",
    resetRationale: "Reset to the pre-filled rationale",
    evidence: "Evidence",
    pinEvidence: "Pin as evidence for your finding",
    unpinEvidence: "Unpin",
    attachDocument: "Attach a document",
    recordFinding: "Record finding",
    recordNewVersion: "Record as v{{version}}",
    findingRecorded: "Finding recorded as v{{version}}",
    findingCleared: "Finding cleared",
    clearFinding: "Clear finding",
    unsavedChanges: "Unrecorded changes",
    moreActions: "More actions",
    copyLink: "Copy link to this criterion",
    linkCopied: "Link copied",
    refresh: "Refresh the assessment",
    refreshHint: "Run {{agent}} again on this case; the assessment refreshes when it finishes",
    refreshQueued: "Agent queued — the assessment refreshes when it finishes",
    draftOf: "draft of {{date}}",
    liveFromFile: "computed live from the case file",
    sources: "Sources ({{count}})",
    pinHint: "Pin a source to cite it in your finding",
    showAll: "Show all {{count}} sources",
    showFewer: "Show fewer",
    sourceStatus: { Linked: "linked", FailureToNotifyCandidate: "possible failure to notify", StandstillBreachCandidate: "possible standstill breach", NotYetDue: "not yet due", OutOfScope: "out of scope", Constitutes: "constitutes a concentration", DoesNotConstitute: "not a concentration", Borderline: "borderline", Met: "met", NotMet: "not met", HighlyConcentrated: "highly concentrated", ModeratelyConcentrated: "moderately concentrated", Unconcentrated: "unconcentrated", Concern: "concern", Watch: "watch", BelowWatch: "below watch", Complete: "complete", Gaps: "gaps", Declared: "declared", Evidenced: "evidenced", Cognisable: "cognisable", NotCognisable: "not cognisable", ViewIssued: "view issued", Pending: "pending", Requested: "requested", Qualifies: "qualifies", Fails: "does not qualify", Consulted: "consulted", NotConsulted: "not consulted", Planned: "planned", Filed: "filed", UnderReview: "under review", OpinionRequested: "opinion requested", Cleared: "cleared", ClearedWithConditions: "cleared with conditions", Prohibited: "prohibited", NotRequired: "not required", Replied: "replied", Elapsed: "time elapsed", Awaiting: "awaiting reply", Proposed: "proposed", Approved: "approved", Edited: "edited and approved", Rejected: "rejected", Superseded: "superseded", Expired: "expired", Concur: "concurs", ConcurWithReservations: "concurs with reservations", Dissent: "dissents", Draft: "draft", Published: "published", Horizontal: "Horizontal", Vertical: "Vertical", Conglomerate: "Conglomerate", Paid: "Paid", Unpaid: "Unpaid", Applicant: "Applicant", AcquiringParty: "Acquiring party", TargetParty: "Target", Representative: "Representative", Complainant: "Complainant", Respondent: "Respondent", OnTrack: "On track", AtRisk: "At risk", Breached: "Breached", Supports: "Supports", Neutral: "Neutral", Contradicts: "Contradicts", Sent: "Sent", Delivered: "Delivered", Read: "Read", Open: "Open", Closed: "Closed", Responded: "Responded", RepliedLate: "Replied late", MinutesApproved: "Minutes approved", NoMinutes: "No minutes", Admissible: "Admissible", Inadmissible: "Inadmissible", Held: "Held", Notified: "Notified", NotNotified: "Not notified", Completed: "Completed", Lapsed: "Lapsed", Match: "Matches the register", NameMismatch: "Name differs", Inactive: "Not in force", NotFound: "Not in the register", Unavailable: "Register unreachable", Overdue: "Overdue", Paused: "Paused", Submitted: "Submitted", AwaitingApplicant: "Awaiting applicant", Accepted: "Accepted", Investigation: "Investigation", Decision: "Awaiting decision", Decided: "Decided", Suspended: "Suspended", Withdrawn: "Withdrawn" },
    verdictHints: { Satisfied: "The requirement is met on the file", Deficient: "The requirement is not met", NeedsInformation: "Cannot be decided on what is on file", NotApplicable: "Does not apply to this case" },
    filter: { label: "Filter criteria", all: "All", awaiting: "Awaiting you", disagree: "Differ from AI", empty: "No criterion matches this filter." },
    hotkeys: "Keyboard",
    voice: { ai: "Platform", officer: "You" },
    sourcesToResolve: "{{count}} to resolve",
    resolveFromHere: "Resolve this item — upload, link a document or rule on it",
    versions: {
      title: "Version history",
      view: "Version history",
      count: "{{count}} versions", count_one: "{{count}} version",
      currentIs: "current v{{version}}",
      current: "Current",
      versionN: "Version {{version}}",
      empty: "No finding has been recorded on this criterion yet.",
      kind: { Recorded: "Recorded", Updated: "Updated", Cleared: "Cleared", Restored: "Restored" },
      fields: { Verdict: "Verdict", Note: "Response", Evidence: "Evidence" },
      changed: "changed",
      compareWith: "Compare with",
      previous: "Previous version",
      currentVersion: "Current version",
      aiAtTime: "AI at the time",
      recordedBy: "Recorded by",
      restoredFrom: "Restored from v{{version}}",
      noEvidence: "No evidence pinned.",
      immutableHint: "Versions are never edited or deleted. Restoring writes a new version; the history stays intact.",
      restore: "Restore v{{version}}",
      restoreHint: "Make version {{version}} the current finding again — recorded as a new version, with today's AI assessment.",
      restored: "Restored — recorded as v{{version}}",
    },
    previous: "Previous",
    next: "Next",
    move: "move",
    raiseIssue: "Raise an issue",
    raiseIssueHint: "Track a deficiency, a question, a risk or a follow-up against this criterion or the stage as a whole. Blocking issues hold the conclusion.",
    issues: "Issues",
    noIssues: "No open issues on this case.",
    issueKindLabel: "Kind",
    issueKind: { Deficiency: "Deficiency", Question: "Question", Risk: "Risk", FollowUp: "Follow-up" },
    severityLabel: "Severity",
    severity: { Low: "Low", Medium: "Medium", High: "High", Blocking: "Blocking" },
    blockingHint: "The stage cannot be concluded while this issue is open.",
    criterion: "Criterion",
    wholeStage: "The stage as a whole",
    detail: "Detail",
    issueRaised: "Issue raised",
    issueUpdated: "Issue updated",
    issueStatus: { Open: "Open", Resolved: "Resolved", Dismissed: "Dismissed" },
    resolve: "Resolve",
    dismiss: "Dismiss",
    reopen: "Reopen",
    resolution: "Resolution",
    resolveHint: "How the point was settled (optional).",
    dismissHint: "Why the point does not need to be pursued.",
    showClosed: "Show {{count}} closed",
    hideClosed: "Hide {{count}} closed",
    concludeStage: "Conclude the stage",
    concludeReady: "Every required criterion has a finding and no blocking issue is open.",
    concludeHint: "Choose how the case moves on and sign the rationale.",
    cannotConclude: "The stage cannot be concluded yet",
    blockers: {
      RequiredUndecided: "{{count}} required criteria have no finding yet: {{detail}}",
      BlockingIssues: "{{count}} blocking issues open: {{detail}}", BlockingIssues_one: "{{count}} blocking issue open: {{detail}}",
      NoTransition: "No transition out of this stage is available to your role at the moment.",
      Terminal: "The case is in a terminal state.",
    },
    recommendation: "Recommendation",
    aiRecommended: "{{agent}} recommends",
    departsFromAi: "Your recommendation departs from the agents' recommendation. This is recorded — the rationale should say why.",
    completionPreview: {
      title: "What the applicant will be asked",
      hint: "Concluding sends this completion request to the applicant, who has {{days}} working days to reply. The file resumes when the request is answered.",
      fromRationale: "No deficient finding or open deficiency is recorded on this stage, so your rationale below is sent as the request. Mark the deficient criteria to send itemised requests instead.",
    },
    rationale: "Rationale",
    preview: "Preview",
    signAndConclude: "Sign & conclude",
    concluded: "Stage concluded",
    agentsDispatched: "Agents dispatched: {{agents}}",
    tally: { decided: "Criteria decided", satisfied: "Satisfied / n.a.", deficient: "Deficient / need info", overrode: "AI overridden" },
    readOnlyTitle: "This stage review is closed",
    terminalTitle: "{{stage}} — nothing left to review",
    terminalHint: "The case has reached a terminal state. The stage reviews that led here are kept in the history.",
    status: { Open: "Open", Concluded: "Concluded", Superseded: "Superseded" },
    noHistory: "No stage review has been opened on this case yet.",
    followedAi: "Followed AI",
    departedFromAi: "Departed from AI",
    concludedBy: "Concluded by {{name}} ({{role}}) on {{date}}",
    openedBy: "Opened by {{name}} on {{date}}",
    findings: "Findings",
    noFindings: "No findings were recorded.",
    notConcludedYet: "Not concluded yet.",
    noRationale: "No rationale was recorded.",
    submitter: "Submitter",
    firm: "Firm",
    verifiedBy: "Verified by",
    openMandateQueue: "Open the representatives queue",
    linkedCase: "Linked case",
  },
  // Condition 3.6: beside its conclusion, the analysis sets out an alternative explanation and the evidence that would distinguish it.
  alternativeExplanation: {
    title: "Alternative explanation and the evidence that would distinguish it",
    evidence: "What would tell them apart",
    none: "The analysis sets out no alternative explanation; it cannot be approved until it does.",
  },
  analysisSections: {
    percentagePoints: "{{value}} pp",
    isic: "ISIC {{code}}",
    concentration: "Concentration (HHI · CR4)",
    cr4Post: "CR4 (post)",
    variancePp: "Δ pp",
    sections: { qualification: "Legal qualification", definition: "Market definition", structure: "Market structure", assessment: "Competitive assessment", evidence: "Evidence & scenarios", precedents: "Precedents" },
    qualificationHint: "Does the transaction transfer control, and do the parties meet the notification thresholds?",
    definitionHint: "Product and geographic dimensions of each relevant market, with the reasoning behind the boundaries.",
    structureHint: "Shares, HHI and concentration ratios – the applicant's figures side by side with what the Data Bank can verify.",
    assessmentHint: "Theories of harm, evidenced constraints, dominance and efficiencies – the effects-based assessment; the structural score is only a triage signal.",
    evidenceHint: "Sensitivity scenarios, the market's concentration history, Mergermarket activity on these parties, comparable decisions and post-decision commitments.",
    precedentsHint: "Earlier Ministry decisions and published precedents the analysis relied on.",
    linkedToDataBank: "Data Bank market",
    notLinked: "Not linked to a Data Bank market",
    definitionRationale: "Definition rationale (Market Definition & Concentration Agent)",
    noDefinitionRationale: "The agent has not yet documented why these market boundaries were chosen.",
    ssnipNote: "Relevant-market boundaries follow the Ministry's Relevant Market Definition Guidelines: demand- and supply-side substitutability tested with a small but significant non-transitory increase in price (SSNIP).",
    marketSize: "Market size",
    parties: "Parties in this market",
    competitorsListed: "Competitors listed",
    declaredSharesHint: "As declared by the applicant. The parties are highlighted.",
    declaredVsVerified: "Declared vs verified shares",
    declaredVsVerifiedHint: "OECD practice: the undertaking self-reports its share and the authority verifies it against its own data. Each verified figure carries its source and confidence.",
    declaredCombined: "Declared combined",
    verifiedCombined: "Verified combined",
    undertaking: "Undertaking",
    declared: "Declared",
    verified: "Verified",
    source: "Source",
    party: "Party",
    curated: "Curated",
    applicantOnly: "Applicant figure only",
    verification: { Verified: "Verified", Discrepancy: "Discrepancy", Unverified: "Unverified", DataBankOnly: "Data Bank only" },
    sourcesUsed: "Sources used",
    noneIdentified: "None identified.",
    noneClaimed: "None claimed.",
    efficiencies: "Efficiencies claimed",
    efficienciesTest: "Efficiencies test",
    efficienciesTestHint: "Each claim on its three limbs – verifiable, merger-specific, passed on – as the rules engine ran it. Only credited marginal-cost savings are set against the CMCR; a narrative claim is not tested and carries no weight.",
    narrativeOnlyEfficiencies: "Efficiencies are claimed in narrative only. They cannot be tested for verifiability, merger-specificity or pass-through and are not credited – ask the parties for each saving with type, amount, timing, evidence, merger-specificity and pass-through.",
    claim: "Claim",
    verifiable: "Verifiable",
    mergerSpecific: "Merger-specific",
    passedOn: "Passed on",
    credited: "Credited",
    creditedTotal: "Credited marginal-cost savings",
    requiredCmcr: "CMCR required",
    shortfall: "Shortfall",
    cmcrComparison: "Against the compensating marginal-cost reduction",
    capabilitiesReading: "Capabilities reading",
    stillNeeded: "Still needed from the parties",
    cognisable: "Cognisable",
    notCognisable: "Not cognisable",
    notTimely: "Beyond 24 months",
    ofMarginalCost: "of marginal cost",
    months: "{{count}} months",
    verdicts: { Yes: "Yes", Partial: "Partial", No: "No" },
    cmcrVerdicts: { ReachesCmcr: "Reaches CMCR", ShortOfCmcr: "Short of CMCR", NoQuantifiedMarginalClaim: "No quantified marginal-cost claim", NoCmcr: "No pricing-pressure screen" },
    efficiencyTypes: { MarginalCost: "Marginal cost", FixedCost: "Fixed cost", Procurement: "Procurement", Distribution: "Distribution", Quality: "Quality", Innovation: "Innovation", Other: "Other" },
    dominance: "Dominance test",
    dominanceHint: "A share above {{share}} establishes a dominant position (Decree-Law Article 6(2)(a); Cabinet Decision No. 3 of 2025, Article 2).",
    overall: "Overall assessment",
    precedentsSource: "Sanitised decisions in the legal knowledge base (published by the Ministry or issued in the platform) ranked by relevance to this case's markets, plus the precedents the analysis cited.",
    precedentCorpus: "{{count}} precedents in the corpus", precedentCorpus_one: "{{count}} precedent in the corpus",
    citedByAgent: "Cited by the analysis",
    noPrecedents: "No precedents yet. Import the Ministry's published decisions into the legal knowledge base; decisions issued here are added automatically.",
    dealIntelligence: {
      title: "Related Mergermarket activity",
      hint: "Licensed deal intelligence on these parties — comparable transactions, announced value and other-regulator events. It verifies the notification; it is not a finding of harm.",
      empty: "No replica row is attached or suggested for these parties yet. Search the catalog if a public announcement is expected.",
      onFile: "On this file",
      suggested: "Suggested from the replica",
      news: "Related news",
      overlap: "Matches",
      link: "Link to this case",
      linked: "Deal linked to this notification",
      open: "Open in Deal Watch",
      relation: { Linked: "Linked", Escalated: "Ex officio source", Suggested: "Suggested" },
    },
  },
  investigations: {
    dataPoints: {
      bid_spread_pct: "Bid spread %", repeat_pattern_count: "Repeated in earlier tenders", combined_share_pct: "Combined share %", days_between: "Days between changes",
      delta_pct: "Price change %", composite_score: "Composite score", flagged_tenders: "Flagged tenders", rotation_index: "Rotation index %",
      forensic_overlaps: "Document overlaps", divergence_points: "Divergence (points)", change_correlation: "Change correlation", acquisitions: "Acquisitions",
      cumulative_share_points: "Share added (points)", not_notified: "Not notified",
    },
    title: "Investigations",
    subtitle: "Complaints by procedural stage, the whistleblowing inbox and the Market Monitor's signals. Open a card for the investigation board: plan, evidence matrix, information requests and field visits.",
    board: "Complaints board",
    whistleblowing: "Whistleblowing inbox",
    signals: "Market signals",
    source: "Source",
    sources: { Individual: "Individual report", Ministry: "Ministry", MarketMonitor: "Market Monitor", Mergermarket: "Deal Watch (Mergermarket)", Regulator: "Other regulator", Referral: "Referral from another section" },
    anonymous: "Anonymous",
    noReports: "No whistleblowing reports",
    noReportsHint: "Reports filed through the portal (anonymous or identified) and signals escalated from the Market Monitor appear here.",
    signalsHint: "Patterns detected in the market feed, tenders and the Data Bank – price parallelism, suspicious bid spreads, share jumps, RPM indicators. Signals are prioritisation aids, not findings.",
    lastScan: "Last scan",
    pendingSignals: "{{count}} scans awaiting review in the AI Inbox", pendingSignals_one: "{{count}} scan awaiting review in the AI Inbox",
    runScan: "Run scan now",
    scanQueued: "Market Monitor scan queued",
    scanQueuedHint: "Detected signals arrive as a proposal for the Head of Complaints in the AI Inbox.",
    signalFilters: { active: "Active", Escalated: "Escalated", Dismissed: "Dismissed", all: "All" },
    signalMethod: { score: "Signal score {{score}}/100", unscored: "Not scored – no screen or rule scores this signal" },
    signalTypes: { PriceParallelism: "Price parallelism", TenderPattern: "Tender pattern", ShareJump: "Share concentration", ResalePriceSignal: "RPM indicator", ComplaintCluster: "Complaint cluster", NewsMention: "Transaction announced", UnnotifiedConcentration: "Unnotified concentration", StandstillBreach: "Implemented before clearance", ExpectedConcentration: "Notification expected" },
    signalLead: { lead: "A lead for inquiry, not evidence.", alternative: "Alternative explanation" },
    signalStatuses: { New: "New", UnderReview: "Under review", Escalated: "Escalated", Dismissed: "Dismissed" },
    noSignals: "No signals",
    noSignalsHint: "Run a scan or wait for the daily Market Monitor job.",
    markReview: "Mark under review",
    openReport: "Open whistleblowing case",
    openReportHint: "Creates a Workflow 6 case with detection source \"Market Monitor\" and links the signal to it.",
    officerNote: "Officer note",
    dismiss: "Dismiss",
    dismissTitle: "Dismiss the signal",
    dismissReasons: "Why the signal is dismissed",
    dismissReasonsHint: "In your own words, at least 20 characters: what you checked and why it raises no competition concern. The reasons are kept with the signal and in the audit trail.",
    dismissConfirm: "Dismiss with these reasons",
    reopen: "Reopen",
    escalated: "Whistleblowing case {{caseNumber}} opened",
    stages: { Received: "Received", FormalCheck: "Formal examination", AwaitingComplainant: "Awaiting complainant", PartiesNotification: "Parties notified ({{period.complaint.response}} working days)", Investigation: "Under investigation", PreliminaryReportShared: "Preliminary report shared", FinalReport: "Final report", Escalation: "Escalation", MinisterDecision: "Minister's decision", Decided: "Decided", RejectOrSuspend: "Reject or suspend", Suspended: "Suspended" },
  },
  dealWatch: {
    dealTypeNames: { Acquisition: "Acquisition", Merger: "Merger", "In talks": "In talks", "Minority stake": "Minority stake", "Mandated advisers": "Mandated advisers", "Private equity buyout": "Private equity buyout", "For sale": "For sale", "Private placement": "Private placement", "Private equity exit": "Private equity exit", Intelligence: "Intelligence" },
    countryNames: { ARE: "UAE", SAU: "Saudi Arabia", DEU: "Germany", CYM: "Cayman Islands", EUR: "Europe", CAN: "Canada", USA: "United States", GBR: "United Kingdom", FRA: "France", IND: "India", CHN: "China", JPN: "Japan", KWT: "Kuwait", QAT: "Qatar", OMN: "Oman", BHR: "Bahrain", EGY: "Egypt", NLD: "Netherlands", CHE: "Switzerland", SGP: "Singapore" },
    currencyNames: { USD: "USD", EUR: "EUR", GBP: "GBP", SAR: "SAR" },
    amountInMillions: "{{currency}} {{amount}} m",
    tab: "Deal Watch",
    enter: {
      action: "Enter a transaction",
      title: "Enter a transaction by hand",
      hint: "A transaction the deal-intelligence catalogue does not carry: a press report, a tip, another authority's notice, or a reference transaction set by the Department. It is screened like a catalogue deal – UAE nexus, change of control, the Article 12 thresholds, a matching notification – and reviewed in the same way.",
      dealTitle: "Title",
      type: "Type",
      types: { Acquisition: "Acquisition", Merger: "Merger", JointVenture: "Joint venture", MinorityStake: "Minority stake", AssetPurchase: "Asset purchase" },
      status: "Status",
      statuses: { Live: "Live", Completed: "Completed", Lapsed: "Lapsed" },
      announcedOn: "Announced on",
      expectedCloseOn: "Expected to close on",
      completedOn: "Completed on",
      valueAed: "Value (AED)",
      stake: "Stake (%)",
      parties: "Parties",
      role: "Role",
      roles: { Bidder: "Acquirer", Target: "Target", Seller: "Seller", Party: "Other party" },
      partyName: "Name of the undertaking",
      country: "Country (ISO code)",
      addParty: "Add a party",
      removeParty: "Remove the party",
      source: "Where it was learned of",
      sourceHint: "A press report, a complaint, another authority, a reference file.",
      sourceReference: "Reference",
      description: "Description",
      submit: "Enter and screen",
      saved: "Transaction {{id}} entered and screened.",
      entered: "Entered by an officer",
    },
    deal: "Deal",
    hint: "M&A deals reported by Mergermarket (ION Analytics), screened by the platform for a UAE nexus, a change of control (Article 1), the Article 12 thresholds and a matching notification in the register. Candidates are prioritisation aids: the Ministry verifies turnover with the FTA and control with the registry before writing to anyone.",
    mode: { Simulator: "Test feed – Mergermarket not connected", Live: "Live feed", Web: "Live feed (web)" },
    lastSync: "Last sync",
    neverSynced: "Not synchronised yet",
    pendingProposals: "{{count}} Deal Watch assessments awaiting review in the AI Inbox", pendingProposals_one: "{{count}} Deal Watch assessment awaiting review in the AI Inbox",
    syncNow: "Sync now",
    syncQueued: "Mergermarket sync queued in the background",
    syncDone: "Sync complete – fetched: {{fetched}}, candidates: {{candidates}}, new: {{fresh}}",
    syncPartial: "Sync finished with errors – fetched: {{fetched}}, candidates: {{candidates}}, new: {{fresh}}; what failed is listed below",
    stats: { total: "Deals on record", intelligence: "{{count}} intelligence items", intelligence_one: "{{count}} intelligence item" },
    closingSoon: "Closing soon",
    closingSoonHint: "Expected close within {{days}} days, or already overdue",
    closingInDays: "in {{count}}d",
    closedDaysAgo: "{{count}}d overdue",
    overdueClose: "Expected close has passed; the provider still reports the deal as live.",
    statusFilter: "Any stage",
    nexusFilter: "Any nexus",
    sortBy: "Sort",
    sort: { score: "Highest score", value: "Largest value", announced: "Newest announced", expectedClose: "Closest close", completed: "Newest completed" },
    minScore: "Any score",
    minScoreValue: "{{count}}+",
    estimatedOnly: "Estimated values",
    clearFilters: "Clear extra filters",
    filterBy: "Technique filter",
    keyboardHint: "↑ ↓ to move between deals",
    prevDeal: "Previous deal",
    nextDeal: "Next deal",
    copyId: "Copy id",
    copied: "Mergermarket id copied",
    techniques: "Techniques",
    providerStatus: "Provider status",
    latestActivity: "Latest activity",
    domestic: "Domestic",
    unsolicited: "Unsolicited",
    timeline: "Deal timeline",
    economics: "Consideration",
    equityValue: "Equity value",
    drawer: { overview: "Facts", parties: "Parties", screening: "Screening", provider: "Mergermarket" },
    filing: { FailureToNotifyCandidate: "Failure to notify", StandstillBreachCandidate: "Standstill breach", NotYetDue: "Watch – not yet due", Filed: "Notified", OutOfScope: "Out of scope" },
    review: { New: "New", UnderReview: "Under review", Dismissed: "Dismissed", Linked: "Linked to notification", Escalated: "Escalated" },
    filingFilters: { candidates: "Candidates", FailureToNotifyCandidate: "Failure to notify", StandstillBreachCandidate: "Standstill", NotYetDue: "Watch", Filed: "Notified", OutOfScope: "Out of scope", all: "All deals" },
    reviewFilters: { active: "Open", Escalated: "Escalated", Linked: "Linked", Dismissed: "Dismissed", all: "Any status" },
    searchPlaceholder: "Search deal, party, Mergermarket id or case number…",
    catalogEmpty: "No replica or live matches yet. Try a company name or a numeric Mergermarket id.",
    catalogLive: "Live web",
    catalogKind: { Deal: "Deal", News: "News", Company: "Company", Intelligence: "Intelligence" },
    refreshFromProvider: "Refresh from Mergermarket",
    refreshed: "Deal refreshed from the licensed web session",
    companyLookup: "Mergermarket company",
    companyIntel: "{{count}} related articles", companyIntel_one: "{{count}} related article",
    relatedDeals: "Related deals on record",
    relatedNews: "Related news on record",
    empty: "No deals match",
    emptyHint: "Run a sync to pull the latest UAE-nexus deals from Mergermarket, or widen the filters.",
    columns: { score: "Screening score", deal: "Deal", filing: "Register", screen: "Screen", dates: "Dates", value: "Value", review: "Review" },
    rowCount: "{{count}} deals shown", rowCount_one: "{{count}} deal shown",
    recordCount: "{{count, number}} records from the provider", recordCount_one: "{{count}} record from the provider",
    roles: { Acquirer: "Acquirer", Bidder: "Acquirer", Target: "Target", Vendor: "Seller", Seller: "Seller" },
    verdictGroups: { nexus: "Nexus", control: "Control", threshold: "Thresholds" },
    nexus: { UaeParty: "UAE party", UaeSubsidiary: "UAE subsidiary", UaeTurnover: "UAE turnover", UaeGeography: "UAE geography", None: "None" },
    control: { Acquired: "Acquired", Possible: "Possible", NotAcquired: "Not acquired", Unknown: "Unknown" },
    threshold: { Met: "Met", NotMet: "Not met", Unknown: "Pending – figures missing" },
    noFigures: "No UAE turnover or market-share figures available for the parties yet.",
    announced: "Announced",
    completed: "Completed",
    expectedClose: "Expected close",
    estimated: "Estimated",
    openOnMergermarket: "Open on Mergermarket",
    enterpriseValue: "Enterprise value",
    stakeExact: "Exact stake",
    settlement: "Settlement",
    status: { Live: "Announced", Completed: "Completed", Lapsed: "Lapsed", Intelligence: "Intelligence" },
    undisclosed: "Undisclosed",
    openCase: "Open case",
    agentAssessed: "Agent assessed",
    screenedAt: "screened",
    escalate: "Open ex officio case",
    escalateHint: "Creates a Workflow 6 case with detection source \"Deal Watch (Mergermarket)\", records the market signal and links the deal to it. The case carries the conduct type and the Article 25/26 penalty range.",
    escalateBasis: { unnotified: "A completed concentration that appears to meet the Article 12 thresholds with no notification in the register (Article 25: fine of 2–10% of UAE sales, or AED 500,000–5,000,000 where sales cannot be established).", standstill: "A concentration implemented before the Minister's decision or against it (Article 26: AED 50,000–500,000; the concentration itself may also be unnotified)." },
    link: "Link to notification",
    linkHint: "Identify the economic concentration notification this deal corresponds to; the filing verdict is recomputed from that case and the deal drops off the candidate list if it was properly notified.",
    linkConfirm: "Link",
    registerSearch: "Search the register by case number or title…",
    linked: "Deal linked to {{caseNumber}}",
    escalated: "Ex officio case {{caseNumber}} opened",
    dismissTitle: "Dismiss deal",
    dismissHint: "The deal stays on record with your note; it can be reopened if new facts appear.",
    dismissPlaceholder: "Why this deal is not a notifiable concentration (no nexus, no control, thresholds unmet, already notified under case …)",
    dismissReasonsHint: "State the reasons in a sentence at least; they are recorded with the dismissal.",
    dismissOverrideTitle: "Dismissing this deal overrides a finding of the platform",
    dismissOverrideBody: "The screening flags the deal as a candidate. Only an officer authorised to override the platform's findings may dismiss it; your reasons are recorded as that override in the deal's history and the audit trail.",
    openProposal: "Agent assessment",
    reviewerRole: "Only the Head of Complaints, the Director or an Economic Researcher may review Deal Watch candidates.",
    reviewNote: "Officer note",
    stake: "Stake acquired",
    combinedTurnover: "Combined UAE turnover",
    combinedShare: "Combined market share",
    countries: "Countries",
    party: "Party",
    role: "Role",
    country: "Country",
    resolvedEntity: "Data Bank entity",
    uaeTurnover: "UAE turnover",
    unresolved: "Not resolved",
    viaSubsidiary: "via",
    registerCheck: "Register check",
    noFilingFound: "No economic concentration notification matches this deal in the Ministry's register.",
    noFilingNeeded: "No notification is required on the current screen (or the deal has not yet completed).",
    otherJurisdictions: "Merger review in other jurisdictions",
    reviewPhases: { PhaseI: "Phase I", PhaseII: "Phase II", Substantivereview: "Substantive review" },
    reviewOutcomes: { Cleared: "Cleared", ClearedWithConditions: "Cleared with conditions", Prohibited: "Prohibited", Withdrawn: "Withdrawn", Pending: "Pending" },
    factors: "Score factors",
    signal: "Market signal",
    proposal: "AI proposal",
    exOfficioCase: "Ex officio case",
    rawRecord: "Provider record (JSON)",
    openNews: "Open News",
    lastMonth: "Last 31 days",
    scoreName: "Screening score {{score}} of 100",
    scoreMeaning: "Points the screening rules give a deal for filing signs, size and overlap; a lead for review, not a finding.",
  },
  news: {
    subtitle: "Market and deal intelligence for the Competition Department. Every card shows its publisher and a link to the original. Mergermarket is one source; UAE press (The National, Khaleej Times, Zawya) and the market feed are others.",
    item: "Article",
    lastSync: "Last sync",
    neverSynced: "Not synchronised yet",
    syncNow: "Sync now",
    syncQueued: "News sync queued in the background",
    syncDone: "Sync complete – fetched: {{fetched}}, new: {{inserted}}, updated: {{updated}}",
    syncPartial: "Sync finished with errors – fetched: {{fetched}}, new: {{inserted}}, updated: {{updated}}; what failed is listed below",
    allSources: "All sources",
    searchPlaceholder: "Search headline or Mergermarket id…",
    empty: "No articles match",
    emptyHint: "Run a sync to pull Mergermarket intelligence and the market feed, or widen the filters.",
    companies: "Companies",
    relatedDeal: "Related Deal Watch item",
    openDealWatch: "Open in Deal Watch",
    openSource: "Open original",
    noUrl: "No publisher URL on this row",
    hasDeal: "Linked to a screened deal",
    lastMonth: "Last 31 days",
    lastMonthMergers: "Last month’s UAE mergers (publisher pages)",
    topCompanies: "Largest UAE undertakings",
    topCompaniesHint: "Open-data master (ADX, DFM, GLEIF, Forbes ME, Wikipedia) — source and URL on every card",
    stats: {
      total: "Articles",
      today: "{{count}} published today",
      lastMonth: "{{count}} in the last 31 days",
      intelligence: "{{count}} intelligence items", intelligence_one: "{{count}} intelligence item",
      market: "{{count}} market-feed items", market_one: "{{count}} market-feed item",
      deals: "Deal announcements",
      dealsHint: "Completed and live Mergermarket deals as news cards",
    },
    sources: {
      mergermarket: "Mergermarket",
      marketfeed: "Market feed",
      news: "News",
      wam: "WAM",
      thenational: "The National",
      gulfnews: "Gulf News",
      khaleejtimes: "Khaleej Times",
      zawya: "Zawya",
      bbc: "BBC",
      wikipedia: "Wikipedia",
      wikidata: "Wikidata",
      "forbes-me": "Forbes Middle East",
      adx: "ADX",
      dfm: "DFM",
      gleif: "GLEIF",
      "open-data-master": "UAE company master",
    },
    kinds: {
      Intelligence: "Intelligence",
      Deal: "Deal",
      Market: "Market",
      Press: "Press",
    },
  },
  enforcement: {
    title: "Enforcement assessment",
    hint: "Articles 25–27 of Federal Decree-Law No. 36 of 2023: the statutory fine range is computed from the sales basis and the article; the case team weighs the circumstances and proposes an outcome; the officer the outcome belongs to approves and signs. A referral to prosecution is the Minister's alone (Article 33).",
    prefilled: "Prefilled – not saved",
    saveDraft: "Save draft",
    saved: "Assessment saved",
    articleShort: "Art. {{n}}",
    openDeal: "Open in Deal Watch",
    facts: "The concentration",
    factsHint: "Who acquired control of whom, when it was implemented and when the Ministry discovered it; the threshold basis the Article 12 obligation rests on.",
    article: "Violation",
    undertaking: "Undertaking liable",
    undertakingAr: "Undertaking (Arabic)",
    target: "Target / other party",
    thresholdBasis: "Threshold basis",
    thresholdBasisHint: "e.g. combined UAE turnover AED 1.2 bn (Article 12(1)(a)) or combined share 45% in retail pharmacy (Article 12(1)(b)).",
    implementedOn: "Implemented on",
    discoveredOn: "Discovered on",
    salesBasis: "Sales basis (Article 25)",
    salesBasisOnFile: "Sales basis on file",
    salesBasisHint: "The UAE sales of the goods or services concerned in the last financial year, from the FTA return or the audited accounts obtained through the request for information. The Data Bank's total turnover is a different measure: it is quoted in the note for reference and never entered here. Without a figure the fixed AED 500,000–5,000,000 range applies.",
    salesAed: "UAE sales of the goods concerned (AED)",
    salesUnknown: "Not established – fixed range applies",
    salesYear: "Financial year",
    salesSource: "Source",
    salesSources: { FTA: "Federal Tax Authority (corporate-tax return)", Filing: "Parties' declaration (notification / RFI reply)", DataBank: "Data Bank", Estimate: "Ministry estimate" },
    salesNote: "Note on the basis",
    fallbackTitle: "Fixed range in force",
    fallback: "fixed range",
    circumstances: "Circumstances",
    circumstancesHint: "Tick what the file establishes. Each circumstance moves the indicative settlement amount between the Article 33(2) floor and the statutory maximum; the weights are guidance, not arithmetic the decision is bound by.",
    aggravating: "Aggravating",
    mitigating: "Mitigating",
    aggravatingNote: "Aggravating – note",
    mitigatingNote: "Mitigating – note",
    outcome: "Proposed outcome",
    outcomeHint: "The fines of Articles 24–27 are criminal and imposed by a court. A warning letter (no penalty) is the Director's; a settlement proposal under Article 33(2) needs the Under-Secretary; the request for the criminal action is reserved to the Minister, although Article 33(1) allows him to authorise a representative. The rules' indication is shown for comparison.",
    indicated: "Indicated",
    approvedBy: "Approved by {{role}}",
    proposedFine: "Proposed settlement amount (AED)",
    indicativeFine: "Rules indicate {{amount}}",
    useIndicative: "Use indicative",
    fineOutOfRange: "Outside the settlement range {{min}} (double the minimum fine) – {{max}}",
    settlementFloor: "Settlement floor (Article 33(2))",
    settlementFloorHint: "A settlement may not be concluded for less than double the minimum fine; a court fines within the range above.",
    referralTitle: "Request for the criminal action (Article 33(1))",
    referralHint: "The memorandum sets out the facts, the evidence of concealment or repeat conduct and the settlement that would otherwise have been proposed; no settlement is proposed alongside it.",
    rationale: "Rationale",
    rationaleHint: "Why this outcome: the concentration and its thresholds, how the circumstances were weighed, and proportionality. Becomes the reasoning of the decision instrument.",
    rationaleAr: "Rationale (Arabic)",
    range: "Statutory range (court fine)",
    min: "Minimum",
    max: "Maximum",
    indicative: "indicative",
    proposed: "proposed",
    indicativeAmount: "Indicative settlement",
    netWeight: "Net weight",
    rulesIndicate: "Rules indicate: {{outcome}}",
    referralWorth: "The circumstances (repeat conduct, concealment) make the criminal action worth putting to the Minister instead of a settlement.",
    chain: {
      title: "Recommendation & approval",
      hint: "Case team drafts → Head of Complaints recommends → {{role}} approves → the approver signs the decision instrument.",
      draft: "Assessment drafted",
      recommended: "Recommended",
      approved: "Approved by {{role}}",
      issued: "Decision issued",
    },
    decision: "Decision instrument",
    notified: "parties notified",
    unsaved: "Save the assessment before recommending or approving it.",
    saveFirst: "Save the draft to open the recommendation.",
    awaitingApprover: "Awaiting approval by {{roles}}.",
    awaitingSigner: "Approved – the decision is signed by {{roles}}.",
    // Scenario 6.40: the penalty calculation stays off until the Department records the legal confirmation of its basis; a second officer approves.
    penaltyBasis: {
      offTitle: "The penalty calculation is not enabled",
      onTitle: "Legal basis of the calculation confirmed",
      confirmedBy: "{{reference}} – recorded by {{name}}, {{date}} (method {{version}})",
      covers: "What the confirmation covers",
      reference: "Reference of the legal opinion or memorandum, with its date",
      referenceAr: "Reference in Arabic",
      note: "Note (optional)",
      confirm: "Record the legal confirmation",
      confirmed: "Legal confirmation recorded",
      secondOfficer: "You drafted or recommended this assessment: a second authorised officer approves it.",
    },
    recommend: "Recommend",
    recommendHint: "Puts the assessment ({{outcome}}) to {{role}} for approval. The draft is locked while it is under approval.",
    recommended: "Assessment recommended",
    approve: "Approve",
    approveHint: "Approves the proposed outcome ({{outcome}}); the decision instrument can then be issued.",
    approved: "Assessment approved",
    return: "Return for revision",
    returnHint: "Sends the assessment back to the case team with your note; the draft is unlocked.",
    returned: "Assessment returned",
    issue: "Issue decision",
    issueHint: "Issues {{outcome}} as a {{instrument}} on this case, with the assessment's rationale as its reasoning, and advances Workflow 6 to Decided.",
    issued: "Decision {{number}} issued",
    decisionTitle: "Decision title",
    decisionTitleHint: "Leave empty to use the standard title for the outcome.",
    decisionTitleAr: "Decision title (Arabic)",
    notifyParties: "Notify the parties on issue",
    issueReferralHint: "The referral decision is internal: the parties are informed by the Public Prosecution, not by the Ministry's notification.",
    note: "Note",
    letters: {
      title: "Letters",
      hint: "The request for information opens the file with the parties (Article 27 applies to the reply); the warning letter, the settlement proposal and the memorandum on the criminal action follow the approved outcome.",
      none: "No enforcement letters on this case yet.",
      kinds: { rfi: "Request for information", warning: "Warning letter", fine: "Settlement proposal", referral: "Memorandum on the criminal action" },
      kindHints: {
        rfi: "Asks the undertaking to confirm the transaction, the control acquired, the UAE turnover and sales of the goods concerned, and any filings elsewhere.",
        warning: "Warning letter – not a penalty – with the direction to notify (or unwind) within the period stated (Regulations Article 18(1)).",
        fine: "Proposes the settlement under Article 33(2): the amount, the acknowledgment of the offence, payment within {{period.enforcement.settlementPayment}} working days and what follows a refusal (Regulations Article 27).",
        referral: "Internal memorandum recommending that the Minister request the criminal action (Article 33(1)); filed on the case, not sent to the parties.",
      },
      responseDays: "reply within {{n}} days",
      subject: "Subject",
      preview: "Preview",
      send: "Send",
      file: "File on the case",
      sent: "Letter sent",
      filed: "Memorandum filed on the case",
      due: "reply due {{date}}",
      letterStatus: { Draft: "Draft", PendingApproval: "Awaiting confirmation", Approved: "Approved", Sent: "Sent", Delivered: "Delivered", Failed: "Failed", Cancelled: "Cancelled" },
      rfiStatus: "Request for information",
      rfiDue: "Reply due {{date}}",
      rfiAnswered: "Replied {{date}}",
      rfiItems: "{{answered}}/{{total}} items answered",
      outcomeLettersAfterRecommendation: "The warning, fine notice and referral memorandum become available once the assessment is recommended.",
    },
  },
  representatives: {
    tab: "Representatives",
    subtitle: "Mandates lodged by law firms and advisers to act for undertakings. Open the power of attorney, check the signatory against the licence, and verify, reject or revoke. A representative may already have filed under a pending mandate.",
    filters: { pending: "Pending verification", verified: "Verified" },
    searchPlaceholder: "Search representative, firm, undertaking or licence…",
    empty: "No mandates",
    emptyHint: "Nothing lodged under this filter.",
    representative: "Representative",
    undertaking: "Acts for",
    noFirm: "No firm recorded",
    lowerAssurance: "E-mail sign-in",
    lodgedOn: "lodged {{date}}",
    grantor: "Granted by",
    validity: "Validity",
    openEnded: "open-ended",
    poa: "Power of attorney",
    noPoa: "no document attached",
    casesFiled: "{{count}} cases filed under this mandate", casesFiled_one: "{{count}} case filed under this mandate",
    verify: "Verify",
    verifyHint: "Confirms the power of attorney is genuine and the signatory authorised; the representative is notified.",
    verifyAnyway: "Verify on new evidence",
    reject: "Not accepted",
    rejectHint: "Stops new filings by this representative for the undertaking until a corrected power of attorney is lodged; the reason is sent to the representative.",
    revoke: "Revoke",
    revokeHint: "Ends the mandate. Cases already filed remain on record; new filings need a new mandate.",
    revoked: "Revoked",
    reason: "Reason (sent to the representative)",
    validUntil: "Valid until",
    validUntilHint: "Leave empty to keep the date on the power of attorney, or none.",
    badge: "Representative",
    badgeHint: "Filed by {{name}} ({{firm}}) under a mandate: {{status}}. Click to open the Representatives queue.",
    badgeNoMandateHint: "Filed by {{name}}, who is neither a member of the undertaking nor holds a mandate for it.",
    status: { Pending: "Pending verification", Verified: "Verified", Rejected: "Not accepted", Revoked: "Revoked", Expired: "Expired", None: "No mandate" },
  },
  screening: {
    tab: "Screening",
    subtitle: "Filings the control test flagged as \"notification does not appear required\" – and filings whose applicant contested that result. Confirm and return them, or admit them to the initial review.",
    empty: "Nothing to screen",
    emptyHint: "Every filing passed the control test and entered the normal intake.",
    contested: "Contested by applicant",
    acknowledged: "Notice acknowledged",
    thresholdsNotMet: "Neither the {{turnover}} sales-in-the-relevant-market threshold nor the {{share}} share threshold is met.",
    applicantSays: "Applicant's reasons",
    confirmReturn: "Confirm: not notifiable – return",
    returnHint: "The Correspondence Agent drafts the 'application returned' letter for your approval; the fee stays non-refundable.",
    proceed: "Notifiable – proceed",
    proceedHint: "The application enters the initial review (Article 10 checklist) like any other filing.",
    badge: "Screening",
    returned: "Returned",
    badgeHint: "The deterministic control test found that notification does not appear required (or the applicant contested the result). See the legal qualification panel.",
  },
  briefSafeguards: {
    title: "Safeguards before the Minister",
    hint: "What the brief carries to the Minister from the records: the independent reviewer's verdict on the approved report, each reservation or dissent with the Department's answer, and the Committee's opinion as adopted. The brief is approved only when every point has an answer in the case team's own words.",
    peer: "Independent review",
    noPeer: "No independent review of the approved report is on file.",
    notIndependent: "Recorded with a declared conflict",
    verdicts: { Concur: "Concurs", ConcurWithReservations: "Concurs with reservations", Dissent: "Dissents" },
    points: "Points the Department must answer ({{count}})",
    answer: "Department's answer",
    answerHint: "Answer the point itself – accept it, explain why the report stands, or say what changes – in at least {{min}} characters. A mention is not an answer.",
    suggested: "Suggested by the draft",
    useSuggestion: "Start from this",
    unanswered: "No answer yet – the brief cannot go to the Minister.",
    committee: "Opinion of the Competition Regulation Committee",
    outcomes: { Approve: "Approval", ApproveWithConditions: "Approval with conditions", Prohibit: "Prohibition", RequestMoreInfo: "Further analysis requested" },
    tally: "{{votesFor}} of {{total}} votes",
    differs: "Differs from the Department's recommendation",
    committeePending: "Referred – the Committee's opinion is not yet adopted.",
    notReferred: "Not referred to the Committee; the brief says so.",
    notReferredRequired: "Not referred, although the recommendation attaches conditions or prohibits – the brief flags it for the Minister.",
    approve: "Approve the brief with these answers",
    approved: "Brief approved with the Department's answers.",
  },
  investigationReport: {
    title: "Review report",
    intro: "The Ministry's report on the economic concentration. The agent drafts each passage in Arabic with an English mirror; you accept, edit or override it section by section before finalising.",
    none: "No review report drafted yet",
    noneHint: "Draft the full substantive review, or the short report for a concentration whose notification thresholds are not met.",
    draftSubstantive: "Draft the substantive review report",
    draftThresholds: "Draft the thresholds-unmet report",
    drafting: "The report is being drafted",
    draftingHint: "The agent's steps stream on the Agents tab; the draft appears here when it finishes.",
    redraft: "Redraft with the agent",
    recommendation: "Recommendation",
    recommendations: { Approve: "Approve", ApproveWithConditions: "Approve with conditions", Prohibit: "Do not approve", NotNotifiable: "Thresholds not met — not notifiable" },
    variants: { SubstantiveReview: "Substantive review (Art. 13(2))", ThresholdsUnmet: "Thresholds unmet (Art. 13(3))" },
    reviewTitle: "Human-plus-AI review",
    reviewHint: "{{count}} sections still need your decision before the report can be finalised.", reviewHint_one: "{{count}} section still needs your decision before the report can be finalised.",
    reviewHintDone: "Every drafted section has been accepted or overridden; the report can be finalised.",
    accepted: "Accepted",
    override: "Edit / override",
    writePassage: "Write the passage",
    applyOverride: "Apply override",
    emptySection: "The agent left this section empty — write it yourself before finalising.",
    finalise: "Finalise the report",
    finaliseHint: "Approves the draft and attaches the Arabic PDF and the editable Word version to the case file.",
    finaliseBlocked: "Accept or override the remaining {{count}} sections first.", finaliseBlocked_one: "Accept or override the remaining {{count}} section first.",
    finalised: "Report finalised and attached to the case file",
    finalisedBadge: "Finalised",
    finalisedHint: "The approved version is on the Documents tab in Arabic and in its English mirror, as PDF and Word. Redraft with the agent to produce a new version.",
    attachRenderings: "Attach renderings",
    renderingsAttached: "Attached to the file: {{files}}",
    renderingsUpToDate: "The approved version is already on file in Arabic and English, as PDF and Word.",
    versionAr: "Arabic version", versionEn: "English version", word: "Word",
    stateHint: "The case is in {{state}}; the report is normally written in the assessment stage or before the Under-Secretary's decision.",
    modeGuided: "Guided review",
    modeList: "All sections",
    progress: "{{done}} of {{total}} passages reviewed",
    overriddenCount: "{{count}} overridden",
    move: "move",
    stepOf: "step {{n}} of {{total}}",
    loadBearing: "Carries the recommendation",
    overridden: "Overridden",
    acceptAgain: "Keep accepted",
    previous: "Previous",
    skip: "Skip for now",
    emptySectionHint: "Write this passage yourself, or redraft the report with the agent.",
    evidenceTitle: "What the figures say",
    evidenceCaption: "Computed by the platform's rules engine from the case file. The agent cannot change these; if one looks wrong, the filing or the market data is wrong.",
    noEvidence: "No computed figure bears on this passage — it rests on the documents and the officer's own reading.",
    summaryTitle: "Everything in one place before you sign",
    summaryHint: "The Department's recommendation, the passages you accepted or rewrote, and the figures the decision will rest on.",
    awaitingYou: "Awaiting you",
    stillOpen: "Passages still awaiting your decision",
    allReviewed: "Every passage has been reviewed",
    allReviewedHint: "Finalising approves the report and attaches the Arabic PDF and the editable Word version to the case file.",
    blanksTitle: "{{count}} passages left blank by the agent", blanksTitle_one: "{{count}} passage left blank by the agent",
    blanksHint: "A blank passage is simply omitted from the printed report. Write it if the Department's template requires it.",
    keyFigures: "Key figures",
    variantLabel: "Report type",
    reasons: "Your reasons for this recommendation",
    reasonsPlaceholder: "What you checked and what the recommendation rests on, in your own words.",
    reasonsHint: "Recorded with your approval and shown in the case journal – at least {{count}} characters ({{typed}} so far); a passage copied from the draft is refused.",
    reasonsBlocked: "State your own reasons for the recommendation first.",
    chapters: {
      header: "Header",
      parties: "§1 Undertakings",
      jurisdiction: "§2 Competence",
      test1: "§2.1 Legal test (1)",
      test2: "§2.2 Legal test (2)",
      nature: "§3 Nature",
      assessment: "§4 Assessment",
      harm: "§4 Theory of harm",
      observations: "§5 Observations",
      summary: "Sign-off",
    },
    capacities: { Acquirer: "Acquirer", Target: "Target", JointVenturePartner: "JV partner", Notifying: "Notifying party", Other: "Other party" },
    natures: { Horizontal: "Horizontal", Vertical: "Vertical", Conglomerate: "Conglomerate", None: "No overlap" },
    evidence: {
      sales: "sales / threshold",
      share: "share / threshold",
      controlVerdict: "Control test",
      changeOfControl: "Change of control",
      acquiredStake: "Stake acquired",
      preStake: "Stake held before",
      controlRights: "Rights conferred",
      consideration: "Consideration",
      capacity: "Capacity",
      acceptedOn: "Accepted on",
      legalBasis: "Legal basis",
      combinedShare: "Combined share after",
      dominanceBefore: "Dominant before the deal",
      band: "Concentration band",
      hhi: "HHI before and after",
      deltaHhi: "Change in HHI",
      worstMarket: "Most affected market",
      competitors: "Competitors remaining",
      nature: "Nature of the concentration",
      recommendation: "Recommendation",
    },
    hints: {
      headerParties: "One sentence naming who acquires what from whom, as it appears in the header grid.",
      headerSector: "The sector and economic activity of the relevant market.",
      partyDescription: "Legal form, registration, activities, ownership and UAE footprint of this undertaking.",
      competence: "Why the Ministry, rather than a local or sectoral authority, reviews this file.",
      requestStatus: "Where the application stands and under which provision it was accepted.",
      test1Intro: "Whether the transaction meets the definition of an economic concentration in Article 1.",
      ownershipTransfer: "The clause of the agreement that transfers ownership, and what it transfers.",
      transactionValue: "The consideration, as disclosed in the filing.",
      ownershipConclusion: "Does the transfer-of-ownership condition hold? The recommendation rests on this.",
      control: "Whether the acquirer gains decisive influence, and of what kind.",
      structure: "The ownership and governance chain, before and after the transaction.",
      test1Conclusion: "The finding on Article 1. Read it against the control test beside it.",
      productMarket: "Overlaps between the parties, product classification and market structure.",
      geographicMarket: "The area of homogeneous competitive conditions.",
      substitution: "Demand-side and supply-side substitution.",
      marketDefinitionResult: "The relevant market or markets, named. Everything downstream depends on this.",
      thresholdConclusion: "Which markets cross {{turnover}} in sales or a {{share}} combined share.",
      nonNotification: "Why the transaction is not notifiable, in the Department's standard form.",
      nature: "Why the concentration is horizontal, vertical or conglomerate.",
      competitiveSituation: "The state of competition in the relevant market before and after.",
      marketCommentary: "What the HHI movement means for this market.",
      harmIntro: "Which effects the concentration could produce, given its nature.",
      harmNonCoordinated: "Could the merged entity raise prices on its own?",
      harmCoordinated: "Could the remaining players coordinate more easily?",
      harmVertical: "Could rivals be foreclosed from inputs or customers?",
      harmConglomerate: "Could sales be tied or bundled across the combined portfolio?",
      riskConclusion: "The finding on risk. Read it against the delta beside it.",
      rebuttal: "What makes those risks less likely.",
      finalObservation: "A numbered finding that carries the recommendation to the Minister.",
    },
    header: {
      title: "Application details",
      hint: "Filled from the case file and the statutory clocks; these figures are not written by the agent.",
      caseNumber: "Application number",
      receivedOn: "Received",
      reviewStartedOn: "Substantive review started",
      suspension: "Time limits suspended",
      transactionType: "Type of concentration",
      nature: "Nature",
      reportDate: "Report date",
    },
    thresholds: { title: "Notification thresholds", hint: "Computed by the rules engine per relevant market against {{turnover}} in combined sales and a {{share}} combined share (Cabinet Decision No. 3 of 2025, Art. 3).", market: "Relevant market", sales: "Sales / threshold (AED)", share: "Share / threshold", notifiable: "Notifiable" },
    sections: {
      headerParties: "Parties to the concentration (header line)",
      headerSector: "Sector and economic activity",
      partyDescription: "description of the undertaking",
      competence: "Competence of the Ministry",
      requestStatus: "Status of the application",
      test1Intro: "Legal test (1) — introduction",
      ownershipTransfer: "Transfer of ownership, rights, shares or assets",
      transactionValue: "Value of the transaction",
      ownershipConclusion: "Conclusion on the transfer of ownership",
      control: "Whether control is acquired",
      structureBefore: "Structure and governance before",
      structureAfter: "Structure and governance after",
      test1Conclusion: "Conclusion of legal test (1)",
      productMarket: "Product and services market",
      geographicMarket: "Geographic market",
      substitution: "Substitutability test",
      marketDefinitionResult: "Conclusion on the relevant market",
      thresholdConclusion: "Conclusion of the threshold test",
      nonNotification: "Reasons why the transaction is not notifiable",
      nature: "Nature of the transaction",
      competitiveSituation: "Competitive situation in the relevant market",
      harmIntro: "Theory of harm — introduction",
      harmNonCoordinated: "Horizontal non-coordinated effects",
      harmCoordinated: "Horizontal coordinated effects",
      harmVertical: "Vertical effects",
      harmConglomerate: "Conglomerate effects",
      riskConclusion: "Conclusion on the likelihood of risks",
      rebuttal: "Whether the risks can be rebutted",
      finalObservation: "Final observation",
    },
  },
  procedure: {
    clock: {
      title: "Statutory review period",
      hint: "{{period.ec.review}} days from receipt of the complete application, extendable once by up to {{period.ec.reviewExtension}} days (Article 13(2)). The period is interrupted while information is awaited from the parties, a sector regulator's opinion is pending or an objection is being examined (Article 14). Silence at the end of the period counts as rejection.",
      running: "Running",
      interrupted: "Interrupted",
      breached: "Period expired",
      completed: "Decided in time",
      notStarted: "Not started",
      notStartedHint: "The period starts when the complete application is registered. Pre-notification discussions do not count.",
      startedAt: "Started",
      startedAtHint: "Receipt of the complete application",
      dueAt: "Falls due",
      days: "days",
      remaining: "Days remaining",
      frozen: "Frozen while interrupted",
      extension: "Extension used",
      extensionHint: "Once, up to {{period.ec.reviewExtension}} days, on justification",
      interruptedDays: "Days interrupted",
      interruptedDaysHint: "{{count}} interruptions journaled", interruptedDaysHint_one: "{{count}} interruption journaled",
      activeGrounds: "The period is currently interrupted on the following grounds",
      since: "since {{date}}",
      history: "Interruption history ({{n}})",
      ongoing: "ongoing",
      silence: "Consequence of silence",
      sync: "Re-synchronise",
      syncedPaused: "Clock re-synchronised: interrupted under Article 14",
      syncedRunning: "Clock re-synchronised: running",
      extend: "Extend (+{{days}} max)",
      extendTitle: "Extend the review period — Article 13(2)",
      extendHint: "A single extension of up to {{max}} more days is available. The parties are notified of the new date and of the reasons.",
      justificationHint: "State the reason (complexity of the file, additional analysis, remedy discussions). It is quoted in the letter to the parties and in the report.",
    },
    simplified: {
      title: "Simplified procedure",
      hint: "Every declared market inside the structural safe harbours of the policy (combined share and ΔHHI on a horizontal market, the parties' share on a vertical or conglomerate one) may take the short track after the comment window: short-form report, then the assessment. One market outside sends the whole file to the full review. Each market takes the mark of its type as the officer classified it, or else as the figures show it – horizontal only where both parties hold a share – never by the applicant's label alone.",
      eligible: "Eligible",
      notEligible: "Full review",
      start: "Start simplified review",
      escalate: "Escalate to full review",
      publish: "Confirm and publish",
      conclude: "Conclude – short-form report",
      overlap: "Overlap",
      combinedShare: "Combined share",
      // 6.6, 6.10: where a market is not horizontal the share is the parties' share, and the type comes from the classification or the figures.
      partiesShare: "Parties' share",
      type: "Type",
      nonHorizontal: "Not horizontal",
      byOfficer: "Officer's classification",
      byFigures: "From the figures",
      applicantLabel: "Applicant: {{type}}",
      contradicted: "Label contradicted",
      reading: "Reading",
      inside: "Inside safe harbour",
      outside: "Outside",
    },
    coordination: {
      title: "Coordination with other authorities",
      hint: "Sector regulators to consult and foreign authorities reviewing the same transaction: timetable, confidentiality waiver and remedy alignment. Quoted in §3.1 of the report.",
      saved: "Coordination record saved.",
      regulatorsToConsult: "Sector regulators the declared ISIC codes point to – not yet consulted",
      addConsultation: "Record consultation",
      empty: "No authority recorded. Add the regulators the ISIC codes point to and any foreign filing the parties disclosed.",
      entry: "Entry {{n}}",
      kinds: { ForeignAuthority: "Foreign competition authority", SectorRegulator: "Sector regulator" },
      statuses: { Planned: "Planned", Filed: "Filed", UnderReview: "Under review", OpinionRequested: "Opinion requested", Consulted: "Consulted", Cleared: "Cleared", ClearedWithConditions: "Cleared with conditions", Prohibited: "Prohibited", NotRequired: "Not required" },
      sources: { Applicant: "Recorded by the parties", Ministry: "Recorded by the Ministry" },
      authority: "Authority",
      jurisdiction: "Jurisdiction (country code)",
      sector: "Regulated sector",
      status: "Status",
      filedOn: "Filed on",
      expectedDecisionOn: "Decision expected by",
      decidedOn: "Decided on",
      waiver: "Confidentiality waiver granted by the parties",
      notes: "Notes",
      remedyAlignment: "Remedy alignment",
      recorded: "Recorded from the opinion request",
      remedyAlignmentHint: "How remedies are aligned with the other authority – same divestiture, UAE carve-out, sequencing – or why they diverge.",
      addForeign: "Add a foreign authority",
      addRegulator: "Add a sector regulator",
    },
    preNotification: {
      title: "Pre-notification discussion",
      hint: "The parties' informal questions before filing and the Department's non-binding view. Points to address feed their readiness check; time here does not count towards the {{period.ec.review}} days.",
      open: "Discussion open",
      none: "The parties did not request a pre-notification discussion.",
      questions: "The parties' questions",
      proposedMarket: "Proposed market definition",
      view: "Non-binding view",
      viewLabel: "The Department's non-binding view",
      viewHint: "React to the proposed market definition and say what the notification must contain. The view is sent to the parties as a letter.",
      viewLabelAr: "Arabic mirror (optional)",
      points: "Points to address in the notification",
      pointsHint: "One per line; each becomes a recommendation in the applicant's readiness check.",
      sendKeepOpen: "Send and keep the discussion open",
      sendConclude: "Send and conclude",
      viewSent: "Non-binding view sent to the parties.",
      concluded: "Discussion concluded on {{date}}",
    },
    findings: {
      title: "Statement of preliminary findings",
      hint: "Before an adverse recommendation reaches the Minister, the parties see the theory of harm and the proposed conditions and reply within the period. The Department answers point by point; both are quoted in §4.6 of the report and Assessment → Escalation is guarded on it.",
      compose: "Put findings to the parties",
      reportRecommends: "The latest draft of the report recommends: {{code}}",
      noReport: "No review report is on the file yet",
      adverseNote: "An adverse recommendation: the parties must be heard before the report is finalised. The draft below is pre-filled from the report.",
      notAdverseNote: "The statement is waived only once an officer approves a report recommending unconditional approval or that the transaction is not notifiable; a draft never waives it.",
      proposedOutcome: "Minded to recommend",
      outcomes: { ApproveWithConditions: "Approval subject to conditions", Prohibit: "Prohibition", Approve: "Approval", NotNotifiable: "Not notifiable" },
      replyDays: "Reply period (working days)",
      theoryOfHarm: "Theory of harm put to the parties",
      theoryHint: "Pre-filled from the report's theory of harm; edit so the parties can answer the actual reasoning, not a summary.",
      theoryOfHarmAr: "Arabic mirror (optional)",
      markets: "Relevant markets", marketsHint: "One market per line (product and geographic). Pre-filled from the report or the notification.",
      evidence: "Evidence the preliminary view rests on", evidenceHint: "One item per line – the parties must know what they are answering. Pre-filled from the report's evidence relied on.",
      evidenceAr: "Evidence in Arabic (optional)", marketsLabel: "Markets", evidenceLabel: "Evidence relied on",
      conditions: "Conditions the Department is minded to propose",
      conditionsHint: "One per line. Required for a conditional approval; leave empty for a prohibition.",
      issue: "Issue the statement",
      issued: "Statement of preliminary findings issued and sent to the parties.",
      none: "No statement issued.",
      issuedOn: "Issued {{date}} by {{by}}",
      periodElapsed: "Reply period elapsed",
      replied: "Replied",
      late: "late",
      replyDue: "Observations due by {{date}}",
      partiesReply: "The parties' observations",
      recordReply: "Record observations received outside the platform",
      recordReplyHint: "A letter or a hearing note; the parties may also reply directly from the portal.",
      recordReplyAction: "Record the observations",
      replyRecorded: "The parties' observations are on file.",
      departmentReply: "The Department's reply",
      departmentReplyHint: "Point by point: what is accepted, what is not and why. Quoted verbatim in the report.",
      departmentReplyAr: "Arabic mirror (optional)",
      recordAnswer: "Record the reply",
      answerRecorded: "The Department's reply is on file.",
      answeredOn: "Answered {{date}} by {{by}}",
      notAnswered: "Not yet answered – the report's §4.6 will say so.",
    },
    peerReview: {
      title: "Independent peer review",
      hint: "A second economic expert who took no part in the case reads the approved report and records whether the evidence carries the recommendation. The report leaves Assessment only with the review on file; a dissent travels into the Minister's brief.",
      verdicts: { Concur: "Concurs", ConcurWithReservations: "Concurs with reservations", Dissent: "Dissents" },
      staleBadge: "Report revised – review again",
      missing: "Awaiting peer review",
      waiting: "Report not yet approved",
      record: "Record peer review",
      reportApproved: "Report approved {{date}} – recommends {{code}}",
      reportNotApproved: "The review report has not been approved yet; the peer review reads the approved text.",
      notIndependent: "You took part in this case",
      notIndependentHint: "The peer review is for someone outside the case team. Your ties: {{ties}}. Hand the task to a colleague, or an administrator may record a review with the conflict on the record.",
      roleRequired: "Economic expert required",
      roleRequiredHint: "The peer review is recorded by an economic expert (or a director standing in) who took no part in the case.",
      overrideTitle: "Conflict on record",
      overrideHint: "You are tied to this case ({{ties}}). As administrator you may still record the review; the conflict is written into the review and the brief.",
      overrideCheck: "Record the review despite the conflict, with the conflict noted",
      verdict: "Verdict",
      recommendedOutcome: "Outcome you would recommend",
      opinion: "Reasoned opinion",
      opinionHint: "Does the evidence carry the recommendation? Market definition, theory of harm, counterfactual, efficiencies, remedies – say where the report is solid and where it is not (40 characters minimum).",
      opinionAr: "Arabic mirror (optional)",
      pointsField: "Points of reservation or dissent",
      pointsHint: "One per line. Required unless you concur without reservation; each point is answered in the decision brief.",
      submit: "Sign the review",
      recorded: "Peer review recorded.",
      none: "No peer review on file.",
      onReport: "On a report recommending {{code}}",
      wouldRecommend: "would recommend {{code}}",
      stale: "reviewed an earlier report",
      points: "Points raised",
      conflictRecorded: "Reviewer was not independent",
      history: "Earlier reviews ({{n}})",
      team: "Case team the reviewer must be outside of ({{n}})",
      conduct: {
        hint: "A legal or economic expert who took no part in the case reads the final report the officers approved and records whether the evidence carries the outcome they chose. The report goes to the Minister only with the review on file; reservations and a dissent travel into the brief.",
        reportNotApproved: "The final report has not been approved yet; the review reads the approved text, with the outcome the officers chose and their reasons.",
        roleRequired: "Legal or economic expert required",
        roleRequiredHint: "The review is recorded by a legal or economic expert (or a director standing in) who took no part in the case.",
        opinionHint: "Does the evidence carry the outcome? Take each question of the legal test, the evidence for and against each outcome, the respondents' justification and the parties' observations – say where the report is solid and where it is not (40 characters minimum).",
      },
    },
    committee: {
      title: "Competition Regulation Committee",
      hint: "The Committee's opinion on the Department's recommendation before the file reaches the Minister (Article 17). Required for a recommendation to attach conditions or to prohibit; optional otherwise. The opinion is quoted in the decision recitals.",
      recommendations: { Approve: "Approve", ApproveWithConditions: "Approve with conditions", Prohibit: "Prohibit", RequestMoreInfo: "Further analysis requested" },
      required: "Opinion required",
      optional: "Optional",
      pending: "Before the Committee",
      overdue: "Opinion overdue",
      refer: "Refer to the Committee",
      referBlocked: "The approved report and its peer review must be on file first.",
      departmentRecommends: "The Department recommends {{code}}",
      requiredHint: "an adverse recommendation goes to the Committee before escalation",
      optionalHint: "may be referred at the Department's discretion",
      none: "Not referred to the Committee.",
      referredOn: "Referred {{date}}",
      dueOn: "opinion due {{date}}",
      votes: "Members' votes ({{n}})",
      noVotes: "No votes recorded yet.",
      member: "Member",
      memberPlaceholder: "Full name",
      vote: "Vote",
      note: "Note (optional)",
      castVote: "Record vote",
      voteRecorded: "Vote recorded.",
      adopt: "Adopt the opinion",
      recommendation: "Recommendation",
      session: "Session reference",
      reasoning: "Reasons",
      reasoningHint: "Why the Committee recommends this outcome, in terms the Minister and a reviewing court can follow (40 characters minimum). Quoted in the brief.",
      reasoningAr: "Arabic mirror (optional)",
      conditions: "Conditions the Committee recommends",
      conditionsHint: "One per line.",
      adoptSubmit: "Adopt and issue",
      opinionRecorded: "Committee opinion recorded.",
      opinion: "Opinion adopted",
      diverges: "The Committee's opinion differs from the Department's recommendation",
      divergesHint: "The brief puts both before the Minister with the reasons for each.",
      recitalNote: "The decision recitals cite this opinion, its date and session.",
    },
  },
  decisions: {
    validity: {
      period: "Valid", from: "Exemption in force from", fromHint: "Leave empty for the day of signature.", until: "Exemption expires on",
      untilHint: "The decision states the period of validity (Regulations Article 9(1)).", untilAmendmentHint: "Only when the amendment changes the period; otherwise the original period stands.",
    },
    title: "Decision queue",
    subtitle: "Files awaiting H.E. the Minister or the Undersecretary, the escalation chain, and the Competition Regulation Committee's review queue.",
    minister: "Awaiting the Minister", escalation: "Escalation chain", committee: "Committee review",
    undersecretary: "Awaiting the Under-Secretary",
    undersecretarySubtitle: "Concentrations whose notification thresholds are not met: the Under-Secretary issues the administrative decision under the delegation of Ministerial Decision No. 142 of 2026.",
    noMinister: "Nothing awaiting the Minister's signature.", noEscalation: "No reports in the escalation chain.", noCommittee: "No files with the Committee.",
    noUndersecretary: "Nothing awaiting the Under-Secretary's signature.",
    states: { ComplianceReview: "Compliance review", CommitteeReview: "With the Committee", CommitteeOpinion: "Opinion sought on the recommendation", MinisterDecision: "Awaiting the Minister", UndersecretaryDecision: "Awaiting the Under-Secretary" },
    instruments: { Ministerial: "Ministerial decision", Administrative: "Administrative decision" },
    instrumentHints: {
      Ministerial: "Ministerial decision signed by the Minister under Article 15 of Federal Decree-Law No. 36 of 2023.",
      Administrative: "Administrative decision that the conditions of Article 12 are not met, signed by the Undersecretary under Ministerial Resolution No. 142 of 2026.",
    },
    signerRequired: "This decision is signed by: {{roles}}.",
    notOpenYet: "The decision cannot be signed yet",
    preview: "Preview the decision",
    previewHint: "Downloads the unsigned instrument exactly as it would be issued, so you can read it before signing.",
    downloadInstrument: "Download the signed decision",
    reasonArHint: "Arabic wording used in Article 1 of the instrument; leave empty to use the standard formula.",
    remedyAccepted: "Remedy package v{{v}} accepted – {{count}} commitments", remedyAccepted_one: "Remedy package v{{v}} accepted – {{count}} commitment",
    remedyAcceptedHint: "Article 1 will print the accepted commitments as the conditions of approval and the commitments register will be built from them (trustee, cadence, sunset, indicator). Prefill to see the wording; edit only if the Minister varies it.",
    noAcceptedRemedy: "No accepted remedy package on file",
    noAcceptedRemedyHint: "A conditional approval should rest on a package the Department has assessed as sufficient after a market test. Conditions typed here will bind the parties without that record; open the Remedies view to run the package through the stage first.",
  },
  remedies: {
    title: "Remedy design",
    hint: "What the parties offer to keep the transaction approvable, with its effect calculated and tested with the market before the Department gives its verdict. Offering a package opens the Remedy design stage; the verdict returns the case to Assessment and the report is re-drafted on the record.",
    legalBasis: "Articles 14 and 15 of Federal Decree-Law No. 36 of 2023 – approval subject to conditions; the Implementing Regulations on the commitments the Ministry may accept.",
    status: { settled: "Settled", needed: "Remedies needed", notNeeded: "Not called for", offered: "Package offered", testing: "Market test running", awaitingVerdict: "Awaiting the Department's verdict" },
    stageOpen: "Remedy design stage",
    reportRecommends: "The review report recommends: {{code}}.",
    noReportYet: "No approved review report yet – the remedy question follows the competitive assessment.",
    marketsOnFile: "{{count}} relevant markets on file for the effect calculation", marketsOnFile_one: "{{count}} relevant market on file for the effect calculation",
    notPublished: "the case is not yet published, so a market test cannot be opened",
    neededTitle: "The report recommends conditions or prohibition and no package is on the table",
    neededHint: "The assessment cannot conclude until remedies are either offered and assessed, or their absence is recorded. Invite the parties to offer commitments through the portal, propose a Department package, or record that none were offered.",
    acceptedTitle: "Package v{{v}} accepted",
    acceptedHint: "{{count}} commitments will be printed as the conditions of the decision and carried into the commitments register with their monitoring terms.", acceptedHint_one: "{{count}} commitment will be printed as the condition of the decision and carried into the commitments register with its monitoring terms.",
    none: "No remedy package on file",
    noneHint: "Packages offered by the parties through the portal appear here, with the calculated effect of each commitment.",
    propose: "Propose a package",
    proposeHint: "A Department package (what the Ministry would accept) or a package recorded on behalf of the parties. The effect of each commitment is calculated on saving: a divestiture re-runs the case market with the carve-out sold; a behavioural commitment is read for its monitoring load.",
    proposeSubmit: "Record the package",
    proposed: "Remedy package recorded; its calculated effect is on file.",
    source: "Offered by",
    sources: { Parties: "The parties", Department: "The Department" },
    proposedByName: "Recorded on behalf of",
    proposedByNameHint: "Name of the signatory when the package is the parties'.",
    rationale: "Why this package answers the harm",
    rationaleHint: "Which finding of the report each commitment addresses; the parties' own words when recorded on their behalf.",
    rationaleAr: "Rationale (Arabic)",
    commitment: "Commitment",
    addCommitment: "Add a commitment",
    package: "Package v{{v}}",
    proposedOn: "Offered on {{date}} by {{by}}",
    statuses: { Proposed: "Proposed", UnderMarketTest: "Under market test", MarketTested: "Market-tested", Accepted: "Accepted", Rejected: "Rejected", Withdrawn: "Withdrawn", Superseded: "Superseded", NoneOffered: "No remedies offered" },
    kinds: { Structural: "Structural", Behavioural: "Behavioural", Reporting: "Reporting", Performance: "Performance" },
    verdicts: { Sufficient: "Sufficient", InsufficientScope: "Insufficient in scope", InsufficientEffectiveness: "Insufficient in effectiveness", NotMonitorable: "Not monitorable", Disproportionate: "Disproportionate" },
    verdictHints: {
      Sufficient: "The package removes the harm found in the report, on the calculated effect and the market-test findings; structural commitments are modelled and restore a workable structure.",
      InsufficientScope: "The package leaves part of the harm untouched – a market, a product or a customer group the report found affected is not covered.",
      InsufficientEffectiveness: "The package covers the harm but does not remove it – the carve-out is too small, the buyer unproven, or the promise unlikely to bite.",
      NotMonitorable: "The package cannot be verified in practice – no trustee, no indicator, an obligation the Ministry cannot observe.",
      Disproportionate: "The package goes beyond what the harm requires; the Department would accept a narrower one.",
    },
    purchaserRequirements: { None: "No purchaser requirement", UpfrontBuyer: "Up-front buyer", FixItFirst: "Fix-it-first", ApprovedPurchaser: "Approved purchaser" },
    fields: {
      kind: "Kind", obligor: "Obligor", relevantMarket: "Relevant market", title: "Title", description: "Undertaking",
      descriptionHint: "The obligation as it would be printed in Article 1 of the decision – who does what, for whom, on what terms.",
      divestedBusiness: "Divested business", divestedFrom: "Divested from", divestedSharePoints: "Share points", divestedSharePointsHint: "Share of the relevant market the carve-out carries; the effect calculation needs it.",
      purchaserRequirement: "Purchaser requirement", purchaserName: "Purchaser (if identified)", divestitureDeadlineMonths: "Divest within (months)",
      monitoringTrustee: "Monitoring trustee", monitoringTrusteeHint: "Independent trustee who reports to the Ministry; without one the Ministry carries the whole monitoring load.",
      verificationMethod: "How compliance is verified", reviewIntervalDays: "Cadence (days)", durationMonths: "Duration (months)", durationMonthsHint: "The sunset; leave empty only for an open-ended obligation.",
      reviewClause: "Review clause", effectivenessIndicator: "Effectiveness indicator", effectivenessIndicatorHint: "What the ex-post evaluation will read to say whether the remedy worked.",
    },
    sharePoints: "share points",
    withinMonths: "divest within {{n}} months",
    forMonths: "for {{n}} months",
    noSunset: "no sunset",
    everyDays: "verified every {{n}} days",
    sandbox: "Effect of the commitments",
    sandboxSummary: "Calculated effect of the package",
    sandboxPending: "The effect of this package has not been calculated yet.",
    sandboxRun: "Effect recalculated on the file's current markets.",
    rerunSandbox: "Recalculate the effect of the commitments",
    combinedShare: "combined share after remedy",
    restoresSafeHarbour: "Restores the safe harbour",
    aboveSafeHarbour: "Increment stays above the safe harbour",
    verificationRounds: "about {{n}} verification rounds",
    notModelled: "Not modelled",
    assumptions: "{{count}} assumptions", assumptions_one: "{{count}} assumption",
    structuralUnmodelled: "A structural commitment could not be modelled",
    structuralUnmodelledHint: "The divestiture is not expressed in share points of a relevant market on file. The Department cannot find such a package sufficient until the carve-out is quantified – ask the parties for the divested turnover or volume.",
    priceEffect: "Price effect",
    marketTest: {
      stances: { Support: "Supports", Oppose: "Opposes", Neutral: "Neutral", Mixed: "Mixed" },
      title: "Market test",
      open: "Open a market test",
      publish: "Publish the market test",
      opened: "Market test opened on the public register.",
      requiresPublication: "The case must be published before its commitments can be market-tested.",
      summaryPublic: "Non-confidential summary of the commitments",
      summaryPublicHint: "What third parties will read on the register. No business secrets; enough for a customer or competitor to say whether the remedy would work.",
      summaryPublicAr: "Summary (Arabic)",
      workingDays: "Working days",
      openDays: "open · {{count}} days left", openDays_one: "open · {{count}} day left",
      closedOn: "closed {{date}}",
      responses: "{{count}} responses", responses_one: "{{count}} response",
      notOpened: "No market test yet – open one so that customers, competitors and the sector regulator can say whether the package works.",
      waitStage: "The market test can be opened once the case is in the Remedy design stage (it moves there when a package is offered).",
      recordView: "Record a third party's view",
      submitter: "Third party",
      submitterType: "Type",
      submitterTypes: { Competitor: "Competitor", Customer: "Customer", Supplier: "Supplier", Association: "Trade association", Regulator: "Sector regulator", Other: "Other" },
      email: "E-mail",
      content: "Their view",
      viewRecorded: "View recorded on the market test.",
      close: "Close the market test",
      closeSubmit: "Close and record the findings",
      closed: "Market test closed; the findings are on file.",
      findings: "Findings of the market test",
      findingsHint: "What the responses say about the package – weighed for evidential weight and interest, as with objections – and what, if anything, should change.",
      findingsAr: "Findings (Arabic)",
    },
    assess: "Give the Department's verdict",
    assessSubmit: "Record the verdict",
    assessed: "Verdict recorded; the case returns to Assessment and the report is re-drafted.",
    assessorRole: "The verdict is given by an economic or legal expert, or the Director.",
    verdict: "Verdict",
    reasoning: "Reasoning",
    reasoningAr: "Reasoning (Arabic)",
    reasoningHint: "At least a few sentences; quoted in §4.7 of the report.",
    assessReasoningHint: "Answer the package on its calculated effect and the market-test findings: what harm it removes, what it leaves, and why. Quoted in §4.7 of the report and in the decision.",
    departmentVerdict: "The Department's verdict",
    acceptedNote: "The accepted commitments become the conditions of approval; the commitments register is built from them at decision.",
    noneOffered: "Record that no remedies were offered",
    noneOfferedHint: "When the parties offer nothing and the Department has nothing to propose, the record must say so – a prohibition must show that remedies were explored.",
    recordNone: "Record",
    noneRecorded: "Recorded: no remedies offered.",
    withdraw: "Withdraw",
    withdrawHint: "Package v{{v}} will be marked withdrawn. If the case is in Remedy design it returns to Assessment; the parties may offer a new package.",
    withdrawConfirm: "Withdraw the package",
    withdrawn: "Package withdrawn.",
  },
  exemption: {
    bases: { Article5RestrictiveAgreement: "Article 5 – restrictive agreement", Article6DominantPosition: "Article 6 – dominant position practice", Article7EconomicDependency: "Article 7 – economic dependency", Article8PriceReduction: "Article 8 – predatory pricing" },
    externalMember: "external member",
    agreement: "Notified agreement", essential: "Essential goods", scorecard: "Article 9 cumulative conditions", applicant: "applicant", validator: "validator", selfOnly: "Applicant self-check only", assessmentPending: "Validator assessment awaiting approval",
    suggestedConditions: "Conditions that would make the agreement acceptable", redTeam: "Questions the Committee will ask", validUntil: "Valid until",
    undertaking: "Undertaking not to implement", undertakingHint: "The parties may not implement until the Minister's reasoned decision (Regulations Article 4(2)(f)). Without a decision within the period the request is deemed rejected (Decree-Law Article 10(1)).", signed: "Signed", lapses: "Decision due by", lapsed: "Decision period elapsed – the request is deemed rejected; the agreement may not be implemented", committeeReceived: "received by the Committee", clockStarts: "The decision date is recorded when the file is referred to the Committee.", undertakingText: "Text of the undertaking", notSigned: "Undertaking not signed", notSignedHint: "The formal review must request the signed undertaking before the file proceeds.", perEstablishment: "Undertaking of each establishment", noUndertaking: "No undertaking yet", authorityOwn: "Own signatory", authorityPowerOfAttorney: "Under a special power of attorney", authorityVerified: "Authority confirmed by {{name}}", verifyAuthority: "Confirm the signatory can bind it", authorityVerifiedToast: "Signatory's authority confirmed",
    committee: "Competition Regulation Committee", committeeHint: "{{period.exemption.committeeReview}} working days to review the detailed report and recommend to the Minister.", committeeStatus: { Pending: "Pending", InReview: "In review", RecommendationIssued: "Recommendation issued" }, notReferred: "Not yet referred – approve the Committee report to refer the file.", reportPending: "Committee report drafted – approve it in the Overview tab to refer the file.", referredOn: "Referred", votes: "Votes", castVote: "Cast vote", voteNote: "Note (optional)", issueRecommendation: "Issue the Committee's recommendation", reasoning: "Reasoning", submitRecommendation: "Submit recommendation", recommendation: "Recommendation", recommendationIssued: "Recommendation issued – file moves to the Minister", voteRecorded: "Vote recorded", referred: "Referred to the Committee",
    recommendations: { Grant: "Grant", GrantWithConditions: "Grant with conditions", Reject: "Reject", RequestMoreInfo: "Request more information" },
    views: "Affected parties' views", noViews: "No views requested.", requestViews: "Request affected parties' views ({{period.exemption.views}} working days)", requestViewsHint: "Customers, competitors or suppliers affected by the agreement; {{period.exemption.views}} working days to respond.", viewsRequested: "Views requested", addInterestedParty: "Add the party in the Overview tab first.",
    refer: "Refer to the Committee", runValidator: "Run compliance validator", runBrief: "Run committee brief",
    combinedShare: "Combined market share of the parties",
  },
  amendment: {
    missing: "The amendment form could not be loaded.", changes: "Changes requested", changesHint: "Each change the parties ask for, set against the exemption as it was granted.", noChanges: "No change has been listed.",
    asGranted: "As granted", requested: "Requested", rationale: "Why the parties ask for the amendment", original: "Exemption as granted", noOriginal: "The original exemption is not linked to this amendment.",
    validUntil: "Valid until {{date}}", agreement: "Agreement", share: "Combined market share", term: "Term", openOriginal: "Open the original exemption", statedFigures: "Figures stated in the change",
    filing: "Filing", declared: "Declaration accepted by the applicant", notDeclared: "Declaration not yet accepted", mandatory: "Required", optional: "Optional",
    fields: { agreementEnd: "End date / duration", agreementScope: "Scope of the agreement", parties: "Parties", relevantMarket: "Relevant market", conditions: "Conditions of the exemption", pricing: "Pricing mechanism", territory: "Territory", other: "Other" },
  },
  appeal: {
    grounds: "Grounds of the grievance", groundsHint: "As stated by the appellant under Article 34.", newEvidence: "New evidence offered", review: "Appeal Reviewer's assessment", reviewPending: "The Appeal Reviewer is checking admissibility and the grounds against the original decision.",
    recommendations: { Accept: "Recommend accept", PartiallyAccept: "Recommend partial acceptance", Reject: "Recommend reject" },
    clocks: "Statutory clocks", inTime: "Filed within {{period.grievance.filing}} working days", late: "Filed after the {{period.grievance.filing}}-working-day period", notified: "Decision notified", filingDeadline: "filing deadline", ministerDue: "Minister's decision due", daysToImplicit: "{{count}} days before implicit rejection", daysToImplicit_one: "{{count}} day before implicit rejection", implicitApplied: "{{period.grievance.decision}} days elapsed – implicit rejection", courtRoute: "Court route open until {{date}}",
    fee: "Fee", refunded: "Refunded", unpaid: "Unpaid", contested: "Contested decision", reasoning: "Reasoning", openOriginal: "Open the original case",
    outcomes: { Accepted: "Accepted – decision reconsidered, fee refunded", Rejected: "Rejected – decision stands", ImplicitRejection: "Implicit rejection (no decision in {{period.grievance.decision}} days)" },
  },
  interest: {
    promptTitle: "Any interest in this file?",
    promptBody: "A financial interest, work for a party, a family tie or earlier advice. A declared interest goes to the Director before you act on the file.",
    promptBodyOptional: "A financial interest, work for a party, a family tie or earlier advice. A declared interest goes to the Director.",
    none: "No interest", have: "Declare an interest", nature: "Nature of the interest", details: "What the interest is", detailsHint: "One or two sentences: what it is and which party it concerns.",
    stepAside: "Step aside from this case now (you will not act on it again)", declare: "Declare the interest", cancel: "Cancel",
    pendingTitle: "Your declared interest awaits the Director's decision", pendingBody: "You declared: {{nature}}. Until the Director decides, you can read the file but not act on it.",
    recusedTitle: "You are recused from this case", recusedBody: "You can read the file but may not act on it, and cannot be assigned to it.", decidedBy: "Decided by {{name}} on {{date}}",
    awaitingTitle: "{{name}} declared an interest – your decision", declaredOn: "Declared on {{date}}", decisionNote: "Reasons for your decision", decisionNoteHint: "Recorded on the case history and in the audit trail.",
    clear: "Continues on the case", recuse: "Recuse from the case",
    noneToast: "Declaration recorded", declaredToast: "Interest declared", clearedToast: "The officer continues on the case", recusedToast: "The officer is recused from the case",
  },
  report: {
    title: "Whistleblowing report",
    identified: "Identified reporter",
    entities: "Undertakings concerned",
    observed: "Observed period",
    ongoing: "ongoing",
    evidence: "Evidence available",
    narrative: "Reporter's account",
    study: "Phenomenon study & impact assessment",
    studyHint: "Workflow 6 requires the Department to study the reported phenomenon, its negative effects and all its dimensions before gathering information.",
    phenomenon: "Study of the phenomenon",
    impact: "Impact assessment",
    protection: "Reporter protection",
    anonymousTitle: "Anonymous report",
    anonymousHint: "No identity or contact data was collected. The reporter follows the case with a receipt code.",
    encryptedTitle: "Contact details encrypted",
    encryptedHint: "Stored with data protection; revealing them is restricted to the Head of Complaints and the Director and is written to the audit trail.",
    reveal: "Reveal contact details (audited)",
    revealRole: "Only the Head of Complaints or the Director can reveal contact details.",
    ask: {
      title: "Conversation with the reporter", hint: "Questions reach the reporter through the receipt code; the answers and files come back here. The reporter stays unknown.",
      awaiting: "Awaiting the reporter's answer", empty: "No question has been sent to the reporter yet.", ministry: "Department", reporter: "Reporter", attachments: "Files from the reporter",
      suggested: "Questions the report leaves open", question: "Question to the reporter", questionAr: "Arabic version", questionArHint: "Optional – shown to a reporter reading in Arabic.",
      identityGuard: "This report is anonymous. The question should not ask for a name, contact details or anything else that identifies the reporter.",
      send: "Send the question", sent: "The question was sent. The reporter sees it with the receipt code.",
      suggestions: {
        when: "When did you first notice this conduct, and is it still happening?",
        evidence: "Do you have any documents, messages or price lists that show the conduct? They can be attached on the report status page with your receipt code.",
        others: "Are other companies involved, for example competitors or distributors that apply the same prices or terms?",
        source: "How did you come to know about this, for example as a customer, a supplier or an employee?",
      },
    },
    signal: "Correlated market signal",
    signalHint: "The Market Monitor correlates each report with price, tender and news signals in the feed.",
    noSignal: "No market signal correlated with this report yet.",
    notice: {
      title: "Notice of the investigation",
      hint: "Each undertaking under investigation is told in writing that the investigation is open: the case number, the legal basis, the subject and its rights. Notice may wait while it would undermine the investigation, but the meetings with the parties cannot be concluded until every undertaking has been notified.",
      notYet: "Notice is given when the file moves into investigation.",
      pendingTitle: "The undertakings have not been told",
      pendingBody: "Send the notice, or record why it must wait and until when.",
      sent: "Sent",
      deferred: "Deferred",
      pending: "Not yet sent",
      decidedBy: "Decided by {{name}} on {{date}}",
      deferredUntil: "Deferred until {{date}}",
      lapsedTitle: "The deferral date has passed",
      lapsedBody: "Send the notice now, or record why the deferral must continue.",
      letters: "Letters sent",
      undertakings: "Undertakings to notify",
      undertakingsHint: "The undertakings the report names and any already on the file. The reporter is never named in the notice.",
      addUndertaking: "Add an undertaking",
      name: "Name",
      nameAr: "Name in Arabic",
      email: "Email for the letter",
      subject: "Subject of the investigation",
      subjectAr: "Subject in Arabic",
      subjectHint: "The suspected conduct and the market, with nothing that could identify the reporter or reveal confidential evidence.",
      send: "Send notice",
      sendMore: "Notify another undertaking",
      defer: "Defer notice",
      extend: "Extend deferral",
      reason: "Ground for deferring",
      note: "Note",
      noteHint: "Required when the ground is another reason.",
      until: "Reconsider by",
      untilHint: "At most {{days}} days ahead. A task to reconsider falls due on that date.",
      recordDeferral: "Record deferral",
      cancel: "Cancel",
      role: "The Head of Complaints or the Director sends or defers the notice.",
      sentToast: "Notice sent",
      deferredToast: "Deferral recorded",
    },
  },
  advocacy: {
    title: "Advocacy",
    subtitle: "Competition assessment of laws, regulations and policies from ministries, federal authorities and emirate departments – the OECD Competition Assessment Toolkit applied by the Competition Assessment Agent under Article 18.",
    newReview: "Assess an instrument",
    tabs: { reviews: "Reviews", framework: "Method & checklist" },
    stats: { total: "Instruments assessed", inProgress: "{{count}} being analysed", inReview: "Awaiting adoption", inReviewHint: "AI drafts in the AI Inbox", adopted: "Opinions adopted", adoptedHint: "adopted by the Ministry", highOrSevere: "High or severe", highOrSevereHint: "average index {{index}}/100", flagged: "Provisions flagged", flaggedHint: "across all instruments" },
    filters: { search: "Title, authority or reference", allStatuses: "All statuses", allBands: "All bands", allStages: "All stages" },
    status: { Received: "Received", Screening: "Screened", Analysing: "Analysing", InReview: "Awaiting adoption", Adopted: "Adopted" },
    band: { None: "No restriction", Low: "Low", Moderate: "Moderate", High: "High", Severe: "Severe" },
    severity: { None: "None", Indicative: "Indicative", Likely: "Likely", Strong: "Strong" },
    verdict: { NoConcern: "No competition concern", MinorConcerns: "Minor concerns", SignificantConcerns: "Significant concerns", SevereConcerns: "Severe concerns" },
    pit: { Justified: "Justified", PartlyJustified: "Partly justified", NotJustified: "Not justified", InsufficientInformation: "Insufficient information" },
    stage: { Draft: "Draft", InForce: "In force", Proposed: "Proposed amendment", Consultation: "Public consultation" },
    instrumentTypes: { Law: "Federal law", DecreeLaw: "Decree-law", CabinetResolution: "Cabinet resolution", MinisterialDecision: "Ministerial decision", Circular: "Circular", Policy: "Policy", Guideline: "Regulation / guideline", DraftBill: "Draft bill", LocalOrder: "Local order (emirate)", Other: "Other" },
    columns: { instrument: "Instrument", authority: "Issuing authority", index: "Index", provisions: "Provisions", flagged: "Flagged", status: "Status", updated: "Updated" },
    provisionsFlagged: "{{flagged}} of {{total}} flagged",
    strongCount: "{{count}} strong",
    empty: "No instrument has been recorded yet.",
    emptyFiltered: "No review matches these filters.",
    byAuthority: "Instruments by issuing authority",
    byBand: "Restrictiveness bands",
    recent: "Recent reviews",
    dialog: {
      title: "New instrument",
      hint: "The instrument file or its text, with its issuing authority and stage. The section's method awaits the Department's approval, so the instrument is recorded without a screen or an assessment.",
      upload: "Upload file",
      paste: "Paste text",
      dropzone: "Instrument file",
      dropzoneHint: "PDF, Word (.docx), text or a scanned image · up to 25 MB",
      textPlaceholder: "Full text of the law, regulation or policy, in Arabic or English.",
      titleLabel: "Title",
      titlePlaceholder: "e.g. Draft Regulation on Ready-Mix Concrete Production",
      titleArLabel: "Title (Arabic)",
      authority: "Issuing authority",
      authorityPlaceholder: "e.g. Ministry of Energy & Infrastructure, Dubai Municipality",
      jurisdiction: "Jurisdiction",
      instrumentType: "Instrument type",
      stage: "Stage",
      reference: "Reference number",
      referencePlaceholder: "e.g. Draft No. 14/2026",
      sector: "Sector (optional)",
      noSector: "Not specified",
      notes: "Notes (optional)",
      notesPlaceholder: "Context from the issuing authority: policy objective, consultation deadline, points raised.",
      submit: "Record",
      submitting: "Reading the instrument…",
      created: "Instrument received – {{provisions}} provisions, {{flagged}} flagged, index {{index}}/100. The agent is drafting the assessment.",
      needText: "The instrument file or its text is required.",
    },
    detail: {
      back: "All reviews",
      overview: "Overview",
      provisions: "Provisions",
      opinion: "Opinion",
      instrument: "Instrument text",
      sources: "Sources",
      sourceTypes: { Regulation: "Legal knowledge corpus", Document: "Case document", Tool: "Tool output" },
      indexTitle: "Competition Restrictiveness Index",
      indexHint: "Orders instruments for attention – not a measure of harm. Bands: 0 none · 1–14 low · 15–34 moderate · 35–59 high · 60+ severe.",
      checklistTitle: "Competition checklist",
      checklistHint: "OECD items A1–D3 and CMA items E1–E2. Colour is the worst severity found; the number is how many provisions touch the item.",
      marketGate: "Market gate",
      marketGatePassed: "The instrument affects a market for goods or services",
      marketGateFailed: "The instrument does not appear to regulate a market – organisational or procedural",
      affectedMarkets: "Markets affected",
      structureOnFile: "Structure on file",
      exposure: "Exposure",
      objectives: "Policy objectives",
      executiveSummary: "Executive summary",
      publicInterest: "Public-interest test",
      publicInterestHint: "A restriction stands only where the benefit to the community outweighs the cost to competition and the objective cannot be achieved by a less restrictive means (OECD step two; Australia CPA cl. 5).",
      pitFields: { policyObjective: "Policy objective", objectiveLegitimacy: "Legitimacy", necessity: "Necessity", proportionality: "Proportionality", benefitsClaimed: "Benefits claimed", costsToCompetition: "Costs to competition" },
      alternatives: "Less-restrictive alternatives",
      altColumns: { restriction: "Restriction", alternative: "Alternative", how: "How it meets the objective", residual: "Residual risk" },
      recommendations: "Recommendations to the issuing authority",
      openQuestions: "Information requested from the issuing authority",
      comparative: "Comparative references – foreign practice, not precedent",
      provisionColumns: { provision: "Provision", restriction: "Restriction", items: "Items", severity: "Severity", alternative: "Less-restrictive alternative" },
      provisionFields: { mechanism: "Mechanism", who: "Who bears the cost", objective: "Objective served", alternative: "Alternative", legalBasis: "Legal basis", screen: "Screen" },
      screenOnly: "The agent's assessment is not on file yet – this is the deterministic screen: candidate restrictions, not findings.",
      rulesDraftProvisions: "These provision readings come from the rules-engine draft (the checklist screen), not a completed model assessment. Confirm or dismiss each flag before adoption.",
      noFlags: "No restriction on competition was identified in the instrument.",
      showClean: "Show unflagged provisions",
      hideClean: "Hide unflagged provisions",
      matched: "Matched wording",
      mitigated: "mitigating phrase found",
      opinionDraft: "AI draft – not yet adopted",
      opinionRulesDraft: "Rules-engine draft – not yet adopted",
      opinionAdopted: "Adopted by {{name}} on {{date}}",
      opinionAdoptedNoName: "Adopted on {{date}}",
      opinionPending: "The Competition Assessment Agent is drafting the opinion. This page refreshes automatically.",
      runFailed: "The agent's last run failed before a draft was written – what you see is the deterministic screen. Use Regenerate to run the assessment again.",
      runFailedWithError: "The agent's last run failed before a draft was written ({{error}}). What you see is the deterministic screen – candidate restrictions, not findings. Use Regenerate to run the assessment again.",
      rulesDraft: "The language model could not complete this run. What you see is a rules-engine draft from the deterministic screen: the checklist flags turned into a first opinion. The economic expert should complete the reading before adoption, or use Regenerate when the model is available.",
      rulesDraftWithError: "The language model could not complete this run ({{error}}). What you see is a rules-engine draft from the deterministic screen: the checklist flags turned into a first opinion. The economic expert should complete the reading before adoption, or use Regenerate when the model is available.",
      assessmentSource: "Draft source",
      assessmentSourceModel: "Language model",
      assessmentSourceRules: "Rules engine (fallback)",
      adoptInInbox: "Adopt in AI Inbox",
      adoptHint: "The opinion becomes the Ministry's when the economic expert approves the proposal in the AI Inbox. Edits made there are what is adopted.",
      regenerate: "Regenerate",
      regenerateNote: "Note for the agent (optional)",
      regenerateNotePlaceholder: "e.g. treat Article 7 as a quality standard, not a cap; the authority confirmed licences are unlimited.",
      regenerating: "Regeneration queued – the agent is re-reading the instrument.",
      exportPdf: "Opinion PDF",
      exportPdfAr: "Arabic PDF",
      exported: "Opinion exported",
      delete: "Delete review",
      deleteConfirm: "Delete this review and its draft? Adopted opinions cannot be deleted.",
      deleted: "Review deleted",
      english: "English",
      arabic: "العربية",
      confidence: "Confidence",
      quality: "Quality",
      run: "Agent run",
      requestedBy: "Requested by",
      language: "Language",
      pages: "{{count}} pages", pages_one: "{{count}} page",
      pasted: "Pasted text",
      viewSource: "View the source",
      meta: { reference: "Reference", instrument: "Instrument", stage: "Stage", jurisdiction: "Jurisdiction", sector: "Sector", authority: "Issuing authority", received: "Received" },
      noSources: "No retrieved sources recorded yet.",
      notFound: "This review does not exist or was deleted.",
    },
    framework: {
      title: "How the tool assesses an instrument",
      intro: "The method follows the OECD Competition Assessment Toolkit, the UK CMA's competition impact assessment guidance and the ICN's advocacy practices, adapted to the Ministry's competences under Federal Decree-Law No. 36 of 2023. Step one is a deterministic screen; step two is the agent's in-depth assessment of every flagged provision; the economic expert adopts the opinion.",
      steps: { one: "1 · Screen", oneHint: "Segment the text into provisions and match each against the bilingual checklist lexicon. Output: flags, severity, restrictiveness index.", two: "2 · Assess", twoHint: "The agent reads every flagged provision: restriction, mechanism, who pays, objective, less-restrictive alternative, public-interest test – grounded in the legal corpus and the Data Bank.", three: "3 · Adopt", threeHint: "The economic expert reviews the draft in the AI Inbox, edits it, and adopts it as the Ministry's opinion to the issuing authority." },
      checklist: "The competition checklist",
      sources: { oecd: "OECD Competition Assessment Toolkit, Competition Checklist (Volume I, v4.0)", cma: "UK CMA, Competition impact assessment: guidelines for policymakers (2015, updated July 2023)" },
      checklistColumns: { item: "Item", question: "Question", alternatives: "Typical less-restrictive alternatives", points: "Base points", source: "Source" },
      index: "The restrictiveness index",
      screen: "The screen",
      guidance: "Guidance in the legal corpus",
      guidanceHint: "Foreign guidance and the draft guidance note the proposed method was drawn from. None is applied until the Department approves the method.",
      instrumentTypes: "Instrument types accepted",
    },
  },
  legal: {
    answerEn: "Answer in English", answerAr: "Answer in Arabic",
    precedents: "Precedents",
    precedentsHint: "Policy Analyst search across issued decisions, investigation reports and official answers – the same index the agent cites when drafting an answer.",
    precedentPlaceholder: "e.g. cement price coordination, joint venture thresholds, resale price…",
    precedentKinds: { Decision: "Decision", Report: "Report", OfficialAnswer: "Official answer" },
    relevance: "Relevance",
    noPrecedents: "No precedent matches these terms.",
    subtitle: "Escalated enquiries awaiting an official answer, FAQ approvals and the legal corpus that grounds the public assistant.",
    addInstrument: "Add instrument",
    importPrecedents: "Import precedents",
    precedentsImported: "Precedents imported: {{files}} from published decisions, {{decisions}} from platform decisions",
    addInstrumentHint: "Paste the text of a law, decision or guideline. It is chunked at article level, embedded and becomes citable by every agent immediately.",
    key: "Key",
    kind: "Kind",
    kinds: { Law: "Law", CabinetDecision: "Cabinet decision", MinisterialDecision: "Ministerial decision", Guideline: "Guideline", Procedure: "Procedure", Precedent: "Precedent", ComparativeReference: "Comparative reference (foreign authority's decision)", Faq: "FAQ", InternationalGuidance: "International guidance" },
    titleAr: "Title (Arabic)",
    issuer: "Issuer",
    text: "Text",
    textHint: "Use headings such as \"Article 12\" to control chunk boundaries.",
    ingest: "Ingest",
    ingested: "Ingested – {{count}} chunks embedded", ingested_one: "Ingested – {{count}} chunk embedded",
    chunkCount_one: "{{count}} passage",
    chunkCount_other: "{{count}} passages",
    stats: { documents: "Instruments in the corpus", chunks: "chunks", embedded: "embedded", enquiries: "Enquiry conversations", escalated: "{{count}} escalated to researchers", confidence: "Average answer confidence", unsupported: "{{count}} unsupported claims caught by the verifier", unsupported_one: "{{count}} unsupported claim caught by the verifier", faqs: "Published FAQs", faqsHint: "Official answers reused by the assistant" },
    enquiries: "Enquiries",
    corpus: "Legal corpus",
    corpusTitle: "Instruments",
    corpusHint: "Toggle an instrument off to exclude it from retrieval; re-embed after editing the text.",
    testRetrieval: "Test retrieval",
    testRetrievalHint: "See exactly which clauses the assistant would cite for a question.",
    searchPlaceholder: "e.g. notification thresholds for joint ventures",
    reembed: "Re-embed",
    reembedded: "Chunks re-embedded",
    active: "Active",
    embedded: "Embedded",
    notEmbedded: "No embedding",
    noEnquiries: "No escalated enquiries",
    noEnquiriesHint: "{{count}} anonymous conversations were answered by the assistant without escalation.", noEnquiriesHint_one: "{{count}} anonymous conversation was answered by the assistant without escalation.",
    question: "Question",
    messages: "messages",
    messageCount: "{{count}} messages",
    messageCount_one: "{{count}} message",
    messageCount_other: "{{count}} messages",
    askedIn: { en: "in English", ar: "in Arabic" },
    statuses: { Open: "Open", Escalated: "With researcher", Answered: "Answered", Closed: "Closed", Flagged: "Flagged by the checks" },
    roles: { user: "Enquirer", assistant: "Assistant", officer: "Legal researcher" },
    draftReady: "Draft answer ready",
    draftReadyHint: "The Policy Analyst drafted an official answer. It can be opened in the editor, or the answer written below.", useDraft: "Open the draft in the editor",
    fromDraft: "Policy Analyst draft · confidence {{confidence}}%", fromDraftHint: "The draft is in the editor. Check the provisions it cites and edit the wording; issuing it approves the draft as edited.",
    draftSources: "Sources the draft relies on", startBlank: "Start from a blank answer", draftApprovedNote: "Edited and issued by the legal researcher from the answer editor",
    published: "Published FAQ",
    notPublished: "Not published",
    faq: "FAQ",
    enquiry: "Enquiry",
    openCase: "Open the case",
    notEscalated: "Answered by the assistant – not escalated",
    officialAnswer: "Official answer",
    publishFaq: "Publish as FAQ",
    publishFaqHint: "Visible on the public Legal Enquiries page and reused as a source by the assistant.",
    writeAnswer: "Official answer",
    writeAnswerHint: "Issued as a letter to the enquirer and closes the {{period.enquiry.answer}}-working-day clock.",
    issueAnswer: "Issue official answer",
    approveAnswer: "Approve the answer",
    answerArRequired: "The official answer is issued in Arabic and English: give the Arabic text.",
    approvedAwaiting: "Approved – awaiting issue",
    correctedAtIssue: "Corrected at issue – the text {{name}} approved on {{date}} is kept as approved",
    approvedBy: "Approved by {{name}} on {{date}}. Read it once more; a last correction can still be made before it goes.",
    issueApproved: "Issue the official answer",
    faqQuestion: "Question as published",
    faqQuestionHint: "Anonymised: no names, figures or business detail. Pre-filled from the enquiry with those taken out; edit before publishing.",
    publishFaqAction: "Publish in the FAQ",
    answerIssued: "Official answer issued",
    conversation: "Conversation",
    conversationHint: "Assistant answers are grounded in the corpus; confidence shown per answer.",
    escalationReason: "Escalation reason",
    noConversation: "No conversation is attached to this case.",
  },
  fileAccess: {
    title: "Access to the file",
    hint: "Before an adverse decision the undertakings concerned see the file: each document in full, as a non-confidential summary, or withheld with the reason. The report does not go forward until the period has run or every undertaking has answered. Each download on the portal is recorded.",
    openUntil: "Open until {{date}}",
    closed: "Closed",
    notOpened: "Not opened yet",
    notRequired: "The platform settings do not require access to the file; it can still be given.",
    noPartiesTitle: "No undertaking concerned yet",
    noParties: "The file is opened to the undertakings concerned once they are recorded on the case, for example when the opening notice or a request for information is sent.",
    parties: "Undertakings concerned",
    portal: "On the portal",
    letterOnly: "By letter",
    openedBy: "Opened by {{name}} on {{date}}",
    closes: "closes on {{date}}",
    closedBy: "Closed by {{name}} on {{date}}",
    inspections_one: "{{count}} download recorded on the portal",
    inspections_other: "{{count}} downloads recorded on the portal",
    index: "Index of the file",
    empty: "No document is on the file yet.",
    access: "Access",
    levels: { Full: "In full", Summary: "Non-confidential summary", Withheld: "Withheld" },
    summary: "Non-confidential summary",
    summaryHint: "What the document shows, without the business secrets (at least 20 characters).",
    summaryAr: "Summary in Arabic",
    reason: "Reason for withholding",
    otherReason: "Another reason…",
    ownReason: "State the reason",
    days: "Working days open",
    daysHint: "Between {{min}} and {{max}}.",
    prepare: "Prepare access to the file",
    reopen: "Open the file again",
    open: "Open the file and send the letters",
    cancel: "Cancel",
    incomplete: "Give a summary for each document shown as a summary, and a reason for each document withheld.",
    closeEarly: "Close early",
    closeReason: "Why the file closes early",
    closeReasonHint: "Every undertaking has answered, or has waived access in writing (at least 20 characters).",
    close: "Close the file",
    openedToast: "The file is open to the undertakings and the letters have been sent.",
    closedToast: "The file is closed.",
    role: "The Head of Complaints or the Director opens the file to the undertakings.",
  },
  investigation: {
    outcome: {
      title: "Recommended outcome",
      hint: "The final report writes up both lawful outcomes with the evidence for and against each, and its draft leaves the choice open. The officers choose one and state their own reasons before approving. An expert outside the case team then reviews the approved report.",
      draftPick: "The draft suggests: {{outcome}}",
      draftNone: "The draft recommends neither outcome",
      evidenceFor: "Evidence for",
      evidenceAgainst: "Evidence against",
      notWrittenUp: "Not written up by the draft – the officers write it up in the report.",
      fullText: "The report in full",
      fullTextHint: "Read the report to its end before approving it; it counts as opened once its end has been on screen.",
      writeUp: "Write up “{{outcome}}” with the evidence for and against it",
      writeUpHint: "The draft left this lawful outcome out. Both outcomes are written up before the report is approved (at least {{min}} characters).",
      choose: "Outcome the officers recommend",
      reason: "The officers' reasons",
      reasonHint: "In your own words: which questions of the legal test the evidence answers, and why it carries this outcome rather than the other (at least {{min}} characters).",
      approve: "Approve the report with this outcome",
      approved: "Final report approved with the officers' outcome.",
      departs: "Departs from the draft's suggestion",
      chosen: "Approved {{date}} – the officers recommend: {{outcome}}",
      reasonLabel: "Reasons",
    },
    evidenceWeight: "weight {{w}}",
    notifyParties: "Notify respondents ({{period.complaint.response}} working days to respond)",
    notified: "{{count}} respondents notified", notified_one: "{{count}} respondent notified",
    requestInfo: "Request information",
    requestInfoHint: "{{period.complaint.informationRequest}} working days to respond; reminders after {{period.informationRequest.firstReminder}} and {{period.informationRequest.secondReminder}} further working days (Ministry procedure), then the Article 23(3) notice giving {{period.complaint.finalNotice}} more working days, which you approve and send.",
    recipient: "Recipient",
    questions: "Questions",
    questionsHint: "One question per line.",
    rfiSent: "Information request sent",
    firstReminder: "first reminder",
    schedule: "Schedule meeting / field visit",
    scheduleHint: "Party hearings and unannounced field visits by judicial officers are minuted by the Meeting Assistant from the transcript.",
    scheduled: "Scheduled",
    kind: "Kind",
    kinds: { FieldVisit: "Field visit", PartyMeeting: "Party hearing", Internal: "Internal", Committee: "Committee" },
    when: "Date & time",
    location: "Location",
    attendees: "Attendees",
    attendeesHint: "Comma-separated.",
    judicialOfficer: "Judicial officer field visit (evidence seizure powers)",
    // Scenario 6.39: who releases the preliminary report, at which stage, from which report; scenario 6.37: the complainant's request for confidential treatment.
    reportRelease: {
      refused: "The report cannot be released yet",
      approvedBy: "Approved by {{name}}",
    },
    complainantIdentity: {
      title: "The complainant asked for confidential treatment",
      protected: "Its name and identity documents are withheld from the respondents: letters to them say \"the complainant\", and the confidentiality screen holds any letter or report that still identifies it.",
      disclosed: "The identity may be disclosed to the respondents on the decision of {{name}}, {{date}}.",
      reason: "Why the identity may be disclosed",
      reasonPlaceholder: "The complainant's consent and its date, or why the investigation requires it",
      record: "Record the decision to disclose",
      recorded: "Decision to disclose recorded",
    },
    shareReport: "Share preliminary report ({{period.complaint.preliminaryReportReply}} working days)",
    shared: "Report shared with {{count}} party(ies)",
    screenTitle: "The report may contain confidential information",
    screenHint: "The screen compared the report with the documents classified confidential on the file. Remove these passages from the report, or record why they may be disclosed (not confidential, or the owner's written consent – Article 20(2)).",
    screenKinds: { Passage: "Passage from a confidential document", Figure: "Figure from a confidential document", Marked: "Passage marked confidential", Email: "E-mail address", Phone: "Telephone number" },
    screenOverride: "Why these passages may be disclosed",
    screenRelease: "Release with this reason",
    runPlanner: "Run planner",
    runAnalyst: "Run evidence analyst",
    plan: "Investigation plan",
    planHint: "Objectives, theory of harm, sequenced steps with owners, questionnaires and field-visit checklist – drafted by the Investigation Planner, approved by the Head of Complaints.",
    planPending: "The Investigation Planner has drafted a plan – approve it in the Overview tab.",
    noPlan: "No plan yet. Run the Investigation Planner or the plan will be drafted when the case enters investigation.",
    objectives: "Objectives",
    stepStatus: { Planned: "Planned", InProgress: "In progress", Done: "Done", Blocked: "Blocked" },
    stepStatusLabel: "Status of step {{step}}",
    planVersion: "Version {{version}}",
    fieldVisit: "Field visit recommended – checklist",
    questionnaires: "Questionnaires",
    evidence: "Evidence matrix",
    evidenceHint: "Each item is mapped to an allegation with its direction and the analyst's weight for its reliability. Items are weighed on what each shows, never added up: the counts only say what is on the board. Tick the shield to mark an item as verified by an officer.",
    itemCounts: "{{supports}} supporting · {{contradicts}} contradicting · {{unverified}} not yet verified",
    evidencePending: "The Evidence Analyst has proposed items – approve them in the Overview tab.",
    supports: "supports",
    contradicts: "contradicts",
    verify: "Mark as verified by officer",
    requests: "Information requests & responses",
    requestsHint: "Party responses ({{period.complaint.response}} working days) and investigation requests with the {{period.complaint.informationRequest}}/{{period.informationRequest.firstReminder}}/{{period.informationRequest.secondReminder}} reminder cadence enforced by the SLA sentinel.",
    cadence: "cadence",
    remindersSent: "{{count}} reminders", remindersSent_one: "{{count}} reminder",
    warningSent: "Warning issued",
    finalNoticeAwaits: "Article 23(3) notice awaits your approval",
    finalNoticeSend: "Approve and send the Article 23(3) notice",
    finalNoticeSent: "Article 23(3) notice sent – reply by {{date}}",
    finalNoticeDone: "Article 23(3) notice sent",
    nextReminder: "next reminder",
    responses: "Responses",
    meetings: "Hearings & field visits",
    meetingsHint: "Transcripts are turned into bilingual minutes by the Meeting Assistant for officer approval.",
    transcript: "Transcript",
    minutesApproved: "Minutes approved",
    minutes: "Minutes",
    recordTranscript: "Record transcript",
    recordTranscriptHint: "Paste the speech-to-text export of the hearing or field visit; the Meeting Assistant drafts bilingual minutes for approval.",
    transcriptFormat: "One utterance per line as [hh:mm] Speaker: text. Speaker names are optional.",
    transcriptRecorded: "Transcript recorded",
    transcriptRecordedHint: "The Meeting Assistant is drafting the minutes – review them in the Overview tab.",
    recording: "Or upload the recording",
    recordingHint: "mp3, wav, m4a, ogg or webm up to 25 MB. The speech-to-text model produces a timestamped, speaker-attributed transcript in the spoken language.",
    transcribeAndDraft: "Transcribe and draft minutes",
    transcribed: "Recording transcribed",
    transcribedHint: "Transcribed in {{seconds}} s. The meeting assistant is drafting the minutes.",
    draftMinutes: "Draft minutes",
  },
  analysis: {
    scenarios: "Scenario testing",
    scenariosHint: "Remedy scenarios recomputed with the same arithmetic as the assessment (bands {{moderate}} / {{high}}, ΔHHI of concern {{delta}}). Configured in Workflow Studio → Analysis policy.",
    scenario: "Scenario",
    verdict: "Reading",
    safeHarbour: "Within safe harbour",
    customDivest: "Divest (%)",
    divestTo: "Purchaser",
    newEntrant: "New entrant",
    runScenario: "Run scenario",
    scenarioFooter: "Arithmetic only: a scenario is not a remedy assessment and does not bind the Ministry.",
    marketHistory: "Concentration record",
    since: "since {{year}}",
    comparables: "Comparable decided cases",
    comparablesHint: "Ranked by shared market vocabulary and case type, so a recommendation can be checked against the Ministry's own precedent.",
    similarity: "Similarity",
    conditions: "{{count}} conditions", conditions_one: "{{count}} condition",
    commitments: "Post-decision commitments",
    commitmentsHint: "Conditions and undertakings the Ministry monitors after the decision, with the obligor, the verification method and the next review.",
    buildRegister: "Build from the decision",
    fromRemedyPackage: "From the accepted package",
    trustee: "Trustee",
    sunset: "Sunset",
    divestBy: "Divest by",
    indicator: "Effectiveness indicator",
    registerCreated: "{{count}} commitments added to the register", registerCreated_one: "{{count}} commitment added to the register",
    commitmentUpdated: "Commitment updated",
    noCommitments: "No commitments recorded",
    noCommitmentsHint: "Create the register from the conditions attached to the decision, or add commitments manually.",
    performance: "Performance target",
    performanceHint: "The efficiency the approval rests on, as a measurable target; if it is missed the compensation clause applies.",
    baseline: "baseline",
    target: "target",
    targetBy: "by",
    measured: "measured",
    notMeasured: "Not yet measured",
    targetMet: "Target met",
    targetMissed: "Target missed – compensation clause applies",
    compensationClause: "Compensation clause",
    recordMeasurement: "Record measurement",
    measuredValue: "Measured value",
    measuredOn: "Measured on",
    measurementNote: "Source of the figure (compliance report, audited accounts, Data Bank)",
    measurementSaved: "Measurement recorded; status follows from the target",
    directions: { AtLeast: "at least", AtMost: "at most" },
    nextReview: "next review",
    lastVerified: "verified",
    monitoringTitle: "Commitment monitoring",
    monitoringSubtitle: "Every condition and undertaking the Ministry is monitoring across decided cases.",
    open: "Open",
    overdue: "Overdue",
    breached: "Breached",
    met: "Met",
  },
  dataBank: {
    entityStatus: { Active: "Active", Inactive: "Inactive", Merged: "Merged into another entity", null: "Not recorded" },
    agreementOf: "Agreement ({{type}})",
    agreementKinds: { Horizontal: "horizontal", Vertical: "vertical", JointPurchasing: "joint purchasing", Standardisation: "standardisation" },
    outcomes: { clearedWithConditions: "Cleared with conditions", completedNotified: "Completed (notified)", completed: "Completed", lapsed: "Lapsed", notifiedExemption: "Notified – exemption review", belowThresholds: "Not notified – below the thresholds of Cabinet Decision No. 3 of 2025" },
    title: "National Competition Data Bank",
    subtitle: "Entities, sectors, markets, market shares and transactions consolidated from cases and government registries.",
    entities: "Entities",
    sectors: "Sectors",
    markets: "Markets",
    shares: "Market shares",
    transactions: "Transactions",
    jurisdictions: "Jurisdictions",
    mergeProposals: "Merge proposals",
    ingestion: "Ingestion jobs",
    studio: "Market Study Studio",
    curation: "Curation",
    reference: "Reference data",
    lastSync: "Last sync",
    registeredOf: "{{count, number}} matched to the National Economic Register",
    sectorsAndJurisdictions: "{{sectors}} ISIC sectors · {{jurisdictions}} jurisdictions",
    curatedOf: "{{count}} confirmed by a curator",
    lineageRecords: "{{count, number}} lineage records",
    studiesCount: "{{count}} market studies",
    searchEntities: "Search by English or Arabic name, alias or licence number…",
    entityCount: "{{count}} entities",
    entity: "Entity",
    licence: "Licence",
    authority: "Licensing authority",
    legalForm: "Legal form",
    emirate: "Emirate",
    sector: "Sector",
    turnover: "Latest turnover",
    ultimateOwner: "Ultimate owner",
    unregistered: "Not in register",
    aliases: "Aliases",
    mergedAway: "Merged",
    pendingMergeNotice: "{{count}} merge proposals involve this entity – review them in the Curation tab.", pendingMergeNotice_one: "{{count}} merge proposal involves this entity – review it in the Curation tab.",
    partyRoles: { Applicant: "Applicant", Representative: "Representative", AcquiringParty: "Acquirer", TargetParty: "Target", Complainant: "Complainant", Respondent: "Respondent", InterestedParty: "Interested party", Objector: "Objector", NotifyingParty: "Notifying party", JointVenturePartner: "JV partner", Whistleblower: "Whistleblower", Other: "Other" },
    noShares: "No market shares recorded yet.",
    year: "Year",
    share: "Share",
    revenue: "Revenue",
    source: "Source",
    curated: "Curated",
    curatedYes: "Curated",
    demonstrationRow: "Demonstration data",
    demonstrationRowHint: "A test or demonstration row: shown for the record, never counted in the market's figures.",
    curate: "Confirm",
    sources: { "company-self-report": "Company self-report", "open-data-master": "Open data", mergermarket: "Mergermarket", "simulated-economy": "Demonstration economic data", AdvocacySeed: "Legislation review", MarketStudy: "Market study", Registry: "Registry", FCSC: "FCSC", MOF: "MOF", CaseFiling: "Case filing", MarketFeed: "Market feed", Curator: "Curator", Merge: "Merge", Estimate: "Estimate", Regulator: "Regulator" },
    sourceKeys: { registry: "National Economic Register", fcsc: "FCSC statistics", mof: "MOF turnover verification" },
    sourceKinds: { Registry: "Registry", Statistics: "Statistics", Regulator: "Regulator", CaseFiling: "Case filings", Web: "Web feed", Customs: "Customs", SelfReport: "Company self-report", OpenData: "Open data", Exchange: "Exchange", Commercial: "Commercial provider", Aggregator: "Data aggregator", FreeZone: "Free zone" },
    confidenceHint: "Each source carries a default confidence – the provenance weight of every figure ingested from it. Customs and regulator data outrank open data; company self-reports are verified against them.",
    customs: {
      title: "Customs trade by HS code (Federal Customs Authority)",
      hint: "Item-level imports and exports attributed to this market through the HS code mapping – the granularity the Department needs to verify declared shares. The figures appear once the Ministry's integration with the Federal Customs Authority is connected.",
      noMapping: "No HS code mapped",
      empty: "No customs declarations loaded yet for the mapped HS codes.",
      emptyNoMapping: "Map an HS code to this market in the reference data to attribute customs trade to it.",
      sync: "Pull from FCA",
      synced: "FCA declarations for HS {{hs}} loaded ({{count}} records)",
      imports: "Imports",
      exports: "Exports",
      records: "Declarations",
      topTraders: "Largest importers / exporters",
      unresolved: "not yet matched to a Data Bank entity",
    },
    editConfidence: "Edit the default confidence",
    applyExisting: "re-weight existing figures",
    confidenceSaved: "Confidence updated ({{count}} existing figures re-weighted)", confidenceSaved_one: "Confidence updated ({{count}} existing figure re-weighted)",
    operations: { Insert: "Created", Update: "Updated", Merge: "Merged", Curate: "Curated", Delete: "Deleted" },
    tables: { market_entities: "entity", market_shares: "share", markets: "market", market_transactions: "transaction", external_deals: "monitored deal" },
    lineage: "Lineage",
    lineageFields: {
      NameEn: "English name", NameAr: "Arabic name", aliases: "Aliases", tags: "Tags", RegistryNumber: "Registry number", RegistryAuthority: "Registry authority",
      LegalForm: "Legal form", Emirate: "Emirate", IsicCode: "Activity code", Lei: "LEI", Ticker: "Ticker", Exchange: "Exchange", Website: "Website",
      UltimateOwner: "Ultimate owner", EmployeeCount: "Employees", LatestTurnoverAed: "Latest turnover", LatestTurnoverYear: "Turnover year",
      VerifiedTurnoverAed: "Verified turnover", VariancePercent: "Variance", ProductDimension: "Product market", GeographicDimension: "Geographic market",
      revenueAed: "Revenue", sharePercent: "Share", Status: "Status", status: "Status", filingStatus: "Filing status", score: "Score",
      completedOn: "Completed on", expectedCloseOn: "Expected close", lastEditAt: "Last edited",
    },
    lineageHint: "Every insert, update and merge with its source, reference and case.",
    filterMarkets: "Filter markets by product, geography or sector…",
    marketCount: "{{count}} markets",
    market: "Market",
    size: "Market size",
    firms: "firms",
    curatedCount: "{{count}} curated",
    hhi: { high: "highly concentrated", moderate: "moderately concentrated", low: "unconcentrated" },
    coverage: "{{year}} shares cover {{percent}}% of the market",
    requestStudy: "Request market study",
    sharesLatest: "Market shares {{year}}",
    others: "Others",
    concentrationTrend: "Concentration over time",
    trendNeedsYears: "At least two years of shares are needed for a trend.",
    shareSeries: "Share series with provenance",
    shareSeriesHint: "Each figure keeps its source, reference and confidence. Confirm a figure to make it the curated value used for HHI and CR4.",
    definingCases: "Cases that defined this market",
    studies: "Market studies",
    definition: "Definition",
    sectorNotes: "Sector statistics",
    primary: "Surviving record",
    duplicate: "Duplicate",
    similarity: "Similarity",
    mergeProposalsHint: "The Data Bank Curator proposes merges for licence, transliteration and legal-form variants. Approving moves aliases, shares and case links to the surviving record.",
    runCurator: "Run Curator",
    curatorQueued: "The Data Bank Curator is scanning for duplicates and share discrepancies.",
    noMerges: "No merges awaiting review",
    noMergesHint: "Run the Curator or check the duplicate scan below.",
    approveMerge: "Approve merge",
    keepSeparate: "Keep separate",
    openInInbox: "Open proposal in AI Inbox",
    merged: "Merged into {{name}}",
    mergeRejected: "Marked as distinct undertakings",
    merge: "Merge",
    duplicateScan: "Duplicate scan",
    matchReason: {
      unlicensed: "The unlicensed record matches the registered name at {{score}}%.",
      names: "Names match at {{score}}%; same emirate: {{emirate}}.",
      sameEmirate: { yes: "yes", unknown: "unknown" },
    },
    duplicateScanHint: "Live similarity scan across names and aliases – candidates below the Curator's auto-proposal threshold are listed for manual judgement.",
    noDuplicates: "No further duplicate candidates.",
    sourcesTitle: "Data sources",
    sourcesHint: "Government registries and statistics feeding the bank, with their default confidence.",
    defaultConfidence: "confidence",
    syncNow: "Sync now",
    synced: "{{source}}: {{count}} records synchronised",
    sectorsHint: "ISIC Rev.4 codes with regulators and sensitivity flags; counts show entities · markets.",
    sensitive: "Sensitive",
    jurisdictionsHint: "Federal, emirate, free-zone and foreign jurisdictions relevant to multi-jurisdiction filings.",
    jurisdictionKinds: { Federal: "Federal", Emirate: "Emirates", FreeZone: "Free zones", Foreign: "Foreign & regional" },
    transactionsHint: "Concentrations and agreements recorded from notifications and exemption filings.",
    studioHint: "The Market Study Agent compiles structure, concentration trends, transactions and policy options from the Data Bank; the Economic Expert publishes from the AI Inbox.",
    newStudy: "New market study",
    newStudyHint: "Pick a market or sector and describe the scope. The agent drafts the study for review.",
    noStudies: "No market studies yet",
    noStudiesHint: "Request one for any market in the bank.",
    study: "Market study",
    studyStatus: { Draft: "Requested", Generating: "Generating", InReview: "Awaiting expert", Published: "Published" },
    analysis: {
      atAGlance: "Study at a glance",
      definition: "Market definition",
      product: "Product dimension",
      geographic: "Geographic dimension",
      rationale: "Substitution reasoning",
      adjacentMarkets: "Adjacent and aftermarket products",
      keyFindings: "Key findings",
      theoriesOfHarm: "Theories of harm",
      theory: "Theory",
      mechanism: "Mechanism",
      evidence: "Evidence in the Data Bank",
      likelihood: "Likelihood",
      likelihoodValue: { Low: "Low", Medium: "Medium", High: "High" },
      indicators: "Indicator assessment",
      indicator: "Indicator",
      latest: "Latest",
      trend: "Trend",
      benchmark: "Benchmark",
      assessment: "Assessment",
      assessmentValue: { Favourable: "Favourable", Neutral: "Neutral", Concern: "Concern" },
      recommendations: "Recommendations to the Ministry",
      action: "Action",
      owner: "Owner",
      timeline: "Timeline",
      legalBasis: "Legal basis",
      monitoringKpis: "Monitoring KPIs and triggers",
      charts: "Charts",
      fullReport: "Full report",
      sources: "Sources cited",
      leader: "Leading undertaking",
      priceGap: "Price index vs benchmark",
    },
    indicatorsTitle: "Market indicators",
    indicatorsHint: "Price indices, tender participation, import origins, installed base and aftermarket lock-in recorded with provenance; the Market Study Agent reads these series.",
    noIndicators: "No indicator series recorded for this market yet.",
    chartCount: "{{count}} charts",
    awaitingPublish: "Draft ready",
    publishFromInbox: "Review & publish in AI Inbox",
    regenerate: "Regenerate",
    regenerating: "The Market Study Agent is regenerating the study.",
    scope: "Scope",
    scopeHint: "Questions the study should answer – structure, conduct signals, implications for pending cases.",
    generatingHint: "The Market Study Agent is reading shares, transactions and sector statistics…",
    inReviewHint: "A draft with charts is waiting for the Economic Expert in the AI Inbox. Publishing stores the report and charts here.",
    titleAr: "Arabic title",
    anyMarket: "— select a market —",
    anySector: "— any sector —",
    studyDefaultTitle: "market study",
    studyDefaultScope: "Structure, concentration trend, recent transactions and conduct signals in {{market}}; implications for pending cases.",
    studyRequested: "Study requested – the agent is drafting it now.",
    intel: {
      graphTab: "Ecosystem graph",
      sentinelTab: "Sentinel",
      evidence: "Deterministic evidence pack",
      evidenceHint: "Computed by the rules engine when the study was drafted ({{at}}); every figure has its method.",
      reading: "Reading",
      downloadReport: "Illustrated report (PDF)",
      reportDownloaded: "The illustrated report has been downloaded.",
      hmt: "Hypothetical-monopolist test (SSNIP)",
      distinctMarket: "Relevant market on its own",
      widenMarket: "Widen the candidate market",
      undecidedMarket: "Not decided – needs measured diversion",
      breakEvenRecapture: "Break-even recapture",
      criticalLoss: "Critical loss",
      actualLoss: "Actual loss",
      margin: "Gross margin",
      elasticity: "Implied elasticity",
      pricingPressure: "Unilateral price pressure",
      guppiHint: "Incentive to raise price after the merger; 10% is the level at which international practice presumes significant effects.",
      cmcrHint: "Marginal-cost saving that would exactly offset the incentive to raise price.",
      uppHint: "GUPPI net of a {{credit}}% efficiency credit.",
      netUpp: "Net UPP",
      diversion: "Share-proportional diversion",
      simulation: "Calibrated merger simulation",
      preMerger: "Pre-merger",
      scenario: "Scenario",
      priceEffect: "Price effect",
      consumerSurplus: "Consumer surplus",
      annualEffect: "Annual price effect",
      priceChangeBy: "Predicted price change by undertaking",
      screens: "Tender, price and acquisition screens",
      composite: "composite",
      tenders: "tenders",
      bids: "bids",
      redFlags: "Red flags",
      noFlags: "None raised by the screens.",
      rotation: "Rotation",
      stability: "Bidder-set stability",
      avgBidders: "Average bidders",
      forensics: "Forensic overlaps",
      priceVsBenchmark: "Price against the benchmark",
      creeping: "Creeping acquisitions",
      priceDivergence: "{{points}} points above the benchmark",
      innocent: "Innocent explanations to exclude",
      graph: "Ownership, control and agency graph",
      findingKind: { CommonOwnership: "Common owner", InterlockingDirectorate: "Interlock", Exclusivity: "Exclusivity" },
      catchments: "Local catchments ({{km}} km radius)",
      centre: "Centre",
      facilities: "Facilities",
      ifLeadersCombine: "If the leaders combine",
      reconciliation: "Reconciled shares",
      disputed: "Disputed",
      agreed: "Agreed",
      straddles: "Straddles {{share}}",
      dominanceBasis: "The dominance mark of {{share}} applies {{basis}} – {{status}}.",
      sandbox: "Effect of remedies",
      sandboxHint: "What if the two undertakings combined, and what would a carve-out recover? A calibrated logit Bertrand–Nash simulation; every figure is computed, none is estimated by a model.",
      sandboxEmpty: "Choose an acquirer and a target and run the simulation.",
      acquirer: "Acquirer",
      target: "Target",
      divest: "Carve-out of the target divested",
      outsideShare: "Outside-good share",
      efficiencies: "Claimed efficiencies (marginal cost)",
      independentPurchaser: "Independent purchaser",
      simulate: "Simulate",
      combinedShare: "Combined share",
      withRemedy: "with remedy",
      merger: "Merger",
      note: "Note",
      sentinelHint: "Every market with public tenders, a price series or acquisitions to screen, scored live by the deterministic screens. The Cartel Screening Analyst writes the dossier; the Head of Complaints decides.",
      sentinelEmpty: "Nothing to screen yet",
      sentinelEmptyHint: "Record tenders, a price index or acquisitions against a market and the screens run automatically.",
      runAnalyst: "Run the Cartel Screening Analyst",
      screeningQueued: "The analyst is screening the market – the dossier will arrive in the AI Inbox.",
      openSignals: "{{count}} open signals", openSignals_one: "{{count}} open signal",
      noTenders: "No tenders recorded for this market.",
      tender: "Tender",
      buyer: "Buyer",
      winner: "Winner",
      coefficientOfVariation: "CV",
      coefficientOfVariationHint: "Coefficient of variation of the bids",
      coverRatio: "Cover ratio",
      flags: "Flags",
      score: "Score",
      signals: "signals",
      lastRuns: "Recent screening runs",
      graphHint: "Owners, directors, principals and registered agencies around the undertakings of a market. A common owner behind two competitors, a director on two boards or an exclusive agency covering the leaders is where market power hides from a share table.",
      graphEmpty: "No graph for this market",
      graphEmptyHint: "Record shares, ownership links or agencies for the market and the graph draws itself.",
      graphLegend: "Solid petrol: shareholding · dotted navy: directorship · dashed gold: registered exclusive agency · faint: share of the market",
      structuralFindings: "Structural findings",
      noFindings: "No common ownership, interlocks or exclusivity recorded.",
      agencies: "Registered commercial agencies",
      noAgencies: "No agencies recorded.",
      exclusive: "exclusive",
      nonExclusive: "non-exclusive",
      until: "until",
      analytics: "Analytical layer",
      overcharge: "What buyers paid above the benchmark path",
      cumulativeExcess: "Cumulative excess {{from}}–{{to}}",
      range: "Range (low – high)",
      latestPremium: "Latest premium",
      priceDecomposition: "Of +{{points}} price points",
      cost: "cost",
      marginShort: "margin",
      actualIndex: "Actual UAE price index",
      butFor: "But-for (benchmark path)",
      premium: "Premium",
      excess: "Excess expenditure",
      perMachine: "Per machine",
      structuralBreak: "Before and after {{date}}",
      metric: "Metric",
      before: "Before",
      after: "After",
      significant: "Significant",
      notSignificant: "Not significant",
      observedAlternation: "Observed alternation of winners",
      expectedAlternation: "Expected if awards were independent",
      binomialP: "Binomial p-value",
      allocation: "Who wins where — allocation index {{index}}%",
      byBuyer: "By buyer",
      byEmirate: "By emirate",
      topWinner: "Most frequent winner",
      trend: "Concentration by year and what moved it",
      fromAcquisitions: "From acquisitions",
      organic: "Organic shift",
      lifetimeCost: "What a machine award commits over {{years}} years",
      competedAtAward: "Competed at award",
      lockedAftermarket: "Locked aftermarket",
      openAftermarket: "Open aftermarket",
      machine: "Machine (award)",
      consumables: "Consumables",
      service: "Service",
      tco: "Lifetime cost",
      emirateStructure: "Structure by emirate (installed base)",
      emirateStructureHint: "Capacity shares of the supplier-installed base in each emirate from facility licensing returns.",
      machines: "Machines",
      scenarioMatrix: "Which combinations the Ministry could clear",
      scenarioMatrixHint: "Every pair among the four largest undertakings, simulated with the same calibration; verdicts read combined share against {{share}}, GUPPI against {{guppiWatch}} and {{guppiConcern}}, and the price effect against {{priceConcern}} and {{priceSerious}}.",
      combination: "Combination",
      verdict: "Verdict",
      commonOwnership: "Common ownership as a merger already made",
      remedySizing: "Remedy sizing",
      sensitivity: "Do the conclusions survive other assumptions?",
      sensitivityHint: "Each cell recomputes the instrument under a different margin, recapture or outside-good share. Green cells keep the conclusion; red cells lose it.",
      harmAssessment: "Assessment of the theories of harm",
      harmAssessmentHint: "Ranked by the strength of the evidence assembled so far — not by the seriousness of the conduct — each with what would rebut it and what to request under Article 18.",
      evidenceStrength: "Evidence",
      statistics: "Statistics",
      strongestEvidence: "Strongest evidence",
      rebuttals: "Rebuttals to test",
      informationToRequest: "Information to request",
      decisionRelevance: "What turns on it",
    },
    standardForm: {
      lead: "A lead for inquiry, not evidence.",
      column: "Standard form",
      prescribed: "Prescribed",
      notPrescribed: "Not prescribed",
      notRecorded: "Not recorded",
      record: "Record whether a standard form was prescribed",
      title: "Standard form for tender {{tender}}",
      hint: "Whether the procuring entity made a standard form mandatory for this tender's bids, as its tender documents show. Where it did, the document overlaps between bidders carry that template as their alternative explanation and are discounted in the composite.",
      question: "Did the procuring entity prescribe a standard form?",
      yes: "Yes, a standard form was prescribed",
      no: "No standard form was prescribed",
      unknown: "Not recorded",
      formName: "Name or reference of the form",
      note: "Note (optional)",
      save: "Record",
      saved: "Recorded. The screens now read the tender with it.",
      alternative: "Alternative explanation",
      discounted: "{{points}} of {{total}} points discounted",
    },
  },
  confirm: {
    finaliseReport: { title: "Finalise the review report?", body: "The report is filed on the case as the Department's record and the case moves on. A finalised report cannot be edited; a change needs a new draft.", action: "Finalise the report" },
    issueDecision: { title: "Sign and issue the decision?", body: "The decision is entered in the register under your name, the appeal period starts and the parties are notified if you chose so. A signed decision cannot be withdrawn.", action: "Sign and issue" },
    notifyParties: { title: "Notify the parties?", body: "The notice of investigation is sent to every party and the response period starts today.", action: "Notify the parties" },
    shareReport: { title: "Share the preliminary report?", body: "The parties receive the preliminary report and may respond within the statutory period.", action: "Share the report" },
    preNotification: { title: "Send the view and close the discussion?", body: "The applicant receives the Department's view and the pre-notification discussion is closed.", action: "Send and close" },
    publish: { title: "Publish the notice?", body: "The notice appears on the Ministry's website in Arabic and English and the comment period starts.", action: "Publish" },
    enforcementIssue: { title: "Issue the enforcement decision?", body: "The decision is entered in the register and the parties are notified if you chose so. An issued decision cannot be withdrawn.", action: "Issue the decision" },
    sendLetter: { title: "Send the letter?", body: "The letter is sent to the recipient and filed on the case.", action: "Send" },
    finalNotice: { title: "Send the Article 23(3) notice?", body: "The party is given {{period.complaint.finalNotice}} more working days, warned of Article 27 of the Decree-Law and told that the Department may proceed on the evidence on the file. The notice is sent in your name.", action: "Approve and send" },
    mergeRecords: { title: "Merge the two records?", body: "The duplicate's names, market shares, transactions and case links move to the primary record, and the duplicate is marked as merged and no longer listed. The records cannot be separated again.", action: "Merge the records" },
  },
  search: {
    open: "Search",
    kinds: { case: "Files", party: "Parties and companies in files", decision: "Decision numbers", payment: "Payment receipts", company: "Companies in the data bank", policy: "Policies and legislation" },
    sections: { concentration: "Economic concentration", investigations: "Investigations and complaints", policies: "Policies", requests: "Other requests", databank: "Data bank" },
  },
  r3Process: {
    blockers: {
      BindingFindings_one: "A finding of the platform rules out every way out of this stage: {{detail}}",
      BindingFindings_other: "Findings of the platform rule out every way out of this stage: {{detail}}",
    },
    finding: {
      title: "Finding of the platform",
      open: "Review",
      reason: "Reasons",
      reasonHint: "Recorded in the file's history and the decision memo.",
      record: "Record the override",
      recordAndApprove: "Override and approve",
      recorded: "Override recorded",
      authorisedOnly: "Only an authorised officer can override a finding of the platform.",
      notOverridable: "A requirement of the procedure; it cannot be overridden.",
    },
    left: {
      needed_one: "{{count}} needed",
      needed_other: "{{count}} needed",
      confirm: "Confirm",
      // Condition 3.2 / Regulations Article 22(1): the complainant's request to withdraw is granted or refused by the Department.
      refuse: "Refuse",
      refuseTitle: "Refuse the request to withdraw",
      refuseReasons: "Reasons for the refusal",
      refuseHint: "The complainant is told these reasons in a portal notice and the file's history; the refusal sends no letter. The complaint continues where it stands.",
      refused: "Request refused – the complaint continues",
    },
    primary: {
      finding: "Review the finding: {{title}}",
      confirm: "{{title}}",
      confirmed: "Step confirmed",
    },
    conclude: { ruledOut: "Ruled out until answered or overridden: {{findings}}" },
    criterion: {
      showPlatform: "Show the platform's assessment",
      hidePlatform: "Hide",
      agree: "Agree with the platform",
      agreeNeeds: "Add your reasons or a piece of evidence to agree.",
      agreed: "Agreed with the platform, with your reasons",
      key: "Key",
    },
    history: {
      ended: "{{route}} · {{name}} · {{date}}",
      route: { Review: "Signed off in the review", Step: "Ended by an officer's step", Party: "Ended by the applicant", Automatic: "Ended by the platform" },
      by: { Automatic: "no officer", Party: "the applicant" },
    },
    clock: {
      recalculate: "Recalculate the period from the file's record",
      confirmInterruption: "Confirm the interruption",
      // Condition 3.2: the parties' answer does not restart the period by itself; the officer confirms, with effect from its receipt.
      confirmResumption: "Confirm the resumption",
      resumptionAwaits: "The material that ends the interruption has arrived – the resumption awaits your confirmation",
      resumptionFrom: "Received on {{date}}. Once confirmed, the period runs again from that moment, not from the confirmation.",
    },
    lists: { unattended: "No officer on a running period" },
    signals: {
      open: "Open a file",
      title: "Decision to open a file",
      reasons: "Reasons for opening the file",
      reasonsHint: "The signal is a lead; the file is opened on an authorised officer's decision.",
      decide: "Open the file",
    },
    inbox: {
      count_one: "One AI draft",
      count_other: "{{count}} AI drafts",
      quick: "Quick approvals",
      quickCount_one: "One quick approval",
      quickCount_other: "{{count}} quick approvals",
      quickHint_one: "Approvals made less than one second after the approver opened the draft (the minimum review period set by the Department), or without opening it.",
      quickHint_other: "Approvals made less than {{count}} seconds after the approver opened the draft (the minimum review period set by the Department), or without opening it.",
      quickNone: "No quick approvals.",
      reviewTime_one: "Approved one second after opening",
      reviewTime_other: "Approved {{count}} seconds after opening",
      notOpened: "Approved without opening the draft",
      withoutFile: "No file",
    },
    peerAgainstFindings: "This review supports the report while findings stand",
    peerAgainstFindingsBody: "The file still holds: {{findings}}. It cannot move past them without an authorised officer's recorded reasons.",
  },
  demo: {
    title: "Test clock",
    hint: "On the test platform only: move the clock forward so periods expire and reminders are sent.",
    platformTime: "Platform time",
    realTime: "real time",
    offset_one: "+{{count}} day",
    offset_other: "+{{count}} days",
    advanceBy_one: "+{{count}} day",
    advanceBy_other: "+{{count}} days",
    advanced_one: "Clock moved forward by {{count}} day",
    advanced_other: "Clock moved forward by {{count}} days",
    sweepResult: "{{atRisk}} clocks at risk · {{breached}} breached · {{fired}} expiry transitions fired",
    reset: "Platform clock reset to real time",
    resetClock: "Reset",
    runSweep: "Run SLA sweep",
    sweepDone: "SLA sweep completed",
    replay: "Replay",
    replayTitle: "Replay – {{caseNumber}}",
    replayHint: "Every transition, letter, agent proposal and decision in the order it happened; the diagram follows the case state.",
    play: "Play",
    pause: "Pause",
  },
  r3Library: {
    signatory: "Signed by the {{capacity}} under {{authority}}",
    verificationRequired: "verification required by the Department",
    status: { Confirmed: "Confirmed by the Department", Awaiting: "Awaiting the Department's confirmation", Excluded: "Excluded" },
    confirmed: "Confirmed. Agents may now cite this document.",
    added: "Document added. It awaits the Department's confirmation.",
    notRecorded: "Not recorded",
    downloadList: "Download the list",
    addDocument: "Add a document",
    add: "Add",
    addHint: "The document waits for confirmation by a legal expert or the Director before any agent cites it.",
    stats: { documents: "Documents in the library", awaiting: "Awaiting the Department's confirmation", escalated: "Enquiries escalated to a researcher", faqs: "Answers published as FAQs" },
    tabs: { library: "Library" },
    filter: "Title, key or issuer",
    libraryHint: "Documents attributed to the Ministry, and documents added by hand, are not cited by agents until the Department confirms them.",
    effective: "Effective from",
    withdrawn: "Withdrawn from agents",
    precedentSearch: "Precedent search",
    precedentKinds: { Precedent: "Precedent", ComparativeReference: "Comparative reference", OfficialAnswer: "Official answer" },
    jurisdiction: "Country of the authority",
    comparativeHint: "A decision of a foreign authority is listed, shelved and cited as a comparative reference, never as a precedent of the Ministry.",
    initialView: {
      title: "Your initial view",
      hint: "Record the relevant market and the theory of harm (or the competition concern) as you see them now. Precedents are suggested, to you and to the agents, only once both are recorded.",
      product: "Relevant product or service market",
      geography: "Geographic market",
      theory: "Theory of harm or competition concern",
      by: "Recorded",
      record: "Record the initial view",
      change: "Record a new view",
      incomplete: "The view is not complete: state both the market and the theory of harm.",
      recordedToast: "Initial view recorded",
    },
    studyConsistency: {
      title: "Consistency with the Department's earlier market definitions",
      none: "The study's market definition does not narrow, widen or depart from an earlier definition of the Department for the same activity.",
    },
    citedByAgents: "Cited by agents",
    source: "Source",
    supplier: "Supplied by",
    confirmedBy: "Confirmed by",
    issuedOn: "Issued on",
    text: "Text",
    ministryAwaiting: "Attributed to the Ministry: agents do not cite it until the Department confirms its text and status.",
    confirm: "Confirm text and status",
    withdraw: "Withdraw from agents",
    restore: "Return to agents",
    precedents: {
      awaitingView: "Precedents are suggested once the market definition and the theory of harm are recorded in the review. The search above is available at any time.",
      noneFound: "No precedent matches this search.",
      noneClose: "No precedent in the library is close to this file by market and activity.",
      definitionDiffers: "The market definition differs from the Department's definition in decision {{reference}} ({{year}}) for the same activity.",
      ground: "Distinguishing ground",
      recordGround: "Record the distinguishing ground",
      groundRecorded: "Ground recorded",
      save: "Record",
      clear: "Clear search",
      open: "Open",
      differs: "Where it differs",
      matches: "Where it matches",
      levels: { Close: "Close", PartlyComparable: "Partly comparable", Distant: "Distant" },
      dimensions: { activity: "Activity", product: "Product", geography: "Geographic market", overlap: "Overlap", transaction: "Transaction", provisions: "Articles relied on" },
      awaitingRecordedView: "Precedents are suggested once you record your initial view: the relevant market and the theory of harm. The search above is available at any time.",
      enquiryHint: "Earlier official answers and the library's precedents are compared with this enquiry by the articles each relies on; other files' names and figures are withheld.",
      awaitingEnquiryView: "Interim rule, until the Department sets which recorded view releases them: earlier official answers and precedents are suggested – to you and to the agent drafting the answer – once the finding «Governing provisions identified» is recorded in the review. The search above is available at any time.",
      noneEnquiry: "No earlier official answer or precedent shares an article or the question's words with this enquiry.",
    },
    consistencyAlert: {
      relation: {
        Narrower: "The market definition is narrower than the Department's definition in {{reference}} ({{year}}) for the same activity.",
        Wider: "The market definition is wider than the Department's definition in {{reference}} ({{year}}) for the same activity.",
        Different: "The market definition departs from the Department's definition in {{reference}} ({{year}}) for the same activity.",
      },
      source: { Decision: "Decision issued on the platform", Library: "Decision of the Department held in the library", DataBank: "Market of the Data Bank's register, with the file it was defined in" },
      basis: { OfficerDefinition: "Your recorded market definition", Declared: "The markets as declared (no market definition is recorded by an officer yet)", MarketStudy: "The study's market definition" },
      thisFile: "This file",
      earlier: "Earlier definition",
      product: "Product market",
      geography: "Geographic market",
      dimension: { Same: "same", Narrower: "narrower", Wider: "wider", Different: "different" },
      ask: "Record the distinguishing ground. The alert stays open until you do; it never blocks a step.",
    },
    ops: {
      noFiles: "No file is behind this figure.",
      days_one: "{{value}} day",
      days_other: "{{value}} days",
      onTime: "on time",
      late: "late",
      draftsLine: "{{unchanged}} unchanged, {{amended}} amended, {{rejected}} rejected",
      times_one: "counted once",
      times_other: "counted {{count}} times",
      figures: { openCases: "Open files", ecFormalReviewDays: "Initial review of concentrations", ecDecisionDays: "Concentration decisions", complaintResolutionDays: "Complaints closed", slaCompliance: "Statutory periods met", aiAcceptance: "AI drafts accepted" },
      method: {
        ecFormalReviewDays: "Average calendar days from submission to formal acceptance, over every concentration file accepted since records began. Test files are not counted.",
        ecDecisionDays: "Average calendar days from submission to the decision, over every concentration file decided since records began.",
        complaintResolutionDays: "Average calendar days from submission to closure, over every complaint closed since records began.",
        slaCompliance: "Share of the Ministry's completed statutory periods that ended on or before their due date. Periods that run for the parties are not counted.",
        aiAcceptance: "Drafts approved unchanged or amended, divided by the drafts an officer has decided (approved unchanged, amended or rejected). Drafts awaiting a decision are not counted. The table below gives the same counts by agent.",
      },
      counts: {
        openCases: "Open now",
        ecFormalReviewDays: "Average, files accepted since records began",
        ecDecisionDays: "Average, files decided since records began",
        complaintResolutionDays: "Average, complaints closed since records began",
        slaCompliance: "Share of completed periods since records began",
        aiAcceptance: "Share of decided drafts since records began",
      },
      files_one: "1 file",
      files_other: "{{count}} files",
      excluded_one: "One test file is left out of these figures.",
      excluded_other: "{{count}} test files are left out of these figures.",
      drafts: "AI drafts by agent",
      bySection: "AI drafts by section",
      bySectionHint: "The same counts and the same method for each section of the Department alone: the drafts on its files, or for the Data Bank, Deal Watch and Advocacy their agents' drafts. Hover a row for the agents behind it.",
      section: "Section",
      accepted: "Accepted",
      unchanged: "Approved unchanged",
      amended: "Amended",
      rejected: "Rejected",
      pending: "Awaiting decision",
      total: "All agents",
      decisions: "Decisions issued, by outcome",
      clocksHint: "Statutory periods of live files by kind and state: running periods as they stand now, completed ones since records began.",
      filesOf: "Files behind {{value}}",
      showFiles: "Files",
    },
    opsBasis: {
      decision: "Decision {{number}} of {{date}}",
      due: "due {{date}}",
      outcomeFiles: "Decisions: {{outcome}}",
      typeFiles: "Open files: {{type}}",
      cellFiles: "{{clock}} – {{health}}",
      clickHint: "Select a cell, an outcome or a type of file to list the files behind it.",
      // Scenario 6.46: each count of the AI drafts table lists the drafts it counts, each with its file.
      draftsHint: "Select a count to list the drafts behind it, each with its file.",
      draftsFiles: "{{agent}} – {{outcome}}",
      draftDecided: "{{outcome}} on {{date}}",
      draftPending: "Awaiting a decision since {{date}}",
      draftNoFile: "Draft with no file",
      openDraft: "Open the draft",
    },
    advocacy: {
      newInstrument: "New instrument",
      suspended: "The method for this section awaits the Department's approval. Instruments are recorded; nothing is screened or assessed until then.",
      suspendedDraft: "The method for this section awaits the Department's approval. The screen and draft on this record predate the suspension and are not applied.",
      caseData: "This opinion names a case file or a party to one, so it is held back: no case or party data may appear in an advocacy opinion.",
      stats: { recorded: "Instruments recorded", inReview: "Drafts awaiting adoption", adopted: "Opinions adopted", sent: "Sent to issuing authorities", highOrSevere: "High or severe" },
      methodTab: "Method",
      proposed: "Proposed method, awaiting the Department's approval. It is not applied.",
      proposedTitle: "Proposed method",
      recorded: "Instrument recorded.",
      approval: {
        title: "The Department's approval of the method",
        approved: "Approved",
        awaiting: "Awaiting the Department's approval",
        notApproved: "The method awaits the Department's approval: until it is recorded, instruments are recorded but not screened, and no agent drafts an assessment.",
        recordHint: "Record the approval only once the Department has given it in writing. It is audited in your name.",
        reference: "Reference of the written approval",
        referenceHint: "The Department's letter or memorandum and its number.",
        referenceAr: "Reference in Arabic (optional)",
        approvedOn: "Date of the written approval",
        recordedBy: "Recorded by",
        note: "Note (optional)",
        record: "Record the Department's approval",
        recorded: "The Department's approval of the method is recorded",
        whoRecords: "The Department's approval is recorded by: {{roles}}. An administrator does not record it.",
      },
    },
    advocacyGuard: {
      held: "This opinion carries data from the Department's files – a case number, a party's name or a figure declared in a file – so it is held back: it can be neither adopted nor exported until that data is removed. No case or party data may appear in an advocacy opinion.",
      found: "Found",
    },
  },
  account: {
    menu: "Account",
  keys: {
    title: "Keyboard shortcuts",
    search: "Search files, companies and reference numbers",
    rows: "Move between rows of a list",
    open: "Open the selected row",
    close: "Close a panel or dialog",
  },
},
} as const;
